
function initBoldMetricsApp() {
    var remoteAppUrl = "https://sartoro.arenacommerce.com/storefront";
    var ID_DT3o_APP = 'boldmetrics-app'
    var SELECTOR_MODAL_DT3o = '.digital-tailor-tool-modal'
    var app = new Vue({
        el: `#${ID_DT3o_APP}`,
        data: {
            idAppContainer: `${ID_DT3o_APP}`,
            SARTORO_APP_CONFIG: SARTORO_APP_CONFIG || {},
            typeApp: "", // dt (digital tailor), sm (self measure), sm-reconfirm (reconfirm), mg (measure garment)
            typeAction: "", // current action of Fit Profile create_fit_profile, continue_fit_profile, edit_fit_profile, delete_fit_profile
            isShowOnlyOnePage: false,
            modalSelector: SELECTOR_MODAL_DT3o,
            Vue_App_State: DT3oState ? DT3oState : {},
            activeChildContentIndex: 0, // index of active child content will show in step template, template has many child content
            // final selected value steps
            finalValues: Object.assign({}, DT3oConstant.DEFAULT_VALUES_FINAL_VALUES),
            finalValuesWithIssue: [], // final values has issue with analyzed data
            // last selected customer choices, value in us (default) or metric or both
            lastChoices: {
                height: { us: "", metric: "", eu: "", uk: "", aus: "" },
                weight: { us: "", metric: "", eu: "", uk: "", aus: "" },
                age: { us: "", metric: "", eu: "", uk: "", aus: "" },
                waist_size: { us: "", metric: "", eu: "", uk: "", aus: "" },
                shoe_size: { us: "", metric: "", eu: "", uk: "", aus: "" },
                jacket_size: { us: "", metric: "", eu: "", uk: "", aus: "" },
                sleeve_length: { us: "", metric: "", eu: "", uk: "", aus: "" },
                neck_size: { us: "", metric: "", eu: "", uk: "", aus: "" },
                pants_inseam: { us: "", metric: "", eu: "", uk: "", aus: "" },
                ...DT3oConstant.ASSETS.mgLastChoicesObj,
            },
            // analyszed data get from server, object default is null
            analyzedData: null,
            // template of a fit profile, contain new profile or editing profile
            fitProfileTemplate: {
                id: null, // timestamp of created date
                name: "", // default is 'Month Day, YYYY' from created date
                created_date: "", // created date (ISOString)
                dt_sm_input: {}, // all basic inputs, posture inputs, self measure inputs
                garment_inputs: {}, // garment inputs, properties of garment
                orders_garment_inputs: [], // order garment inputs
                api_boldmetrics_inputs: {}, // input usef for calculating values of returned API Bold Metrics (bm_dimensions)
                update_to_fit: {}, // garment inputs to next order
                info: {
                    gender: DT3oConstant.DEFAULT_GENDER, // male / female / nonebinary
                    bm_dimensions: {}, // returned from Boldmetric API
                    purchasedCustomBefore: "",
                },
                images: [], // uploaded images
                customer_note: "", // note of customer
                enable: true, // not show if
                from: "dt", // dt (digital tailor), sm (self measure), sm-reconfirm (reconfirm), mg (measure garment)
                type: "partial", // partial: default for new, local_complete: complete but local, complete: complete and saved to metafield
            },
            // current fit profile
            fitProfileDetails: {},
            fitProfileHasImage: false,
            progressSteps_DT: 14, // number of items (steps) in progress DT
            progressSteps_SM: 14, // number of items (steps) in progress SM
            progressSteps_MG: 14, // number of items (steps) in progress MG
            progressSteps: this.progressSteps_DT, // total steps which have progress bar
            progressPhotoSteps: [],
            bigPages: {},
            bigPages_DigitalTailor: {
                intro: { steps: [], progressStep: 0 },
                body_size_detail: {
                    steps: ["height", "weight", "age", "shoe_size"],
                    progressStep: 1,
                },
                pants_size: { steps: ["waist_size", "pants_inseam"], progressStep: 2 },
                jacket_size: { steps: ["jacket_size"], progressStep: 3 },
                shirt_size: { steps: ["neck_size", "sleeve_length"], progressStep: 4 },
                posture_torso: { steps: ["body_posture_torso"], progressStep: 5 },
                posture_arm_length: {
                    steps: ["body_posture_arm_length"],
                    progressStep: 6,
                },
                posture_shoulder_width: {
                    steps: ["body_posture_shoulder_width"],
                    progressStep: 7,
                },
                posture_shoulder_slope: {
                    steps: ["body_posture_shoulder_slope"],
                    progressStep: 8,
                },
                posture_stance: { steps: ["body_posture_stance"], progressStep: 9 },
                posture_seat: { steps: ["body_posture_seat"], progressStep: 10 },
                posture_rise: { steps: ["body_posture_rise"], progressStep: 11 },
                posture_fit_preference: {
                    steps: ["body_posture_fit_preference"],
                    progressStep: 12,
                },
                customer_input_review: { steps: [], progressStep: 14 },
                waiting_result: { steps: [], progressStep: 0 },
                profile_issue_found: { steps: [], progressStep: 0 },
                analyze_input_review: { steps: [], progressStep: 0 },
                profile_creation: { steps: [], progressStep: 0 },
                create_account: { steps: [], progressStep: 0 },
                posture_jacket_length_preferred: {
                    steps: ["body_posture_jacket_length_preferred"],
                    progressStep: 13,
                },
                edit_one_input: { steps: [], progressStep: 0 }, // use for edit one self input on fit profile
            },
            bigPages_SelfMeasure: {
                body_size_detail: {
                    steps: ["height", "weight", "age", "shoe_size"],
                    progressStep: 1,
                },
                pants_size: { steps: ["waist_size", "pants_inseam"], progressStep: 2 },
                jacket_size: { steps: ["jacket_size"], progressStep: 3 },
                shirt_size: { steps: ["neck_size", "sleeve_length"], progressStep: 4 },
                posture_torso: { steps: ["body_posture_torso"], progressStep: 5 },
                posture_arm_length: {
                    steps: ["body_posture_arm_length"],
                    progressStep: 6,
                },
                posture_shoulder_width: {
                    steps: ["body_posture_shoulder_width"],
                    progressStep: 7,
                },
                posture_shoulder_slope: {
                    steps: ["body_posture_shoulder_slope"],
                    progressStep: 8,
                },
                posture_stance: { steps: ["body_posture_stance"], progressStep: 9 },
                posture_seat: { steps: ["body_posture_seat"], progressStep: 10 },
                posture_rise: { steps: ["body_posture_rise"], progressStep: 11 },
                posture_fit_preference: {
                    steps: ["body_posture_fit_preference"],
                    progressStep: 12,
                },
                customer_input_review: { steps: [], progressStep: 14 },
                waiting_result: { steps: [], progressStep: 0 },
                sm_mg_transition: { steps: [], progressStep: 0 },
                sm_intro: { steps: [], progressStep: 0 },
                sm_at_home_intro: { steps: [], progressStep: 0 },
                sm_at_home_input: { steps: [], progressStep: 1 },
                sm_profile_review: { steps: [], progressStep: 0 },
                profile_creation: { steps: [], progressStep: 0 },
                create_account: { steps: [], progressStep: 0 },
                result_edit: { steps: [], progressStep: 0 },
                edit_one_input: { steps: [], progressStep: 0 }, // use for edit one self input on fit profile
                profile_issue_found: { steps: [], progressStep: 0 },
                analyze_input_review: { steps: [], progressStep: 1 },
                posture_jacket_length_preferred: {
                    steps: ["body_posture_jacket_length_preferred"],
                    progressStep: 13,
                },
            },
            bigPages_MeasureGarment: {
                body_size_detail: {
                    steps: ["height", "weight", "age", "shoe_size"],
                    progressStep: 1,
                },
                pants_size: { steps: ["waist_size", "pants_inseam"], progressStep: 2 },
                jacket_size: { steps: ["jacket_size"], progressStep: 3 },
                shirt_size: { steps: ["neck_size", "sleeve_length"], progressStep: 4 },
                posture_torso: { steps: ["body_posture_torso"], progressStep: 5 },
                posture_arm_length: {
                    steps: ["body_posture_arm_length"],
                    progressStep: 6,
                },
                posture_shoulder_width: {
                    steps: ["body_posture_shoulder_width"],
                    progressStep: 7,
                },
                posture_shoulder_slope: {
                    steps: ["body_posture_shoulder_slope"],
                    progressStep: 8,
                },
                posture_stance: { steps: ["body_posture_stance"], progressStep: 9 },
                posture_seat: { steps: ["body_posture_seat"], progressStep: 10 },
                posture_rise: { steps: ["body_posture_rise"], progressStep: 11 },
                posture_fit_preference: {
                    steps: ["body_posture_fit_preference"],
                    progressStep: 12,
                },
                customer_input_review: { steps: [""], progressStep: 14 },
                waiting_result: { steps: [], progressStep: 0 },
                sm_mg_transition: { steps: [], progressStep: 0 },
                mg_intro: { steps: [], progressStep: 0 },
                mg_instruction: { steps: [], progressStep: 0 },
                mg_input: { steps: [], progressStep: 0 },
                mg_profile_review: { steps: [], progressStep: 0 },
                mg_intro_submitted: { steps: [], progressStep: 0 },
                profile_creation: { steps: [], progressStep: 0 },
                create_account: { steps: [], progressStep: 0 },
                profile_issue_found: { steps: [], progressStep: 0 },
                analyze_input_review: { steps: [], progressStep: 1 },
                posture_jacket_length_preferred: {
                    steps: ["body_posture_jacket_length_preferred"],
                    progressStep: 13,
                },
            },
            bigPages_Reconfirm: {
                intro_reconfirm: { steps: [], progressStep: 0 },
                body_size_detail: {
                    steps: ["height", "weight", "age", "shoe_size"],
                    progressStep: 1,
                },
                pants_size: { steps: ["waist_size", "pants_inseam"], progressStep: 2 },
                jacket_size: { steps: ["jacket_size"], progressStep: 3 },
                shirt_size: { steps: ["neck_size", "sleeve_length"], progressStep: 4 },
                //
                waiting_result: { steps: [], progressStep: 0 },
                // profile_issue_found: { steps: [], progressStep: 0 },
                analyze_input_review: { steps: [], progressStep: 0 },
                posture_jacket_length_preferred: {
                    steps: ["body_posture_jacket_length_preferred"],
                    progressStep: 0,
                },
                // SM
                rc_sm_intro: { steps: [], progressStep: 0 },
                sm_at_home_intro: { steps: [], progressStep: 0 },
                sm_at_home_input: { steps: [], progressStep: 1 },
                sm_profile_review: { steps: [], progressStep: 0 },
                // MG
                mg_intro: { steps: [], progressStep: 0 },
                mg_input: { steps: [], progressStep: 0 },
                mg_profile_review: { steps: [], progressStep: 0 },
                //
                profile_creation: { steps: [], progressStep: 0 },
                // rc_photo_opt_out: { steps: [], progressStep: 0 },
                rc_final_notes: { steps: [], progressStep: 0 },
            },
            currentInputSM: null, // current input of self measure
            currentInputMG: null, // current input of measure a garment
            beforeStepBasicOfSM: "",
            currentInputBeforeStepBasicOfSM: "",
            previousBigPages: "",
            showEditOneInputModal: false,
            currentBigPages: "intro",
            mainPhotoSteps: ["front", "side", "rear"],
            currentPhotoStep: "front", // front, rear, side
            photo_can_skip: false,
            photo_cropper: null,
            ratioZoomPhotoCropper: 1, // from 0 to 2, so default 1
            keysOfBigPages: [], // contain keys of all big pages
            basicInputsWithIssue: [], // basic inputs has issue with analyzed data
            currentBasicInputHasIssue: null, // current basic input has issue
            stepsIsProfileInput: [
                "body_size_detail",
                "pants_size",
                "jacket_size",
                "shirt_size",
                "posture_torso",
                "posture_arm_length",
                "posture_shoulder_width",
                "posture_shoulder_slope",
                "posture_stance",
                "posture_seat",
                "posture_rise",
                "posture_fit_preference",
                "sm_intro",
                "sm_at_home_input",
                "mg_intro",
                "mg_input",
            ], // steps are fit profile inputs, ex height, age, self measure, garment inputs, note...
            stepsHasIntroLayout: [
                "intro",
                "intro_reconfirm",
                "rc_final_notes",
                "rc_photo_opt_out",
                "rc_issues_found",
                "profile_creation",
                "sm_intro",
                "mg_intro",
                "create_account",
                "mg_intro_submitted",
            ], // steps has same layout like intro
            stepsHideBackAtMenu: [
                "intro",
                "intro_reconfirm",
                "rc_final_notes",
                "rc_photo_opt_out",
                "rc_issues_found",
                "profile_creation",
                "photo_intro_new",
                "intro_overview",
                "sm_intro",
                "mg_intro",
                "create_account",
                "mg_intro_submitted",
            ],
            stepsHideSartoroAtMenu: [
                "intro",
                "intro_reconfirm",
                "rc_final_notes",
                "rc_photo_opt_out",
                "rc_issues_found",
                "profile_creation",
                "photo_intro_new",
                "save_options",
                "intro_overview",
                "sm_intro",
                "mg_intro",
                "create_account",
                "mg_intro_submitted",
            ],
            stepsHideCloseWithoutKeepWidthAtMenu: [
                "fit_profile_details",
                "body_size_detail",
                "rc_all_required_inputs",
                "rc_review_input",
                "pants_size",
                "jacket_size",
                "shirt_size",
                "sm_at_home_input",
                "mg_input",
                "mg_profile_review",
                "customer_input_review",
            ],
            stepsHideCloseButKeepWidthAtMenu: [
                "save_options",
                "intro_overview",
                "sm_mg_transition",
                "profile_issue_found",
                "waiting_result",
                "analyze_input_review",
                "sm_at_home_intro",
                "mg_instruction",
                "posture_jacket_length_preferred",
            ],
            stepsShowUnitConverterAtMenu: [
                "fit_profile_details",
                "body_size_detail",
                "rc_all_required_inputs",
                "rc_review_input",
                "pants_size",
                "jacket_size",
                "shirt_size",
                "sm_at_home_input",
                "customer_input_review",
                "mg_input",
                "mg_profile_review",
            ],
            stepsCanSkip: ["shirt_size"],
            stepsHideBottomSection: [
                "intro",
                "intro_reconfirm",
                "rc_final_notes",
                "rc_photo_opt_out",
                "rc_issues_found",
                "intro_sm",
                "save_options",
                "photo_intro",
                "waiting_result",
                "rc_analyzing_inputs",
                "measurements_intro",
                "sm_at_home_intro",
                "response_submitted",
                "fit_guarantee",
                "intro_overview",
                "fit_profile_details",
                "profile_creation",
                "sm_intro",
                "mg_instruction",
                "sm_profile_review",
                "mg_intro",
                "create_account",
                "sm_at_home_input",
                "mg_profile_review",
                "mg_input",
                "sm_mg_transition",
            ],
            // only hide on mobile
            stepsHideBottomSectionOnlyMobile: ["customer_input_review"],
            // steps hide progress bar on desktop
            stepsHideProgressBarOnDesktop: ["sm_at_home_input"],
            stepsHideNextBtnBodyProportions: [
                "posture_torso",
                "posture_stance",
                "posture_seat",
                "posture_rise",
                "posture_shoulder_width",
                "posture_arm_length",
                "posture_shoulder_slope",
                "posture_fit_preference",
            ],
            stepsShowNextButtonIsSubmit: ["save_result", "photo_upload"],
            stepsShowNextButtonWithDifferentColor: [
                "customer_note",
                "measurements_at_home_confirm",
            ],
            stepsShowNextButtonWithGreenColor: ["customer_input_review"],
            stepsShowNextButtonWithBlackColor: ["profile_issue_found"],
            stepsNotSetActiveStep: [
                "intro",
                "intro_reconfirm",
                "rc_final_notes",
                "rc_photo_opt_out",
                "intro-sm",
                "sm_at_home_input",
            ],
            stepsHideTopNav: [
                "intro",
                "intro_reconfirm",
                "rc_final_notes",
                "rc_photo_opt_out",
                "rc_issues_found",
                "profile_creation",
                "sm_intro",
                "mg_intro",
                "create_account",
                "mg_intro_submitted",
                "sm_mg_transition",
                "sm_profile_review",
            ],
            stepsHideTopTitle: [
                "intro",
                "intro_reconfirm",
                "rc_final_notes",
                "rc_photo_opt_out",
                "rc_issues_found",
                "waiting_result",
                "rc_analyzing_inputs",
                "fit_profile_details",
                "profile_creation",
                "profile_issue_found",
                "sm_at_home_intro",
                "sm_intro",
                "mg_intro",
                "mg_instruction",
                "mg_intro_submitted",
                "create_account",
                "sm_at_home_input",
                "mg_profile_review",
                "mg_input",
            ],
            posture_shoulder_slope_error: { isValid: true },
            pants_preference_error: { isValid: true },
            fit_preference_error: { isValid: true },
            stepBodyProportions: [
                "body_posture_shoulder_slope",
                "body_posture_chest_p",
                "body_posture_stomach",
                "body_posture_stance",
                "body_posture_seat",
                "body_posture_rise",
                "body_posture_pants_break",
                "body_posture_arm_length",
            ],
            stepSelfMeasurements: [
                { key: "neck", title: "Neck", step: 0.1 },
                { key: "chest", title: "Chest", step: 0.1 },
                { key: "upper_waist", title: "Upper Waist", step: 0.1 },
                { key: "belly", title: "Midsection", step: 0.1 }, // midsection
                { key: "bicep", title: "Bicep", step: 0.1 },
                { key: "shoulder", title: "Shoulder", step: 0.1 },
                { key: "arm_length", title: "Arm Length", step: 0.1 },
                { key: "jacket_length", title: "Jacket Length", step: 0.1 },
                { key: "beltline", title: "Beltline", step: 0.1 },
                { key: "hips", title: "Hips", step: 0.1 },
                { key: "crotch", title: "Crotch", step: 0.1 },
                { key: "thigh", title: "Thigh", step: 0.1 },
                { key: "calf", title: "Calf", step: 0.1 },
                { key: "pants_outseam", title: "Outseam", step: 0.1 },
            ],
            stepResultPart_1: [
                {
                    key: "boldmetrics_api_chest",
                    title: "CHEST",
                    keyValueShow: "boldmetrics_api_chest",
                },
                {
                    key: "boldmetrics_api_neck",
                    title: "NECK",
                    keyValueShow: "boldmetrics_api_neck",
                },
                {
                    key: "boldmetrics_api_shoulder",
                    title: "SHOULDER",
                    keyValueShow: "boldmetrics_api_shoulder",
                },
                {
                    key: "boldmetrics_api_bicep",
                    title: "BICEP",
                    keyValueShow: "boldmetrics_api_bicep",
                },
                {
                    key: "boldmetrics_api_arm_length",
                    title: "ARM",
                    keyValueShow: "boldmetrics_api_arm_length",
                },
                {
                    key: "boldmetrics_api_belly",
                    title: "BELLY",
                    keyValueShow: "boldmetrics_api_belly",
                },
                {
                    key: "boldmetrics_api_beltline",
                    title: "BELTLINE",
                    keyValueShow: "boldmetrics_api_beltline",
                },
                {
                    key: "boldmetrics_api_hips",
                    title: "SEAT",
                    keyValueShow: "boldmetrics_api_hips",
                },
                {
                    key: "boldmetrics_api_crotch",
                    title: "CROTCH",
                    keyValueShow: "boldmetrics_api_crotch",
                },
                {
                    key: "boldmetrics_api_thigh",
                    title: "THIGH",
                    keyValueShow: "boldmetrics_api_thigh",
                },
                {
                    key: "boldmetrics_api_calf",
                    title: "CALF",
                    keyValueShow: "boldmetrics_api_calf",
                },
                {
                    key: "boldmetrics_api_pants_outseam",
                    title: "OUTSEAM",
                    keyValueShow: "boldmetrics_api_pants_outseam",
                },
            ],
            stepResultPart_2: [
                { key: "height", title: "HEIGHT", keyValueShow: "height_show" },
                { key: "weight", title: "WEIGHT", keyValueShow: "weight" },
                { key: "age", title: "AGE", keyValueShow: "age" },
                { key: "waist_size", title: "WAIST", keyValueShow: "waist_size" },
                { key: "pants_inseam", title: "INSEAM", keyValueShow: "pants_inseam" },
                { key: "shoe_size", title: "SHOES", keyValueShow: "shoe_size" },
                { key: "jacket_size", title: "JACKET", keyValueShow: "jacket_size" },
                { key: "sleeve_length", title: "SLEEVE", keyValueShow: "sleeve_length" },
            ],
            stepResultPart_3: [
                { key: "neck_size", title: "NECK", keyValueShow: "neck_size" },
                {
                    key: "body_posture_shoulder_slope",
                    title: "SHOULDER",
                    keyValueShow: "body_posture_shoulder_slope",
                },
                {
                    key: "body_posture_stance",
                    title: "STANCE",
                    keyValueShow: "body_posture_stance",
                },
                {
                    key: "body_posture_chest_p",
                    title: "CHEST",
                    keyValueShow: "body_posture_chest_p",
                },
                {
                    key: "body_posture_stomach",
                    title: "STOMACH",
                    keyValueShow: "body_posture_stomach",
                },
                {
                    key: "body_posture_seat",
                    title: "HIPS/SEAT",
                    keyValueShow: "body_posture_seat",
                },
                {
                    key: "body_posture_rise",
                    title: "PANTS RISE",
                    keyValueShow: "body_posture_rise",
                },
                {
                    key: "body_posture_pants_break",
                    title: "BREAK",
                    keyValueShow: "body_posture_pants_break",
                },
            ],
            shoeSizeMapEuToUs: SARTORO_APP_CONFIG.generalData.shoeSizeMapEuToUs,
            stepsNeedConvert: [
                {
                    key: "height",
                    needConvert: false,
                    needRound: true,
                    needUpdateSlider: true,
                },
                {
                    key: "weight",
                    needConvert: false,
                    needRound: true,
                    needUpdateSlider: false,
                },
                {
                    key: "waist_size",
                    needConvert: true,
                    needRound: true,
                    needUpdateSlider: false,
                },
                {
                    key: "shoe_size",
                    needConvert: false,
                    needRound: false,
                    needUpdateSlider: false,
                },
                {
                    key: "jacket_size",
                    needConvert: false,
                    needRound: true,
                    needUpdateSliderAdditional: true,
                },
                {
                    key: "pants_inseam",
                    needConvert: true,
                    needRound: true,
                    needUpdateSliderAdditional: true,
                },
                {
                    key: "sleeve_length",
                    needConvert: true,
                    needRound: true,
                    needUpdateSliderAdditional: true,
                },
                {
                    key: "neck_size",
                    needConvert: true,
                    needRound: true,
                    needUpdateSliderAdditional: true,
                },
            ],
            customerNote: "",
            registerEmail: "",
            registerEmailConfirm: "",
            registerEmailIsValid: false,
            registerEmailConfirmIsValid: false,
            registerEmailErrorMesg: "",
            registerEmailConfirmErrorMesg: "",
            registerEmailAccept: false,
            registerName: "",
            registerNameIsValid: false,
            registerNameErrorMesg: "",
            customerLoginForm: {
                email: null,
                password: null,
            },
            photo_upload_error: {
                isValid: true,
                isSuccess: false,
                errorMsg: "This is required. Please add a photo to continue.",
                successMsg: "",
                type: "",
            },
            measurements_by_tailor_input_error: {
                isValid: true,
                isSuccess: false,
                errorMsg: "Please enter a value for all fields.",
                successMsg: "Measurements were taken by a tailor",
                type: "unit",
            },
            sm_at_home_input_error: {
                isValid: true,
                isCheckedValid: false,
                isSuccess: false,
                errorMsg: "Measurement value entered is out of the acceptable range.",
                errorMsgEmpty: "The value must not be empty.",
                errorMsgInvalid:
                    "Measurement value entered is out of the acceptable range.",
                successMsg: "",
                type: "unit",
            },
            edit_one_input_error: {
                isValid: true,
                isSuccess: false,
                errorMsg: "Measurement value entered is out of the acceptable range.",
                errorMsgEmpty: "The value must not be empty.",
                errorMsgInvalid:
                    "Measurement value entered is out of the acceptable range.",
                successMsg: "",
                type: "unit",
            },
            isShowTooltip: false,
            isShowTooltipInputSM: false,
            isShowTooltipInputMG: false,
            isEditFitPreference: false,
            objShowToolbarOfBrowser: {},
            bodyProportionRequest: {
                numberRequestSend: 0,
                numberRequestDone: 0,
                numberRequest: 0,
            },
            selfMeasurementRequest: {
                numberRequestSend: 0,
                numberRequestDone: 0,
                numberRequest: 0,
            },
            selfMeasurementBeforeEdit: {},
            customer: DT3oState.CUSTOMER_INFO,
            currentEditStep: {
                isEditOneInput: false, // true if we edit one input from review steps
                oldValue: null,
                fromStep: "",
            },
            flags: {
                saving: false,
                doneBoldmetricsAPI: false,
                savedChangedInputs: false,
                customModalType: "confirmExitOrSaveData",
                isSkippedPhotos: true,
                isSubmittedPhotos: false,
                isGoFirstPage: false,
                isUploadingPhotos: false,
                isLastItemOfMeasureAtHomeIntro: false,
                isAnchorFitProfileDetailsStep: false, // anchor point at fit profile details step
                isExportingPDF: false,
                fromStep: "", // value is null or '' will go to other steps normally
                showFitPrecisionPants: false, // true will show the fit precision pants
                showFitPrecisionJacket: false, // for jacket
                showFitPrecisionShirt: false, // for shirt
                showIntroWithAnimation: false, //true will show intro content wrapper with animation
                hasChangeFinalValues: false, // true if any in finalValues changes
                hasChangeLastChoices: false, // true if any in lastChoices changes
                createFitProfileSuccess: false, // true if created fit profile successfully,
            },
            step: 0, // index of currentBigPages
            modalOpen: false,
            error: {
                message: "",
                active: false,
            },
            units: {
                values: ["us", "metric"],
                selected: "us",
            },
            UsUkUnits: DT3oConstant.UNITS_UK_US,
            EuAusUnits: DT3oConstant.UNITS_EU_AUS,
            UkAusUnits: DT3oConstant.UNITS_UK_AUS,
            selectors: {
                modal: ".boldmetrics-modal",
                stepsWrapper: ".boldmetrics-steps-wrapper",
            },
            mgProductTypesArr: DT3oConstant.ASSETS.mgProductTypesArr, // mg product types with sorted inputs in array
            mgProductTypesObj: DT3oConstant.ASSETS.mgProductTypesObj, // mg product types with sorted inputs in object
            smInputsArr: [], // definition all SM inputs
            smInputsBodyTypeArr: [], // sorted SM inputs filtered by body type
            smInputsWithIssue: [], // SM inputs has issue with analyzed data
            currentSMInputHasIssue: null, // current SM input has issue
            mgAllProductTypesInputsArr: {
                jacket: [],
                pants: [],
                shorts: [],
                shirt: [],
                vest: [],
                coat: [],
            }, // all inputs of all product type MG
            mgProductTypeInputsArr: [], // all inputs of current (selected) product type MG
            mgProductTypeWithIssueInputsArr: [], // MG inputs has isue with analyzed data
            currentMGInputHasIssue: null, // current MG input has issue
            // definition of inputs
            measurements: {
                ...DT3oConstant.GENERAL_DATA_STEPS,
                ...{
                    pants_size_info: {
                        selected: {},
                        metafieldKey: "pants_size_info",
                        metafield_namespace: "measurement_data",
                        us: {
                            values: [
                                {
                                    text1: "How do pants that size typically fit ...",
                                    text2: "... your waistline?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Snug",
                                        "Just Right",
                                        "A Bit Loose",
                                        "Very Loose",
                                    ],
                                    key: "waistline",
                                },
                                {
                                    text1: "",
                                    text2: "... your hips/seat?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Snug",
                                        "Just Right",
                                        "A Bit Loose",
                                        "Very Loose",
                                    ],
                                    key: "hips_seat",
                                },
                                {
                                    text1: "",
                                    text2: "... your thighs?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Snug",
                                        "Just Right",
                                        "A Bit Loose",
                                        "Very Loose",
                                    ],
                                    key: "thighs",
                                },
                                {
                                    text1: "",
                                    text2: "... your calves?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Snug",
                                        "Just Right",
                                        "A Bit Loose",
                                        "Very Loose",
                                    ],
                                    key: "calves",
                                },
                                {
                                    text1: "",
                                    text2: "... your length?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Snug",
                                        "Just Right",
                                        "A Bit Long",
                                        "Very Long",
                                    ],
                                    key: "length",
                                },
                            ],
                        },
                    },
                    jacket_size_info: {
                        selected: {},
                        metafieldKey: "jacket_size_info",
                        metafield_namespace: "measurement_data",
                        us: {
                            values: [
                                {
                                    text1: "What jacket fit/cut do you typically buy ...",
                                    text2: "",
                                    values: [
                                        "Not Sure",
                                        "Slim",
                                        "Modern",
                                        "Athletic",
                                        "Comfort",
                                    ],
                                    key: "fit_cut",
                                },
                                {
                                    text1: "How do jackets you purchase typically fit ...",
                                    text2: "... your shoulders?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Snug",
                                        "Just Right",
                                        "A Bit Loose",
                                        "Very Loose",
                                    ],
                                    key: "shoulders",
                                },
                                {
                                    text1: "",
                                    text2: "... your chest?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Snug",
                                        "Just Right",
                                        "A Bit Loose",
                                        "Very Loose",
                                    ],
                                    key: "chest",
                                },
                                {
                                    text1: "",
                                    text2: "... your belly?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Snug",
                                        "Just Right",
                                        "A Bit Loose",
                                        "Very Loose",
                                    ],
                                    key: "belly",
                                },
                                {
                                    text1: "",
                                    text2: "... your arm length?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Short",
                                        "Just Right",
                                        "A Bit Long",
                                        "Very Long",
                                    ],
                                    key: "arm_length",
                                },
                                {
                                    text1: "",
                                    text2: "... your jacket length?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Short",
                                        "Just Right",
                                        "A Bit Long",
                                        "Very Long",
                                    ],
                                    key: "jacket_length",
                                },
                            ],
                        },
                    },
                    shirt_size_info: {
                        selected: {},
                        metafieldKey: "shirt_size_info",
                        metafield_namespace: "measurement_data",
                        us: {
                            values: [
                                {
                                    text1: "What shirt fit/cut do you typically buy ...",
                                    text2: "",
                                    values: [
                                        "Not Sure",
                                        "Slim",
                                        "Modern",
                                        "Athletic",
                                        "Comfort",
                                    ],
                                    key: "fit_cut",
                                },
                                {
                                    text1: "How do shirts in that size typically fit ...",
                                    text2: "... your chest?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Snug",
                                        "Just Right",
                                        "A Bit Loose",
                                        "Very Loose",
                                    ],
                                    key: "chest",
                                },
                                {
                                    text1: "",
                                    text2: "... your belly?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Snug",
                                        "Just Right",
                                        "A Bit Loose",
                                        "Very Loose",
                                    ],
                                    key: "belly",
                                },
                                {
                                    text1: "",
                                    text2: "... your biceps?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Snug",
                                        "Just Right",
                                        "A Bit Loose",
                                        "Very Loose",
                                    ],
                                    key: "biceps",
                                },
                                {
                                    text1: "",
                                    text2: "... your arm length?",
                                    values: [
                                        "Not Sure",
                                        "A Bit Short",
                                        "Just Right",
                                        "A Bit Long",
                                        "Very Long",
                                    ],
                                    key: "arm_length",
                                },
                            ],
                        },
                    },
                },
            },
            posture_torso_error: {
                isValid: true,
                isSuccess: false,
                errorMsg: "",
                successMsg: "",
            },
            posture_shoulder_slope_error: {
                isValid: true,
                isSuccess: false,
                errorMsg: "",
                successMsg: "",
            },
            shoulder_width_seat_error: {
                isValid: true,
                isSuccess: false,
                successMsg: "",
                errorMsg: DT3oConstant.TRANS.ChooseValueForStepError,
            },
            pants_preference_error: {
                isValid: true,
                isSuccess: false,
                errorMsg: "",
                successMsg: "",
            },
            fit_preference_error: {
                isValid: true,
                isSuccess: false,
                errorMsg: "",
                successMsg: "",
            },
            boldmetricsData: {},
            introStepActive: "intro",
            introPreviousStepActive: null,
            introStepActivePreventChange: false, // true: note should not change introStepActive when watch currentBigPages
            selectedStepOfInputInfoPopup: { key: null, title: "", text: "", image: "" }, // text, image of selected step used to show in Input Info Popup
            introStepTabs: {
                values: ["Overview", "Guarantee", "Inches/CM"],
                selected: "Overview",
            },
            currentSMBodyType: "", // type self measure to measure (upper: Upper Body, lower: Lower Body, both: Full Body) - Nguyen changed default to ''
            currentMGProductType: "", // type measure a garment to measure (jacket, pants, shirt, vest, coat)
            currentMGProductTypeProfileDetail: "jacket", // type active garment in profile details fit_profile_details
            doneMGProductTypes: [],
            fitProfileTabs: {
                values: [
                    { label: "Core Inputs", value: "core-inputs", typeApp: "dt" },
                    { label: "Self Measure", value: "self-measure", typeApp: "sm" },
                    {
                        label: "Garment Measure",
                        value: "garment-measure",
                        typeApp: "mg",
                        tabs: {
                            values: [
                                { label: "Jacket", key: "jacket" },
                                { label: "Pants", key: "pants" },
                                { label: "Shirt", key: "shirt" },
                                { label: "Coat", key: "coat" },
                            ],
                            selected: "jacket",
                        },
                    },
                ],
                measurementType: "dt_sm_input", //  dt_sm_input | garment_inputs
                selected: "core-inputs",
                coreInputsLeftContent: [
                    {
                        key: "height",
                        title: "Height",
                        unitUs: "",
                        unitEu: "cm",
                        unitUk: "",
                        unitAus: "cm",
                        step: "body_size_detail",
                    },
                    {
                        key: "weight",
                        title: "Weight",
                        unitUs: "lbs",
                        unitEu: "kg",
                        unitUk: "lbs",
                        unitAus: "kg",
                        step: "body_size_detail",
                    },
                    {
                        key: "age",
                        title: "Age",
                        unitUs: "years",
                        unitEu: "years",
                        unitUk: "years",
                        unitAus: "years",
                        step: "body_size_detail",
                    },
                    {
                        key: "shoe_size",
                        title: "Shoe Size",
                        unitUs: "US",
                        unitEu: "EU",
                        unitUk: "UK",
                        unitAus: "AUS",
                        step: "body_size_detail",
                    },
                    {
                        key: "jacket_size",
                        title: "Jacket Size",
                        unitUs: "US",
                        unitEu: "EU",
                        unitUk: "UK",
                        unitAus: "AUS",
                        step: "jacket_size",
                    },
                    {
                        key: "waist_size",
                        title: "Pants Waist",
                        unitUs: "US",
                        unitEu: "EU",
                        unitUk: "UK",
                        unitAus: "AUS",
                        step: "pants_size",
                    },
                    {
                        key: "pants_inseam",
                        title: "Pants Inseam",
                        unitUs: "US",
                        unitEu: "EU",
                        unitUk: "UK",
                        unitAus: "AUS",
                        step: "pants_size",
                    },
                    {
                        key: "neck_size",
                        title: "Shirt Neck",
                        unitUs: "US",
                        unitEu: "EU",
                        unitUk: "UK",
                        unitAus: "AUS",
                        step: "shirt_size",
                    },
                ],
                coreInputsRightContent: [
                    {
                        key: "body_posture_fit_preference",
                        title: "Fit Preference",
                        step: "posture_fit_preference",
                        isPostureStep: true,
                        step: "posture_fit_preference",
                    },
                    {
                        key: "sleeve_length",
                        title: "Shirt Sleeve",
                        unitUs: "US",
                        unitEu: "EU",
                        unitUk: "UK",
                        unitAus: "AUS",
                        isPostureStep: false,
                        step: "shirt_size",
                    },
                    {
                        key: "body_posture_torso",
                        title: "Torso",
                        isPostureStep: true,
                        step: "posture_torso",
                    },
                    {
                        key: "body_posture_shoulder_width",
                        title: "Shoulder Width",
                        isPostureStep: true,
                        step: "posture_shoulder_width",
                    },
                    {
                        key: "body_posture_shoulder_slope",
                        title: "Shoulder Slope",
                        isPostureStep: true,
                        step: "posture_shoulder_slope",
                    },
                    {
                        key: "body_posture_stance",
                        title: "Stance",
                        isPostureStep: true,
                        step: "posture_stance",
                    },
                    {
                        key: "body_posture_seat",
                        title: "Hips / Butt Size",
                        isPostureStep: true,
                        step: "posture_seat",
                    },
                    {
                        key: "body_posture_arm_length",
                        title: "Arm Length",
                        isPostureStep: true,
                        step: "posture_arm_length",
                    },
                    {
                        key: "body_posture_rise",
                        title: "Pants Rise",
                        isPostureStep: true,
                        step: "posture_rise",
                    },
                ],
                mgInputs: [], // sorted MG inputs
            },
            valueInputSM: "",
            valueInputMG: "",

            isTransitioning: false,
            /* Reconfirm photo opt out */
            requiredImages: true,

            /* Reconfirm input*/
            inputOrderNumberReconfirm: "",
            inputOrderEmailReconfirm: "",
            textErrorOrderReconfirm: "",
            inputOrderNameReconfirm: "",
            inputOrderDateReconfirm: "",
            inputOrderDeliveryTypeReconfirm: "",

            messageReconfirm: "",

            /* Reconfirm final notes */
            textErrorFinalNotes: "",
            valueFinalNotesContent: "",
            selectedButton: null,
            valueFinalNotesExplanation: "",
            changeStepActivePhotoIntro: true,
            transitionName: "",
            hasAnalyzedDataSM: false,
            hasAnalyzedDataMG: false,

            /* Customer account fit profiles */
            showAddonIntroAccount: false,
        },
        // ======= end data
        watch: {
            currentBigPages: async function (val, oldVal) {
                console.log("==== currentBigPages",val, oldVal);
                if (typeof val === "undefined") {
                    this.currentBigPages = "intro";
                }

                const btnNext = document.querySelector(`.js-next-btn`);
                if (btnNext) btnNext.classList.remove("hide-ui");

                let _this = this;
                _this.previousBigPages = oldVal;
                _this.step = _this.currentIndexBigPages;
                _this.$set(_this.flags, "hasChangeFinalValues", false);
                _this.$set(_this.flags, "hasChangeLastChoices", false);
                _this.setActiveClassForStep(val, oldVal);
                // set type of fit profile when == COMPLETE_STEP (create_account)
                if (DT3oConstant.COMPLETE_STEP === val) {
                    // not logged in
                    if (_this.fitProfileDetails) {
                        _this.fitProfileDetails.type = !DT3oState.CUSTOMER_IS_LOGGED_IN
                            ? "local_complete"
                            : "complete";
                    }

                    if (window.setFitProfileSuccessInBrowser) {
                        window.setFitProfileSuccessInBrowser();
                    }
                }

                // not update progress when == 'intro' or 'profile_issue_found'
                if (val !== "intro" || val !== "profile_issue_found") {
                    this.createProgress({ currentStep: val, previousStep: oldVal });
                }
                switch (oldVal) {
                    case "sm_at_home_input":
                    case "sm_at_home_intro":
                    case "mg_intro":
                    case "mg_input":
                        this.clearContentSliderSMMGInput();
                        break;
                }
                switch (val) {
                    case "intro":
                        this.introStep().initStepActive();

                        break;
                    case "intro_reconfirm":
                        setTimeout(() => {
                            _this.introStep().setStepActive("intro-reconfirm-order");
                        }, 0);
                        break;
                    case "waiting_result":
                        if (this.isTypeAppReconfirm && this.skipWaitingResult) {
                            this.checkInputsIssuesAfterRunAnalyze({ typeApp: 'dt' });
                            setTimeout(() => {
                                this.nextStep_V2();
                            }, 100);
                            return;
                        }
                        this.finalValuesWithIssue = [];
                        this.analyzedData = null;

                        const initSlider = new Promise(resolve => {
                            setTimeout(() => {
                                _this.initSliderCustomerReview();
                                resolve();
                            }, 100);
                        });

                        const progressAnimation = new Promise(resolve => {
                            setTimeout(() => {
                                const progressBar = document.querySelector(".js-boldmetrics-wait-result-progress");
                                if (progressBar) {
                                    progressBar.classList.add("progressing");
                                }
                                setTimeout(resolve, 4000); // Ensure animation runs for 4s
                            }, 100);
                        });

                        const analysisPromise = new Promise(resolve => {
                            switch (this.typeApp) {
                                case "dt":
                                case "sm":
                                    Promise.race([
                                        DT3oTool.runMeasurementsAnalysis({
                                            typeApp: this.typeApp,
                                        }).then(data => resolve({type: 'standard', data})),
                                        new Promise((_, reject) => setTimeout(() => resolve({type: 'standard', data: null}), 5000))
                                    ]);
                                    break;
                                case "mg":
                                    // console.log("runMGAnalysis MG");
                                    Promise.race([
                                        DT3oTool.runMGAnalysis().then(data => resolve({type: 'standard', data})),
                                        new Promise((_, reject) => setTimeout(() => {
                                            _this.currentMGProductType = "";
                                            resolve({type: 'standard', data: null})
                                        }, 5000))
                                    ]);
                                    break;
                                case "sm-reconfirm":
                                    Promise.race([
                                        DT3oTool.runMeasurementsAnalysis({
                                            typeApp: 'dt',
                                        }).then(data => resolve({type: 'reconfirm', data})),
                                        new Promise((_, reject) => setTimeout(() => resolve({type: 'reconfirm', data: null}), 5000))
                                    ]);
                                    break;
                            }
                        });

                        Promise.all([initSlider, progressAnimation, analysisPromise])
                            .then(([_, __, analysis]) => {
                                if (analysis.type === 'standard') {

                                    if (this.smInputsWithIssue.length > 0) {
                                        this.hasAnalyzedDataSM = true;
                                    } else {
                                        this.hasAnalyzedDataSM = false;
                                    }
                                    if (_this.basicInputsIssueNumber && _this.basicInputsIssueNumber > 0) {
                                        _this.goToPageAndInput("profile_issue_found");
                                    } else {
                                        switch (_this.typeApp) {
                                            case "dt":
                                                _this.goToPageAndInput("profile_creation");
                                                break;
                                            case "sm":
                                            case "mg":
                                                _this.goToPageAndInput("sm_mg_transition");
                                                break;
                                        }
                                    }
                                } else {
                                    if (_this.basicInputsIssueNumber && _this.basicInputsIssueNumber > 0) {
                                        _this.goToPageAndInput("analyze_input_review");
                                        return;
                                    }
                                    _this.goToPageAndInput("rc_sm_intro");
                                }
                            });
                        break;
                    case "measurements_intro":
                        setTimeout(() => {
                            DT3oTool.initVideo('[data-big-page="measurements_intro"]');
                        }, 100);
                        break;
                    case "sm_intro":
                    case "rc_sm_intro":
                        if (this.isTypeAppReconfirm) {
                            // Init smInputsBodyTypeArr for collect smInputsWithIssue
                            _this.smInputsBodyTypeArr =
                            _this.smInputsBodyTypeArr.length > 0
                                ? _this.smInputsBodyTypeArr
                                : _this.getSortedInputsSMBodyType("both");
                                DT3oTool.runMeasurementsAnalysis({typeApp: 'sm'});
                                _this.updateKeyofBigPagesRC('sm');
                        }
                        break;
                    case "sm_at_home_intro":
                        _this.currentInputSM = null;
                        _this.handleMeasurementsInstructionStep();
                        break;
                    case "sm_at_home_input":
                        if (!_this.currentInputSM) {
                            _this.currentInputSM = _this.smInputsBodyTypeArr[0];
                        }
                        _this.progressSteps = _this.smInputsBodyTypeArr.length;
                        _this.bigPages[val].progressStep = _this.currentInputSMIndex + 1;
                        _this.createSliderGuideForSM(_this.currentInputSM);
                        break;
                    case "sm_profile_review":
                        _this.updateSMValuesToProfileByFinalValues();
                        break;
                    case "mg_intro":
                        if (this.isTypeAppReconfirm) {
                            DT3oTool.runMeasurementsAnalysis({typeApp: 'mg'});
                            _this.updateKeyofBigPagesRC('mg');
                        }
                        break;
                    case "mg_input":
                        if (!_this.currentInputMG) {
                            _this.currentInputMG = _this.mgProductTypeInputsArr[0];
                        }
                        _this.progressSteps = _this.mgProductTypeInputsArr.length;
                        _this.bigPages[val].progressStep = _this.currentInputMGIndex + 1;
                        _this.createSliderGuideForMG(_this.currentInputMG);
                        break;
                    case "mg_profile_review":
                        _this.doneMGProductTypes.push(_this.currentMGProductType);
                        _this.updateMGValuesToProfileByFinalValues();
                        break;
                    case "edit_one_input":
                        let sliderSelector = ".edit-one-input-item-slider";
                        DT3oTool.destroySlickSlider(sliderSelector);
                        setTimeout(() => {
                            let containerSlider = jQuery(
                                `[data-big-page="edit_one_input"]`
                            ).find(sliderSelector);
                            if (containerSlider.length) {
                                let html = "";
                                DT3oState.CurrentEditingInputOfSM.images.forEach(
                                    (item, index) => {
                                        html += `<div> <img src="${item.url}" alt="${item.alt}"/> </div>`;
                                    }
                                );
                                DT3oState.CurrentEditingInputOfSM.videos.forEach(
                                    (item, index) => {
                                        html +=
                                            index === 0
                                                ? '<div class="box video__wrapper">'
                                                : "";
                                        html += `<div class="plyr-embed" data-plyr-provider="vimeo" data-plyr-embed-id="${item.url}" style="--plyr-color-main: #1ac266;"></div>`;
                                        html +=
                                            index ===
                                            DT3oState.CurrentEditingInputOfSM.videos
                                                .length -
                                                1
                                                ? "</div>"
                                                : "";
                                    }
                                );
                                containerSlider.html(html);
                                setTimeout(() => {
                                    DT3oTool.initVideo(
                                        `[data-big-page="edit_one_input"]`
                                    );
                                }, 100);
                                setTimeout(() => {
                                    DT3oTool.initSliderOneInputSMGM(sliderSelector);
                                }, 700);
                                setTimeout(() => {
                                    DT3oTool.initDoubleHandersRangeInput({
                                        sliderSelector: "#RangeSliderEditOneInput",
                                        current_from: 20,
                                        current_to: 80,
                                    });
                                }, 200);
                            }
                            // focus
                            jQuery(
                                `[data-big-page="edit_one_input"] [name="measurements-at-home-item-input"]`
                            ).focus();
                        }, 100); // setTimeout
                        break;
                    case "customer_input_review":
                        _this.flags.fromStep = ""; // remove from Step
                        _this.updateMeasurementValuesToProfile();
                        break;
                    case "fit_profile_details":
                        _this.flags.isAnchorFitProfileDetailsStep = true;
                        _this.smInputsBodyTypeArr =
                            _this.smInputsBodyTypeArr.length > 0
                                ? _this.smInputsBodyTypeArr
                                : _this.getSortedInputsSMBodyType("both");
                        // load photos from fit profile into upload photos
                        DT3oTool.loadPhotosIntoUploadPhotos_Caller({ typeApp: DT3oConstant.TYPE_APP.EDIT_FIT_MODAL, idProfile: _this.fitProfileDetails.id });
                        // console.log("** _this.fitProfileDetails", _this.fitProfileDetails);
                        // console.log("** _this.finalValues", _this.finalValues);

                        break;
                    case "profile_creation":
                        if (_this.checkFitProfileHasImage()) {
                            _this.introStep().setStepActive("profile_created");
                        }
                        if (_this.isTypeAppReconfirm) {
                            if (SARTORO_APP_SM_RECONFIRM.imageConfirm.reconfirm !== "required") {
                                _this.nextStep_V2();
                                return;
                            }
                            _this.introStep().setStepActive("photo_intro");
                            DT3oTool.uploadPhotosRCToServer();
                            return;
                        }
                        if (!_this.introStepActivePreventChange)
                            _this.introStep().setStepActive("profile_created");
                        if (_this.fitProfileDetails) {
                            switch (_this.fitProfileDetails.type) {
                                case "partial":
                                    _this.fitProfileDetails.type = _this.customer.loggedIn
                                        ? "complete"
                                        : "local_complete";
                            }
                            // console.log("========= _this.fitProfileDetails::", _this.fitProfileDetails);

                            // call to add / update fit profile
                            let respAdd = await DT3oTool.checkToAddOrUpdateFitProfile({ typeAction: "add", fitProfile: _this.fitProfileDetails, typeApp: _this.typeApp });
                            _this.$set(_this.flags, "createFitProfileSuccess", respAdd.success);
                            // DT3oTool.showContentOfOneFitProfileModal_Caller();
                            // console.log("_this.fitProfileDetails::", _this.fitProfileDetails);

                            setTimeout(() => {
                                DT3oTool.runOnLoad();
                            }, 300);
                             // after X seconds will set active
                            if (_this.changeStepActivePhotoIntro) {
                                setTimeout(() => {
                                    _this.introStep().setStepActive("photo_intro");
                                }, 3000);
                            }
                        }

                        break;
                    case "analyze_input_review":
                        if (!_this.currentBasicInputHasIssue) {
                            _this.currentBasicInputHasIssue = {
                                ..._this.measurements[_this.basicInputsWithIssue[0].key],
                                ..._this.basicInputsWithIssue[0],
                            };
                            if (_this.basicInputsWithIssue.length > 0) {
                                _this.bigPages[_this.currentBigPages].progressStep = _this.basicInputsWithIssue.length;
                            }
                        }

                        if (!_this.currentBasicInputHasIssue) {
                            switch (_this.typeApp) {
                                case "dt":
                                    _this.goToPageAndInput("profile_creation");
                                    break;
                                case "sm":
                                    _this.goToPageAndInput("sm_intro");
                                    break;
                                case "mg":
                                    _this.goToPageAndInput("mg_intro");
                                    break;
                            }
                        }

                        setTimeout(() => {
                            DT3oTool.initDoubleHandersRangeInput({
                                sliderSelector: "#RangeSliderAnalyzeInputReview",
                                current_from: _this.currentBasicInputHasIssue.finalMin1,
                                current_to: _this.currentBasicInputHasIssue.finalMax1,
                                originalValue: _this.currentBasicInputHasIssue.originalValue,
                            });
                        }, 200);
                        break;
                    case "rc_photo_opt_out":
                        setTimeout(() => {
                            _this.introStep().setStepActive("photo-opt-out-main-wrapper");
                        }, 0);
                        break;
                    case "rc_final_notes":
                        setTimeout(() => {
                            this.introStep().setStepActive("final-notes-wrapper");
                        }, 0);
                        break;
                    case "posture_fit_preference":
                        this.progressSteps = this.isTypeAppDT
                        ? this.progressSteps_DT
                        : this.isTypeAppSM
                        ? this.progressSteps_SM
                        : this.progressSteps_DT;
                        break;
                    // complete step, ex 'create_account'
                    case [DT3oConstant.COMPLETE_STEP]:
                        break;
                    case "body_size_detail":
                        this.introStep().setStepActive("intro");
                        if (this.isTypeAppReconfirm) {
                            this.skipWaitingResult = this.skipWaitingResult || true;
                            this.finalValuesWithIssue = [];
                            this.analyzedData = null;
                            DT3oTool.runMeasurementsAnalysis({typeApp: 'dt'});
                        }
                    default:
                        this.progressSteps = this.isTypeAppDT
                            ? this.progressSteps_DT
                            : this.isTypeAppSM
                            ? this.progressSteps_SM
                            : this.progressSteps_DT;
                }
            },
            currentSMBodyType: function (val, oldVal) {
                this.smInputsBodyTypeArr = this.getSortedInputsSMBodyType(val);
                this.currentInputSM = this.smInputsBodyTypeArr[0] || null;
                this.checkInputsIssuesAfterRunAnalyze({ typeApp: this.typeApp });
            },
            // true when need to open the Edit One Input Modal
            showEditOneInputModal: function (val = false, oldVal) {
                // console.log("** showEditOneInputModal");
                if (val) {
                    let sliderSelector = ".edit-one-input-item-slider";
                    DT3oTool.destroySlickSlider(sliderSelector);
                    setTimeout(() => {
                        let containerSlider = jQuery(
                            `[data-big-page="edit_one_input"]`
                        ).find(sliderSelector);
                        if (containerSlider.length) {
                            let html = "";
                            DT3oState.CurrentEditingInputOfSmInModal.images.forEach(
                                (item, index) => {
                                    html += `<div> <img src="${item.url}" alt="${item.alt}"/> </div>`;
                                }
                            );
                            DT3oState.CurrentEditingInputOfSmInModal.videos.forEach(
                                (item, index) => {
                                    html +=
                                        index === 0
                                            ? '<div class="box video__wrapper">'
                                            : "";
                                    html += `<div class="plyr-embed" data-plyr-provider="vimeo" data-plyr-embed-id="${item.url}" style="--plyr-color-main: #1ac266;"></div>`;
                                    html +=
                                        index ===
                                        DT3oState.CurrentEditingInputOfSmInModal.videos
                                            .length -
                                            1
                                            ? "</div>"
                                            : "";
                                }
                            );
                            containerSlider.html(html);
                            setTimeout(() => {
                                DT3oTool.initVideo(`[data-big-page="edit_one_input"]`);
                            }, 100);
                            setTimeout(() => {
                                DT3oTool.initSliderOneInputSMGM(sliderSelector);
                            }, 700);
                            setTimeout(() => {
                                DT3oTool.initDoubleHandersRangeInput({
                                    sliderSelector: "#RangeSliderEditOneInput",
                                    current_from: 20,
                                    current_to: 80,
                                });
                            }, 200);
                        }
                        // focus
                        jQuery(
                            `[data-big-page="edit_one_input"] [name="measurements-at-home-item-input"]`
                        ).focus();
                    }, 100); // setTimeout
                } else {
                }
            },
            smInputsArr: {
                handler: function (val, oldVal) {
                    let _this = this;
                    _this.smInputsArr.forEach((item) => {
                        _this.measurements[item.metafieldKey] = item;
                        _this.finalValues[item.metafieldKey] = "";
                        _this.lastChoices[item.metafieldKey] = {
                            us: "",
                            metric: "",
                            eu: "",
                            uk: "",
                            aus: "",
                        };
                    });
                },
                deep: true,
            },
            currentInputSM: {
                handler: function (val, oldVal) {
                    this.smInputConfirmed = false;
                    try {
                        if (!val) return false;
                        if (this.isTypeAppReconfirm && !this.currentEditStep.isEditOneInput) {
                            if (this.isSkipInReconfirm(val.metafieldKey, 'sm')) {
                                this.valueInputSM = "";
                                this.handleBackNextSMInput(true);
                                return;
                            }
                        }
                        this.createSliderGuideForSM(val);
                    } catch (error) {
                        console.log("** Error watch currentInputSM", error);
                    }
                },
                deep: true,
            },
            mgAllProductTypesInputsArr: {
                handler: function (val, oldVal) {
                    let _this = this;
                    Object.keys(_this.mgAllProductTypesInputsArr).forEach(
                        (productKey) => {
                            if (!_this.lastChoices[productKey])
                                _this.lastChoices[productKey] = [];
                            if (!_this.finalValues[productKey])
                                _this.finalValues[productKey] = [];
                            let inputsProductType =
                                _this.mgAllProductTypesInputsArr[productKey];

                            inputsProductType.forEach((inputItem) => {
                                if (
                                    !_this.lastChoices[productKey][inputItem.metafieldKey]
                                ) {
                                    _this.lastChoices[productKey][
                                        inputItem.metafieldKey
                                    ] = { us: "", metric: "", eu: "", uk: "", aus: "" };
                                }
                                if (
                                    !_this.finalValues[productKey][inputItem.metafieldKey]
                                ) {
                                    _this.finalValues[productKey][
                                        inputItem.metafieldKey
                                    ] = {};
                                }
                            });
                        }
                    );
                },
                deep: true,
            },
            currentInputMG: {
                handler: function (val, oldVal) {
                    this.mgInputConfirmed = false;
                    try {
                        if (!val) return false;
                        if (this.isTypeAppReconfirm && !this.currentEditStep.isEditOneInput) {
                            if (this.isSkipInReconfirm(val.metafieldKey, 'mg')) {
                                this.valueInputMG = "";
                                this.handleBackNextMGInput(true);
                                return;
                            }
                        }
                        this.createSliderGuideForMG(val);
                    } catch (error) {
                        console.log("** Error watch currentInputMG", error);
                    }
                },
                deep: true,
            },
            valueInputSM: function (val, oldVal) {
                if (
                    ["sm_at_home_input"].includes(this.currentBigPages) &&
                    !this.currentInputSM
                )
                    return false;
                const { metafieldKey } = this.currentInputSM;
                if (!metafieldKey) return false;
                this.finalValues[metafieldKey] = val ? parseFloat(val) : val;
                this.lastChoices[metafieldKey][this.selectedUnit] = val ? parseFloat(val) : val;
            },
            valueInputMG: function (val, oldVal) {
                if (["mg_input"].includes(this.currentBigPages) && !this.currentInputMG)
                    return false;
                const { metafieldKey } = this.currentInputMG;
                if (!metafieldKey) return false;
                this.lastChoices[this.currentMGProductType][metafieldKey][this.selectedUnit] = val ? parseFloat(val) : val;
                if (!this.finalValues[this.currentMGProductType]) {
                    this.finalValues[this.currentMGProductType] = {};
                }
                this.finalValues[this.currentMGProductType][metafieldKey] = val ? parseFloat(val) : val;
                // this.finalValues[this.currentMGProductType][metafieldKey] = val;
            },
            currentMGProductType: function (val, oldVal) {
                // this.mgProductTypeInputsArr = this.mgAllProductTypesInputsArr[val] ? this.mgAllProductTypesInputsArr[val] : [];
                this.mgProductTypeInputsArr = this.mgProductTypesObj[val]
                    ? this.mgProductTypesObj[val].inputs
                    : [];
                this.progressSteps = this.mgProductTypeInputsArr.length;
                this.bigPages["mg_input"].progressStep = this.currentInputMGIndex + 1;
                this.currentInputMG = this.mgProductTypeInputsArr[0];
                setTimeout(() => {
                    DT3oTool.initDoubleHandersRangeInput({
                        sliderSelector: "#RangeSliderMeasureGarmentInput",
                        current_from: 20,
                        current_to: 80,
                    });
                }, 2000);
            },
            finalValues: {
                handler: function (val, oldVal) {
                    this.$set(this.flags, "hasChangeFinalValues", true);
                },
                deep: true,
            },
            lastChoices: {
                handler: function (val, oldVal) {
                    this.$set(this.flags, "hasChangeLastChoices", true);
                },
                deep: true,
            },
            fitProfileDetails: {
                handler: function (val, oldVal) {
                    this.$set(this.flags, "hasChangeFinalValues", true);
                    if (
                        ["create_fit_profile", "continue_fit_profile"].includes(
                            this.typeAction
                        )
                    ) {
                        localStorage.setItem(
                            DT3oConstant.SESS_FIT_PROFILES_LOCAL,
                            JSON.stringify(this.fitProfileDetails)
                        );
                    }
                },
                deep: true,
            },
            currentPhotoStep: function (val, oldVal) {
                let { currentUploadPhotos } = DT3oState;
                jQuery(`#App-Photo-Upload-Customer-Img-${val}`).attr(
                    "src",
                    currentUploadPhotos[val].preview
                );
                DT3oState.currentPhoto.typeDirection = val;
                DT3oState.currentUploadPhotos.currentStep = val;
            },
            ratioZoomPhotoCropper: function (val, oldVal) {
                if (val === 1) {
                    this.$refs["dt3o_cropper_zoombar_slider"].value = 1;
                }
                let ratioZoom = val > oldVal ? 0.1 : -0.1;
                DT3oTool.zoomUploadPhoto(ratioZoom);
            },
            basicInputsWithIssue: function (val, oldVal) {},

            currentBasicInputHasIssue: function (val, oldVal) {
                if (this.currentBigPages === "analyze_input_review") {
                    this.transitionDTAnalyzeInputReview();
                    return;
                }
            },
            isTransitioning: function (val, oldVal) {
                if (val) {
                    setTimeout(() => {
                        this.isTransitioning = false;
                        return false;
                    }, 800);
                }
            },
            fitProfileHasImage: function (val, oldVal) {
                return val;
            },
        },
        // ======= end watch
        computed: {
            currentIndexBigPages: function () {
                return this.currentBigPages
                    ? this.keysOfBigPages.indexOf(this.currentBigPages)
                    : 0;
            },
            currentInputSMIndex: function () {
                if (!this.currentInputSM) return -1;
                return this.smInputsBodyTypeArr.findIndex(
                    (item) => item.metafieldKey === this.currentInputSM["metafieldKey"]
                );
            },
            currentInputMGIndex: function () {
                if (!this.currentInputMG) return -1;
                return this.mgProductTypeInputsArr.findIndex(
                    (item) => item.metafieldKey === this.currentInputMG["metafieldKey"]
                );
            },
            getReconfirmItem: function () {
                if (
                    this.SARTORO_APP_SM_RECONFIRM &&
                    this.SARTORO_APP_SM_RECONFIRM.self_measure_reconfirm &&
                    this.SARTORO_APP_SM_RECONFIRM.self_measure_reconfirm.length
                ) {
                    let found = false;
                    this.SARTORO_APP_SM_RECONFIRM.self_measure_reconfirm.some(
                        (item, index) => {
                            if (
                                item.status &&
                                item.status.toString().toLowerCase() === "reconfirm"
                            ) {
                                found = item;
                                return true;
                            }
                        }
                    );
                    return found;
                }
                return false;
            },
            currentPhotoStepIndex: function () {
                // return currentPhotoStepIndex = this.bigPages.photo_upload.steps.indexOf(this.currentPhotoStep);
                return (currentPhotoStepIndex = this.mainPhotoSteps.indexOf(
                    this.currentPhotoStep
                ));
            },
            measurementValues: function () {
                var _this = this,
                    values = {};
                var unit = _this.selectedUnit;
                _.each(_this.measurements, function (step) {
                    let stepName = step.metafieldKey
                        ? step.metafieldKey
                        : step.name
                        ? step.name
                        : null;
                    if (!stepName) {
                        return false;
                    }
                    var isPostureStep = stepName.indexOf("posture") !== -1;
                    var isBoldmetricsApi = stepName.indexOf("api") !== -1;
                    var isHeight = stepName === "height";
                    var isWeight = stepName === "weight";
                    if (isHeight) {
                        let value = _this.unitIsUsUk
                            ? _this.finalValues.height_show_inches
                            : _this.finalValues.height_show_cm;
                        let ht_in_inches = _this.unitIsUsUk
                            ? _this.checkStepNeedRoundUp("height")
                                ? DT3oTool.roundUp(value)
                                : value
                            : _this.checkStepNeedRoundUp("height")
                            ? DT3oTool.convertCmToInches(value, true)
                            : DT3oTool.convertCmToInches(value, false);
                        values[stepName] = parseFloat(ht_in_inches);
                    } else if (isWeight) {
                        var value =
                            _this.finalValues[
                                stepName
                            ] /* || step[_this.selectedUnit].selected || step[_this.selectedUnit].other */ ||
                            getSessionMeasurement(stepName);
                        var weight_pounds = value;
                        if (_this.unitIsMetric) {
                            if (_this.checkStepNeedRoundUp("weight")) {
                                weight_pounds = DT3oTool.roundUp(weight_pounds * 2.20462);
                            } else {
                                weight_pounds *= 2.20462;
                            }
                        }
                        values[stepName] = parseFloat(weight_pounds);
                    } else if (
                        [
                            "jacket_size_info",
                            "pants_size_info",
                            "shirt_size_info",
                        ].includes(stepName)
                    ) {
                        values[stepName] =
                            _this.finalValues[stepName] ||
                            getSessionMeasurement(stepName);
                    } else if (!isPostureStep && !isBoldmetricsApi) {
                        // other steps not posture or boldmetrics api
                        // Arn 15/10/2021
                        if (unit === "metric" && stepName) {
                            let stepNeedConvert = null;
                            _this.stepsNeedConvert.some((item, index) => {
                                if (stepName === item.key) {
                                    stepNeedConvert = item;
                                    return true;
                                }
                            });
                            let value =
                                _this.finalValues[
                                    stepName
                                ] /* || step[_this.selectedUnit].selected || step[_this.selectedUnit].other */ ||
                                getSessionMeasurement(stepName);
                            if (stepName === "shoe_size" && value !== "n/a") {
                                let shoe_size_eu = value;
                                // let shoe_size_us = _this.shoeSizeMapEuToUs[shoe_size_eu] ? _this.shoeSizeMapEuToUs[shoe_size_eu] : _this.lastChoices[stepName][unit]; // commented by task 8810
                                // Task 8810
                                let shoe_size_us = Number(shoe_size_eu) - 34;
                                step.us.selected = shoe_size_us;
                                step.metric.selected = shoe_size_eu;
                                values[stepName] = shoe_size_us;
                            } else if (stepName === "jacket_size") {
                                if (value !== "n/a") {
                                    let jacket_size_no_srl = ['S','R','L'].includes(value.toString()) ? value.toString().replace(/[SRL]/i, "") : value;
                                    // Thanh 09/09/2022
                                    // let valueNotSRL = _this.convertCmToInches(jacket_size_no_srl); // commented by task 8810
                                    // Task 8810
                                    let valueNotSRL = Number(jacket_size_no_srl) - 10;
                                    if (_this.checkStepNeedRoundUp(stepName)) {
                                        valueNotSRL = DT3oTool.roundUp(valueNotSRL);
                                    }
                                    // end 09/09/2022
                                    values[stepName] = valueNotSRL;
                                } else {
                                    values[stepName] = value;
                                }
                                values["jacket_size_srl"] =
                                    _this.finalValues["jacket_size_srl"] ||
                                    getSessionMeasurement("jacket_size_srl") ||
                                    "";
                            }
                            // Task 8810 add waist_size
                            else if (stepName === "waist_size") {
                                values[stepName] = DT3oTool.roundUp(Number(value) - 16);
                            } else {
                                // other steps
                                values[stepName] =
                                    stepNeedConvert &&
                                    stepNeedConvert.needConvert &&
                                    step[unit].selected !== "n/a"
                                        ? _this.convertCmToInches(value)
                                        : value;
                                // Thanh 09/09/2022
                                if (_this.checkStepNeedRoundUp(stepName)) {
                                    values[stepName] = DT3oTool.roundUp(values[stepName]);
                                }
                                // end 09/09/2022
                            }
                        } else {
                            var value =
                                _this.finalValues[
                                    stepName
                                ] /* || step[_this.selectedUnit].selected || step[_this.selectedUnit].other */ ||
                                getSessionMeasurement(stepName);
                            values[stepName] = value;
                        }
                    } else if (isPostureStep) {
                        // posture
                        values[stepName] =
                            _this.finalValues[stepName] ||
                            getSessionMeasurement(stepName);
                    } else {
                        // boldmetrics
                        values[stepName] = step.value || getSessionMeasurement(stepName);
                    }
                });

                // bold metrics
                var boldmetrics_api = {
                    neck: getSessionMeasurement("boldmetrics_api_neck"),
                    chest: getSessionMeasurement("boldmetrics_api_chest"),
                    upper_waist: getSessionMeasurement("boldmetrics_api_upper_waist"),
                    belly: getSessionMeasurement("boldmetrics_api_belly"),
                    bicep: getSessionMeasurement("boldmetrics_api_bicep"),
                    shoulder: getSessionMeasurement("boldmetrics_api_shoulder"),
                    arm_length: getSessionMeasurement("boldmetrics_api_arm_length"),
                    jacket_length: getSessionMeasurement("boldmetrics_api_jacket_length"),
                    beltline: getSessionMeasurement("boldmetrics_api_beltline"),
                    hips: getSessionMeasurement("boldmetrics_api_hips"),
                    crotch: getSessionMeasurement("boldmetrics_api_crotch"),
                    thigh: getSessionMeasurement("boldmetrics_api_thigh"),
                    thigh_height: getSessionMeasurement("boldmetrics_api_thigh_height"),
                    calf: getSessionMeasurement("boldmetrics_api_calf"),
                    //calf_height: '',
                    pants_outseam: getSessionMeasurement("boldmetrics_api_pants_outseam"),
                };

                // MG inputs
                Object.keys(this.getMGProductTypesWithInputsFromDTConfig()).forEach(
                    (productType) => {
                        values[productType] =
                            _this.finalValues[productType] ||
                            getSessionMeasurement(productType);
                    }
                );

                _.each(boldmetrics_api, function (value, key) {
                    values[`boldmetrics_api_${key}`] = value;
                });
                return values;
            },
            isPartialProfile: function () {
                return this.checkTypeFitProfile(this.fitProfileDetails, "partial");
            },
            isLocalCompleteProfile: function () {
                return this.checkTypeFitProfile(this.fitProfileDetails, "local_complete");
            },
            isCompleteProfile: function () {
                return this.checkTypeFitProfile(this.fitProfileDetails, "complete");
            },
            hasThisPageInBigPages: function () {
                return Object.keys(this.bigPages).includes(this.currentBigPages);
            },
            selectedUnit: function () {
                return this.units.selected;
            },
            unitIsInches: function () {
                return this.units.selected === "us";
            },
            unitIsUsUk: function () {
                return this.UsUkUnits.includes(this.units.selected);
            },
            unitIsEuAus: function () {
                return this.EuAusUnits.includes(this.units.selected);
            },
            unitIsMetric: function () {
                return this.units.selected === "metric";
            },
            unitPlacehoder: function () {
                return this.unitIsUsUk ? "0.00" : "0";
            },
            placeHolderCustomerFitProfile: function () {
                try {
                    let dateObj = new Date();
                    const options = { year: "numeric", month: "short", day: "numeric" };
                    return dateObj.toLocaleDateString("en-US", options);
                } catch (error) {
                    console.log("** placeHolderCustomerFitProfile", error);
                    return "Jan 1st, 2025";
                }
            },
            unitFull: function () {
                return this.unitIsUsUk ? "inches" : "centimeters";
            },
            totalSteps: function () {
                return jQuery(".boldmetrics-modal .step").length - 1; // -1 to exclude intro
            },
            isLastStep: function () {
                return this.step == this.totalSteps;
            },
            isValidNextButton() {
                if (this.isTypeAppReconfirm) {
                    let noSkip = [];
                    switch (this.currentBigPages) {
                        case "body_size_detail":
                            noSkip = [this.unitIsUsUk ? "height_show_inches" : "height_show_cm","age","weight","shoe_size"].filter(key => !this.isSkipInReconfirm(key, 'dt'));
                            return noSkip.every((key) => !!this.getFinalValueStep(key, ""));
                        case "pants_size":
                            noSkip = ["pants_waist"].filter(key => !this.isSkipInReconfirm(key, 'dt'));
                            noSkip = ["waist_size"];
                            return noSkip.every((key) => !!this.getFinalValueStep(key, ""));
                        case "posture_rise":
                            noSkip = ["body_posture_rise"].filter(key => !this.isSkipInReconfirm(key, 'dt'));
                            return noSkip.every((key) => !!this.getFinalValueStep(key, ""));
                        case "jacket_size":
                            noSkip = ["jacket_size"].filter(key => !this.isSkipInReconfirm(key, 'dt'));
                            return noSkip.every((key) => !!this.getFinalValueStep(key, ""));
                        case "shirt_size":
                            noSkip = ["neck_size", "sleeve_length"].filter(key => !this.isSkipInReconfirm(key, 'dt'));
                            return noSkip.some((key) => !!this.getFinalValueStep(key, ""));
                        default:
                            return true;
                    }
                };
                switch (this.currentBigPages) {
                    case "body_size_detail":
                        return [
                            this.unitIsUsUk ? "height_show_inches" : "height_show_cm",
                            "age",
                            "weight",
                            "shoe_size",
                        ].every((key) => !!this.getFinalValueStep(key, ""));
                    case "pants_size":
                        return ["waist_size"].every(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    case "posture_rise":
                        return ["body_posture_rise"].every(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    case "jacket_size":
                        return ["jacket_size"].every(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    case "shirt_size":
                        return ["neck_size", "sleeve_length"].some(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    case "posture_torso":
                        return ["body_posture_torso"].every(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    case "posture_arm_length":
                        return ["body_posture_arm_length"].every(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    case "posture_shoulder_width":
                        return ["body_posture_shoulder_width"].every(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    case "posture_shoulder_slope":
                        return ["body_posture_shoulder_slope"].every(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    case "posture_stance":
                        return ["body_posture_stance"].every(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    case "posture_seat":
                        return ["body_posture_seat"].every(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    case "body_fit_preference":
                        return ["body_posture_fit_preference"].every(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    case "sm_at_home_input":
                        if (!this.currentInputSM) return false;
                        const { metafieldKey } = this.currentInputSM;
                        let checkValid = DT3oTool.checkValidValueInput(
                            metafieldKey,
                            this.valueInputSM
                        );
                        return checkValid.isValid;
                    case "mg_input":
                        if (!this.currentInputMG) return false;
                        const { metafieldKey: metafieldKeyMG } = this.currentInputMG;
                        let checkValidMG = DT3oTool.checkValidValueInput(
                            metafieldKeyMG,
                            this.valueInputMG
                        );
                        return checkValidMG.isValid;
                    case "posture_jacket_length_preferred":
                        return ["body_posture_jacket_length_preferred"].every(
                            (key) => !!this.getFinalValueStep(key, "")
                        );
                    default:
                        return true;
                }
            },
            // measure a garment inputs
            measureGarmentInputs: function () {
                if (SARTORO_APP_CONFIG.measureGarmentInputs) {
                    this.measureGarmentInputs = Object.keys(
                        SARTORO_APP_CONFIG.measureGarmentInputs
                    ).map((key) => {
                        return SARTORO_APP_CONFIG.measureGarmentInputs[key];
                    });
                }
            },
            // label of type Self Measure: both is 'Full Body', upper is 'Upper Body', lower is 'Lower Body'
            labelTypeBodySelfMeasure: function () {
                switch (this.currentSMBodyType) {
                    case "both":
                        return "Full Body";
                    case "upper":
                        return "Upper Body";
                    case "lower":
                        return "Lower Body";
                }
                return "";
            },
            // Check form recomfirm
            isFormFilled() {
                let valueOrderNumber = this.inputOrderNumberReconfirm;
                let patternNumber = new RegExp(/^\d{1,5}$/);
                let valueOrderNumberLength = patternNumber.test(valueOrderNumber);
                let valueOrderEmail = this.inputOrderEmailReconfirm;
                let validOrderEmail = DT3oTool.checkValidEmail(valueOrderEmail);
                if (
                    valueOrderNumber !== "" &&
                    valueOrderNumberLength &&
                    valueOrderEmail !== "" &&
                    validOrderEmail
                ) {
                    return true;
                }
                return false;
            },
            // Check validateInteger for the order number input
            validateInteger() {
                let valueOrderNumber = this.inputOrderNumberReconfirm;
                this.inputOrderNumberReconfirm = valueOrderNumber.replace(/\D/g, "");
            },
            // get heading for custom modal based on flags.customModalType
            headingCustomModal() {
                let { TRANS } = DT3oConstant;
                switch (this.flags.customModalType) {
                    case "confirmExitOrSaveData":
                        return TRANS.confirmExitOrSaveDataHeading;
                    case "savedDataIsError":
                        return TRANS.saveDataIsErrorHeading;
                    case "pleaseWaitForComplete":
                        return TRANS.waitToCompleteHeading;
                    case "wrongRangeOfBasicInput":
                        return TRANS.wrongRangeOfBasicInputHeading;
                    case "confirmCancelEditFitProfile":
                        return TRANS.CancelEditFitProfileConfirmHeading;
                    case "confirmDeleteFitProfile":
                        return (
                            TRANS.deleteFitProfileConfirmTitle +
                            " " +
                            DT3oState.currentDeleteFitProfile.name
                        );
                    case "deleteFitProfileSuccess":
                        return TRANS.resultSuccess;
                    case "deleteFitProfileFailed":
                        return TRANS.resultFailed;
                    case "confirmCreateNewFitProfile":
                        return TRANS.confirmCreateNewFitProfileHeading;
                    case "confirmInputSM":
                        return TRANS.confirmInputSMHeading;
                    case "confirmInputMG":
                        return TRANS.confirmInputMGHeading;
                    default:
                        return "";
                }
            },
            // get content for custom modal based on flags.customModalType
            contentCustomModal() {
                let { TRANS } = DT3oConstant;
                switch (this.flags.customModalType) {
                    case "confirmExitOrSaveData":
                        return TRANS.confirmExitOrSaveDataContent;
                    case "savedDataIsError":
                        return TRANS.saveDataIsErrorContent;
                    case "pleaseWaitForComplete":
                        return TRANS.waitToCompleteContent;
                    case "wrongRangeOfBasicInput":
                        return TRANS.wrongRangeOfBasicInputContent;
                    case "confirmCancelEditFitProfile":
                        return TRANS.CancelEditFitProfileConfirmContent;
                    case "confirmDeleteFitProfile":
                        return TRANS.deleteFitProfileConfirmContent;
                    case "confirmCreateNewFitProfile":
                        return TRANS.confirmCreateNewFitProfileContent;
                    case "confirmInputSM":
                        return TRANS.confirmInputSMContent;
                    default:
                        return "";
                }
            },
            // text for one button custom modal based on flags.customModalType
            textOneButtonCustomModal() {
                let { TRANS } = DT3oConstant;
                switch (this.flags.customModalType) {
                    case "pleaseWaitForComplete":
                        return TRANS.waitToCompleteButtonText;
                    case "wrongRangeOfBasicInput":
                    case "deleteFitProfileSuccess":
                    case "deleteFitProfileFailed":
                        return TRANS.ButtonOk;
                    default:
                        return TRANS.ButtonLaunchDigitalTailor;
                }
            },
            // check custom modal show One Button
            isOneButtonCustomModal() {
                return (
                    DT3oConstant.LIST.modalCustomShowOneButton.indexOf(
                        this.flags.customModalType
                    ) > -1
                );
            },
            // get top title at step based on currentBigPages
            stepTopTitle() {
                let { coreApp } = SARTORO_APP_CONFIG
                    ? SARTORO_APP_CONFIG.textsAndImages
                    : {};
                switch (this.currentBigPages) {
                    case "body_size_detail":
                        return coreApp.coreRequireInfoHeaderText;
                    case "pants_size":
                        return coreApp.coreRequireInfoPantsHeaderText;
                    case "jacket_size":
                        return coreApp.coreRequireInfoJacketSizeHeaderText;
                    case "shirt_size":
                        return coreApp.coreRequireInfoShirtSizeHeaderText;
                    case "rc_all_required_inputs":
                        return coreApp.reconfirmRequiredInputsHeaderText;
                    case "rc_review_input":
                        return coreApp.coreFitProfileReviewHeaderTextReconfirm;
                    case "posture_torso":
                        return coreApp.coreBodyType1HeaderText;
                    case "posture_arm_length":
                        return coreApp.coreBodyType2HeaderText;
                    case "posture_shoulder_width":
                        return coreApp.coreBodyType3HeaderText;
                    case "posture_shoulder_slope":
                        return coreApp.coreBodyType4HeaderText;
                    case "posture_stance":
                        return coreApp.coreBodyType5HeaderText;
                    case "posture_seat":
                        return coreApp.coreBodyType6HeaderText;
                    case "posture_rise":
                        return coreApp.coreBodyType7HeaderText;
                    case "posture_fit_preference":
                        return coreApp.coreBodyType8HeaderText;
                    case "customer_note":
                        return coreApp.coreProfileCustomerNoteHeaderText;
                    case "customer_input_review":
                        return coreApp.coreProfileReviewHeaderText;
                    case "posture_jacket_length_preferred":
                        return coreApp.JacketLengthPreferredHeaderText;
                    case "analyze_input_review":
                        return coreApp.JacketLengthPreferredHeaderText;
                    default:
                        return "";
                }
            },
            // currentEditStep: check old value and new value are different
            // Nguyen comment 04/18/2025 - no see used
            // checkDifferentOldNewValueCurrentEditStep() {
            // },
            finalValuesIssueNumber() {
                return this.basicInputsWithIssue.length;
            },
            basicInputsIssueNumber() {
                return this.basicInputsWithIssue.length;
            },
            smInputsIssueNumber() {
                return this.smInputsWithIssue.length;
            },
            sortedInputsMGIssueNumber() {
                return this.mgProductTypeWithIssueInputsArr.length;
            },
            currentBasicInputHasIssueIndex() {
                return this.basicInputsWithIssue.findIndex(
                    (item) => item.key === this.currentBasicInputHasIssue.key
                );
            },
            currentBasicInputHasNewValue() {
                if (!this.currentBasicInputHasIssue) return false;
                let currentValue =
                    this.finalValues[this.currentBasicInputHasIssue.metafieldKey];
                if (!currentValue) return false;
                let isUpdatedOriginalValue =
                    currentValue != this.currentBasicInputHasIssue.originalValue;
                if (isUpdatedOriginalValue)
                    this.currentBasicInputHasIssue.originalValue = currentValue;
                return isUpdatedOriginalValue ? true : false;
            },
            classColorOriginalHandleIssueBasicInput() {
                if (!this.currentBasicInputHasIssue) return "";
                let {
                    originalValue,
                    finalMin1,
                    finalMax1,
                    finalMin2,
                    finalMax2,
                    finalMin3,
                    finalMax3,
                } = this.currentBasicInputHasIssue;
                if (finalMin2 <= originalValue && originalValue <= finalMax2)
                    return "green";
                else {
                    return finalMin3 > originalValue || originalValue > finalMax3
                        ? "red"
                        : "yellow";
                }
            },
            classColorNewHandleIssueBasicInput() {
                if (!this.currentBasicInputHasIssue) return "";
                let currentValue =
                    this.finalValues[this.currentBasicInputHasIssue.metafieldKey];
                if (!currentValue) return "";
                currentValue =
                    typeof currentValue !== "number"
                        ? parseFloat(currentValue)
                        : currentValue;
                let { finalMin2, finalMax2, finalMin3, finalMax3 } =
                    this.currentBasicInputHasIssue;
                if (finalMin2 <= currentValue && currentValue <= finalMax2) {
                    return "";
                } else {
                    return finalMin3 > currentValue || currentValue > finalMax3
                        ? "red"
                        : "yellow";
                }
            },
            smInputsKeys() {
                return this.smInputsArr.map((item) => item.metafieldKey);
            },
            smInputsBodyTypeKeys() {
                return this.smInputsBodyTypeArr.map((item) => item.metafieldKey);
            },
            sortedInputsMGProductTypeKeys() {
                return this.mgProductTypeInputsArr.map((item) => item.metafieldKey);
            },
            defaultValueInputSM() {
                return this.finalValues[this.currentInputSM.metafieldKey];
            },
            defaultValueInputMG() {
                const { metafieldKey } = this.currentInputMG;
                return this.finalValues[this.currentMGProductType][metafieldKey];
            },
            postureInputsKeys() {
                return DT3oConstant.POSTURE_INPUTS.map((item) => item.metafieldKey);
            },
            basicInputKeys() {
                return DT3oConstant.BASIC_INPUTS.map((item) => item.metafieldKey);
            },
            isHideNextBtnPosture() {
                let stepHide = this.stepsHideNextBtnBodyProportions.includes(this.currentBigPages) && this.currentBigPages !== 'posture_fit_preference';
                let noValue = this.finalValues['body_' + this.currentBigPages] === '' || this.finalValues['body_' + this.currentBigPages] === null || this.finalValues['body_' + this.currentBigPages] === undefined;
                return stepHide && noValue;
            },
        },
        // ======= end computed
        // life circle
        mounted: function () {
            var _this = this;
            this.typeApp = "dt";
            jQuery((event) => {
                let bodyListArn = document.querySelector("body");
                var previousUrl = "";
                var observerArn = new MutationObserver(function (mutations) {
                    if (location.href !== previousUrl) {
                        previousUrl = location.href;
                        if (
                            location.href.toLowerCase().indexOf("pages/measurements") > -1
                        ) {
                            let interval = setInterval(() => {
                                let eleDest = jQuery(
                                    "#arena-account-measurements-anchor"
                                );
                                if (
                                    eleDest.length &&
                                    eleDest.data("load-content") == "n"
                                ) {
                                    eleDest.text("").data("load-content", "y");
                                    let eleNeedMove = jQuery(
                                        ".boldmetrics-account-measurement-page-container"
                                    );
                                    eleNeedMove.clone(true).appendTo(eleDest);
                                    eleDest
                                        .find(
                                            ".boldmetrics-account-measurement-page-container"
                                        )
                                        .css({ display: "block" });
                                    jQuery(
                                        ".boldmetrics-account-measurement-fit-preference-content"
                                    ).trigger("click");
                                    _this.getAllSelfMeasureBeforeEdit();
                                    clearInterval(interval);
                                }
                            }, 700);
                        }
                    }
                });
                let config = { attributes: true, subtree: true };
                observerArn.observe(bodyListArn, config);
            });
            // Integrate with Gem Pages
            jQuery(document).on(
                "click",
                "#e-1595302476538 .button, .launch-bold-metrics",
                function (e) {
                    e.preventDefault();
                    // jQuery('.js-boldmetrics-link').trigger('click');
                    DT3oTool.openDigitalTailor("intro");
                }
            );

            console.log('DT mounted::');
            jQuery(document).on(
                "click",
                ".boldmetrics-edit-body-proportion-caller",
                function (e) {
                    e.preventDefault();
                    DT3oTool.openEditBodyProportion(e);
                }
            );
            // Thanh comment 02/21/2025
            // jQuery(document).on('click', '.boldmetrics-edit-fit-preference-caller', function(e) {
            //     e.preventDefault();
            //     let step = 'body_posture_fit_preference';
            //     let stepObj = { key: step, value: getSessionMeasurement('body_posture_fit_preference') };
            //     if (!stepObj.value || _this.measurements[step].values.indexOf(stepObj.value) == -1) { // set default
            //         _this.finalValues.body_posture_fit_preference = _this.measurements[step].default;
            //     }
            //     else {
            //         _this.finalValues.body_posture_fit_preference = stepObj.value;
            //     }
            //     _this.isEditFitPreference = true;
            //     _this.showOnlyOnePage('fit_preference', stepObj);
            // });
            //
            jQuery(document).on("click", ".relaunch-boldmetrics-modal", function (e) {
                e.preventDefault();
                _this.relaunchBoldmetricsModal(e, "intro");
            });
            //
            jQuery(document).on("click touchstart", ".boldmetrics-modal", function (e) {
                let isTarget = jQuery(e.target).hasClass("boldmetrics_svg_question_icon");
                if (!isTarget) {
                    _this.hideStepInfo_V2(e);
                }
            });
            //
            jQuery(document).on(
                "click touchstart",
                ".launch-edit-your-size",
                function (e) {
                    _this.showEditSelfMeasurementInAccountPage();
                }
            );
            //
            jQuery(document).on(
                "click touchstart",
                ".boldmetrics-account-measurement-fit-preference-content",
                function (e) {
                    _this.showContentAsFitPreference(e);
                }
            );


            // Click Export PDF Button
            jQuery(document).on(
                "click touchstart",
                ".measurements-by-tailor-pdf",
                function (e) {
                    if (!_this.flags.isExportingPDF) {
                        // DT3oTool.openMeasurementsByTailorModal(); // open for testing
                        // change order ID
                        let reconfirmItem = _this.getReconfirmItem;
                        if (reconfirmItem && reconfirmItem.order_id) {
                            jQuery(
                                ".self-measure-measurements-by-tailor-print-modal .top-order-number-value"
                            ).text(reconfirmItem.order_id);
                        }
                        _this.$set(_this.flags, "isExportingPDF", true);
                        setTimeout(() => {
                            DT3oTool.exportMeasurementsByTailor();
                        }, 1000);
                    }
                }
            );
            //
            jQuery(document).on(
                "click touchstart",
                ".boldmetrics-create-your-custom-size-caller",
                function (e) {
                    _this.isShowOnlyOnePage = false;
                    _this.currentBigPages = "intro";
                    _this.step = _this.keysOfBigPages.indexOf(_this.currentBigPages);
                    jQuery(".js-boldmetrics-link").trigger("click");
                }
            );
            //
            jQuery(document).on(
                "click touchstart",
                ".launch-bold-metrics-start-over, .relaunch-boldmetrics-modal-when-exising-other-modal",
                function (e) {
                    e.preventDefault();
                    _this.closeModalAll();
                    jQuery(".js-boldmetrics-link").trigger("click");
                }
            );

            // Arn 11/01/2022, Thanh comment 02/21/2025
            /*
            jQuery(document).on('click touchstart', '.launch-self-measure-start-over', function(e) {
                e.preventDefault();
                _this.closeModalAll();
                DT3oTool.changeSeftMeasurement(e);
            });
            */
            var islastAccessed =
                sessionStorage.getItem("last_accessed_tool") == "boldmetrics";
            var allSaved =
                sessionStorage.getItem("measurements_saved_boldmetrics") == "true";
            if (islastAccessed && !allSaved && _this.customer.loggedIn) {
                // _this.saveAllChangedMeasurements_V2_Handle('login');
                //_this.saveLocalFitProfileToServer_Caller();
            }
            this.introStep().initStepActive();
        },
        // ======= end mounted
        methods: {
            createProgress: function ({ currentStep, previousStep }) {
                if (!currentStep) {
                    console.log("===** Error createProgress: Not have currentStep");
                }
                let progress = DT3oTool.getTrackProgress();
                let progressData = {
                    ...(progress || {}),
                    typeApp: this.typeApp,
                    currentStep,
                    currentInput:
                        this.typeApp === "sm"
                            ? this.currentInputSM
                            : this.typeApp === "mg"
                            ? this.currentInputMG
                            : {},
                    currentSMBodyType: this.currentSMBodyType,
                    currentMGProductType: this.currentMGProductType,
                    isTypeAppDT: this.isTypeAppDT,
                    isTypeAppSM: this.isTypeAppSM,
                    isTypeAppReconfirm: this.isTypeAppReconfirm,
                    isTypeAppMG: this.isTypeAppMG,
                };
                if (typeof previousStep !== "undefined") {
                    progressData.previousStep = previousStep;
                }
                if (this.stepsIsProfileInput.includes(currentStep)) {
                    progressData.lastStepProfileInput = currentStep;
                }
                DT3oTool.updateTrackProgress(progressData);
            },
            getBigPages: function (typeApp) {
                let isTypeAppDT = typeApp === "dt" ? true : false;
                let isTypeAppSM = typeApp === "sm" ? true : false;
                let isTypeAppMG = typeApp === "mg" ? true : false;
                let isTypeAppReconfirm = typeApp === "sm-reconfirm" ? true : false;
                return isTypeAppDT
                    ? this.bigPages_DigitalTailor
                    : isTypeAppSM
                    ? this.bigPages_SelfMeasure
                    : isTypeAppMG
                    ? this.bigPages_MeasureGarment
                    : this.bigPages_Reconfirm;
            },
            checkThisPageInBigPages: function (bigPages, page) {
                return Object.keys(bigPages).includes(page);
            },
            checkIsProfileInput: function (page) {
                return this.stepsIsProfileInput.includes(page);
            },
            // temporary fit profile
            getFitProfileDetailsTemp: function () {
                return JSON.parse(
                    localStorage.getItem(DT3oConstant.SESS_FIT_PROFILES_LOCAL) || null
                );
            },
            checkIsPartialProfile: function () {
                return this.checkTypeFitProfile(
                    this.getFitProfileDetailsTemp(),
                    "partial"
                );
            },
            checkIsLocalCompleteProfile: function () {
                let profile = this.getFitProfileDetailsTemp();
                if (!profile) return false;
                if (Array.isArray(profile)) {
                    profile = profile[0];
                }
                return this.checkTypeFitProfile(
                    profile,
                    "local_complete"
                );
            },
            checkIsCompleteProfile: function () {
                return this.checkTypeFitProfile(
                    this.getFitProfileDetailsTemp(),
                    "complete"
                );
            },
            checkTypeFitProfile: function (profile, typeCheck) {
                if (!profile || !typeCheck) return false;
                let { dt_sm_input, type } = profile;
                if (!dt_sm_input) return false;
                return dt_sm_input && dt_sm_input.height && type === typeCheck
                    ? true
                    : false;
            },
            createFitProfileInputs: function () {
                try {
                    let _this = this;
                    let dt_sm_input = {};
                    let postureKeys = this.postureInputsKeys;
                    this.smInputsArr.forEach((item) => {
                        let value = _this.finalValues[item.metafieldKey];
                        if (value !== undefined && value !== null && value !== "") {
                            dt_sm_input[item.metafieldKey] = value;
                        }
                    });
                    postureKeys.forEach((key) => {
                        let value = _this.finalValues[key];
                        if (value !== undefined && value !== null && value !== "") {
                            dt_sm_input[key] = value;
                        }
                    });

                    Object.keys(DT3oConstant.GENERAL_DATA_STEPS).forEach((key) => {
                        let value = _this.finalValues[key];
                        if (key === 'jacket_size_srl') return;
                        if (key === 'jacket_size') {
                            let jacketSizeSrl = _this.finalValues['jacket_size_srl'] || '';
                            value = `${_this.finalValues[key]}${jacketSizeSrl}`;
                        }
                        if (DT3oConstant.INPUTS_CAN_EMPTY.includes(key)) {
                            dt_sm_input[key] = value;
                            return true;
                        }
                        if (!value) return false;
                        dt_sm_input[key] = value;
                    });
                    // pants_size_info, jacket_size_info, shirt_size_info
                    ["pants_size_info", "jacket_size_info", "shirt_size_info"].forEach(
                        (key) => {
                            let value = _this.finalValues[key];
                            if (DT3oConstant.INPUTS_CAN_EMPTY.includes(key)) {
                                dt_sm_input[key] = value;
                                return true;
                            }
                            if (!value || !Object.keys(value).length) return false;
                            dt_sm_input[key] = value;
                        }
                    );
                    let api_boldmetrics_inputs = {};
                    Object.keys(ARN_BOLDMETRICS_API_METAFIELDS_LIST).forEach((key) => {
                        let value = _this.finalValues[key];
                        if (!value) return false;
                        api_boldmetrics_inputs[key] = value;
                    });
                    // MG inputs
                    let garment_inputs = {};
                    Object.keys(this.getMGProductTypesWithInputsFromDTConfig()).forEach(
                        (productType) => {
                            let value = _this.finalValues[productType];
                            if (!value) return false;
                            garment_inputs[productType] = value;
                        }
                    );
                    let _fitProfile = {
                        dt_sm_input,
                        api_boldmetrics_inputs,
                        garment_inputs,
                    };
                    return _fitProfile;
                } catch (error) {
                    console.log("===** createFitProfileInputs: ", error);
                    return {};
                }
            },
            // Update finalValues to fit profile vars
            updateMeasurementValuesToProfile: function () {
                let _fitProfile = this.createFitProfileInputs();
                this.fitProfileDetails = { ...this.fitProfileDetails, ..._fitProfile };
            },
            // Update SM finalValues to fit profile vars
            updateSMValuesToProfileByFinalValues: function () {
                // if (this.typeApp !== "sm") return;
                let _fitProfile = {};
                _fitProfile["dt_sm_input"] = { ...this.fitProfileDetails["dt_sm_input"] };
                this.smInputsArr.forEach((item) => {
                    _fitProfile["dt_sm_input"][item.metafieldKey] =
                        this.finalValues[item.metafieldKey];
                });
                this.fitProfileDetails = { ...this.fitProfileDetails, ..._fitProfile };
            },
            // Update SM finalValues to fit profile vars
            updateSMValuesToProfileByLastChoices: function () {
                // if (this.typeApp !== "sm") return;
                let _fitProfile = {};
                _fitProfile["dt_sm_input"] = { ...this.fitProfileDetails["dt_sm_input"] };
                this.smInputsArr.forEach((item) => {
                    this.finalValues[item.metafieldKey] =
                        this.lastChoices[item.metafieldKey][this.selectedUnit];
                    _fitProfile["dt_sm_input"][item.metafieldKey] =
                        this.lastChoices[item.metafieldKey][this.selectedUnit];
                    this.measurementValues[item.metafieldKey] =
                        this.lastChoices[item.metafieldKey][this.selectedUnit];
                });
                this.fitProfileDetails = { ...this.fitProfileDetails, ..._fitProfile };
            },
            // Update MG finalValues to fit profile vars
            updateMGValuesToProfileByFinalValues: function () {
                let _fitProfile = {};
                _fitProfile["garment_inputs"] = {};

                this.mgProductTypesArr.forEach((item) => {
                    // Check if item.type exists and finalValues has this type
                    if (!item.type || !this.finalValues[item.type]) return;
                    _fitProfile["garment_inputs"][item.type] = _fitProfile["garment_inputs"][item.type] || {};
                    if (typeof this.finalValues[item.type] === 'object' && this.finalValues[item.type] !== null) {
                        Object.keys(this.finalValues[item.type]).forEach((itemKey) => {
                            console.log("** itemKey", itemKey);
                            if (!this.finalValues[item.type][itemKey]) return;
                            _fitProfile["garment_inputs"][item.type][itemKey] =
                                this.finalValues[item.type][itemKey];
                        });
                    }
                });
                this.fitProfileDetails = { ...this.fitProfileDetails, ..._fitProfile };
                localStorage.setItem(DT3oConstant.SESS_FIT_PROFILES_LOCAL, JSON.stringify(this.fitProfileDetails));

            },
            // Update MG finalValues to fit profile vars
            updateMGValuesToProfileByLastChoices: function () {
                // if (this.typeApp !== "mg") return;
                let _fitProfile = {};
                _fitProfile["garment_inputs"] = {
                    ...this.fitProfileDetails["garment_inputs"],
                };
                this.mgProductTypesArr.forEach((item) => {
                    _fitProfile["garment_inputs"][item.type] =
                        this.finalValues[item.type];
                    this.measurementValues[item.type] =
                        this.finalValues[item.type];
                });
                this.fitProfileDetails = { ...this.fitProfileDetails, ..._fitProfile };
            },
            // Update posture inputs to fit profile vars
            updatePostureValuesToProfile: function () {
                try {
                    let _this = this;
                    let _fitProfile = {};
                    _fitProfile["dt_sm_input"] = { ...this.fitProfileDetails["dt_sm_input"] };

                    let postureKeys = this.postureInputsKeys;
                    postureKeys.forEach((key) => {
                        let value = _this.finalValues[key];
                        if (value !== undefined && value !== null && value !== "") {
                            _fitProfile["dt_sm_input"][key] = value;
                        }
                    });
                    this.fitProfileDetails = { ...this.fitProfileDetails, ..._fitProfile };
                } catch (error) {
                    console.log("===** Error updatePostureValuesToProfile", error);
                }
            },
            // Save posture input value to session and update fit profile
            savePostureInputValueSessionAndProfile: function ({
                inputKey,
                notSaveMetafieldWhenLogin = true,
            }) {
                try {
                    this.saveMeasurement(inputKey, notSaveMetafieldWhenLogin);
                    this.updatePostureValuesToProfile();
                } catch (error) {
                    console.log("===** Error savePostureInputValueSessionAndProfile", error);
                }
            },
            //
            updateLastChoicesToFinalValues: function () {
                let garmentKeys = this.mgProductTypesArr.map(item => item.type);
                Object.keys(this.lastChoices).forEach((key) => {
                    if (garmentKeys.includes(key)) {
                        Object.keys(this.lastChoices[key]).forEach((itemKey) => {
                            if (!this.lastChoices[key][itemKey] || !this.lastChoices[key][itemKey][this.selectedUnit]) return;
                            this.finalValues[key][itemKey] = this.lastChoices[key][itemKey][this.selectedUnit];
                        });
                    } else {
                        if (this.lastChoices[key] && this.lastChoices[key][this.selectedUnit]) {
                            this.finalValues[key] = this.lastChoices[key][this.selectedUnit];
                            if (key === "height") {
                                this.finalValues[key] = this.selectedUnit === "us" ? this.finalValues.height_show_inches : this.finalValues.height_show_cm;
                            }
                        }
                    }
                });
            },
            //
            updateFinalValuesToLastChoices: function () {
                let garmentKeys = this.mgProductTypesArr.map(item => item.type);

                Object.keys(this.finalValues).forEach((key) => {
                    if (garmentKeys.includes(key) && key && this.finalValues[key]) {
                        Object.keys(this.finalValues[key]).forEach((itemKey) => {
                            if (!itemKey ||
                                !this.finalValues[key] !== undefined ||
                                !this.finalValues[key][itemKey] !== undefined ||
                                !this.lastChoices[key] !== undefined ||
                                !this.lastChoices[key][itemKey] !== undefined ||
                                !this.lastChoices[key][itemKey][this.selectedUnit] !== undefined ||
                                !this.selectedUnit) return;

                            this.lastChoices[key][itemKey][this.selectedUnit] = this.finalValues[key][itemKey];
                        });
                    } else {
                        if (key &&
                            this.lastChoices[key] !== undefined &&
                            this.lastChoices[key][this.selectedUnit] !== undefined &&
                            this.selectedUnit &&
                            this.finalValues[key] !== undefined) {

                            this.lastChoices[key][this.selectedUnit] = this.finalValues[key];

                            if (key === "height") {
                                if (this.selectedUnit === "us" && this.finalValues.height_show_inches) {
                                    this.lastChoices[key][this.selectedUnit] = this.finalValues.height_show_inches;
                                } else if (this.finalValues.height_show_cm) {
                                    this.lastChoices[key][this.selectedUnit] = this.finalValues.height_show_cm;
                                }
                            }
                        }
                    }
                });
            },
            createSliderGuideForSM: function (val) {
                if (!val) return;
                this.clearContentSliderSMMGInput();
                const { metafieldKey } = val;
                if (metafieldKey) {
                    let value = this.lastChoices[metafieldKey][this.selectedUnit];
                    this.valueInputSM = value ? value : null;
                }
                if (this.currentBigPages === "sm_at_home_input") {
                    let sliderSelector = ".measurements-at-home-input-item-slider";
                    let $section = jQuery(sliderSelector);
                    $section.css({ opacity: "0" });
                    DT3oTool.destroySlickSlider(sliderSelector);

                    // Prevent multiple executions with a flag
                    if (this._isCreatingSliderSM) return;
                    this._isCreatingSliderSM = true;

                    requestAnimationFrame(() => {
                        let containerSlider = jQuery(
                            `[data-big-page="sm_at_home_input"]`
                        ).find(sliderSelector);

                        if (containerSlider.length) {
                            let html = "";
                            val.images.forEach((item, index) => {
                                if (item && item.url) {
                                    html += `<div> <img src="${item.url}" alt="${item.alt}"/> </div>`;
                                }
                            });
                            val.videos.forEach((item, index) => {
                                if (item && item.url) {
                                    html += index === 0  ? '<div class="box video__wrapper">' : "";
                                    html += `<div class="plyr-embed" data-plyr-provider="vimeo" data-plyr-embed-id="${item.url}" style="--plyr-color-main: #1ac266;"></div>`;
                                    html += index === val.videos.length - 1 ? "</div>" : "";
                                }
                            });
                            containerSlider.html(html);
                            DT3oTool.initVideo(`[data-big-page="sm_at_home_input"]`);

                            setTimeout(() => {
                                DT3oTool.initSliderOneInputSMGM(sliderSelector, true);
                                DT3oTool.initDoubleHandersRangeInput({
                                    sliderSelector: "#RangeSliderMeasureInput",
                                    current_from: 20,
                                    current_to: 80,
                                });
                                $section.css({ opacity: "1" });

                                this._isCreatingSliderSM = false;
                            }, 100);
                        } else {
                            this._isCreatingSliderSM = false;
                        }

                        jQuery(
                            `[data-big-page="sm_at_home_input"] [name="measurements-at-home-item-input"]`
                        ).focus();
                    });
                    this.createProgress({ currentStep: this.currentBigPages });
                }
            },
            createSliderGuideForMG: function (val) {
                if (!val) return;
                this.clearContentSliderSMMGInput();
                const { metafieldKey } = val;
                if (metafieldKey) {
                    let value = this.finalValues[this.currentMGProductType][metafieldKey];
                    this.valueInputMG = value ? value : null;
                }

                if (this.currentBigPages === "mg_input") {
                    let sliderSelector = ".measure-garment-input-item-slider";
                    let $section = jQuery(sliderSelector);
                    $section.css({ opacity: "0" });
                    DT3oTool.destroySlickSlider(sliderSelector);

                    // Prevent multiple executions with a flag
                    if (this._isCreatingSliderMG) return;
                    this._isCreatingSliderMG = true;

                    requestAnimationFrame(() => {
                        let containerSlider = jQuery(`[data-big-page="mg_input"]`).find(
                            sliderSelector
                        );

                        if (containerSlider.length) {
                            // Build HTML content
                            let html = "";
                            if (val.images) {
                                val.images.forEach((item, index) => {
                                    if (item && item.url) {
                                        html += `<div> <img src="${item.url}" alt="${item.alt}"/> </div>`;
                                    }
                                });
                            }
                            if (val.videos) {
                                val.videos.forEach((item, index) => {
                                    if (item && item.url) {
                                        html += index === 0 ? '<div class="box video__wrapper">' : "";
                                        html += `<div class="plyr-embed" data-plyr-provider="vimeo" data-plyr-embed-id="${item.url}" style="--plyr-color-main: #1ac266;"></div>`;
                                        html += index === val.videos.length - 1 ? "</div>" : "";
                                    }
                                });
                            }
                            containerSlider.html(html);
                            DT3oTool.initVideo(`[data-big-page="mg_input"]`);

                            setTimeout(() => {
                                DT3oTool.initSliderOneInputSMGM(sliderSelector, true);
                                DT3oTool.initDoubleHandersRangeInput({
                                    sliderSelector: "#RangeSliderMeasureGarmentInput",
                                    current_from: 20,
                                    current_to: 80,
                                });
                                $section.css({ opacity: "1" });
                                this._isCreatingSliderMG = false;
                            }, 100);
                        } else {
                            this._isCreatingSliderMG = false;
                        }

                        jQuery(
                            `[data-big-page="mg_input"] [name="measure-garment-item-input"]`
                        ).focus();
                    });
                    this.createProgress({ currentStep: this.currentBigPages });
                }
            },
            closeGarmentAndNext: function () {
                const modal = document.querySelectorAll(`.jsGarmentAndNext[data-current-page="${this.currentBigPages}"]`);
                modal.forEach(item => {
                    item.classList.add('close');
                });

                setTimeout(() => {
                    this.goToPageAndInput('profile_creation');
                }, 400);
            },
            clearContentSliderSMMGInput: function () {
                let sliderSelector = ".measurements-at-home-input-item-slider";
                DT3oTool.destroySlickSlider(sliderSelector);
                let containerSlider = jQuery(`[data-big-page="sm_at_home_input"]`).find(sliderSelector);
                if (containerSlider.length) {
                    containerSlider.html("");
                    containerSlider.removeClass("slick-initialized", "slick-slider");
                }

                // let sliderMGSelector = ".measure-garment-input-item-slider";
                // DT3oTool.destroySlickSlider(sliderMGSelector);
                // let containerSliderMG = jQuery(`[data-big-page="mg_input"]`).find(sliderMGSelector);
                // if (containerSliderMG.length) {
                //     containerSliderMG.html("");
                //     containerSliderMG.removeClass("slick-initialized", "slick-slider");
                // }
            },
            getClassForStep: function (stepName) {
                return {
                    active: this.currentBigPages === stepName,
                    "prev-active": this.previousBigPages === stepName,
                };
            },
            // handler when click on one button custom modal based on flags.customModalType
            handlerClickOneButtonCustomModal(e) {
                switch (this.flags.customModalType) {
                    case "pleaseWaitForComplete":
                        this.closeModalAll();
                        break;
                    case "wrongRangeOfBasicInput":
                        DT3oTool.closeGeneralModal();
                        break;
                    case "deleteFitProfileSuccess":
                    case "deleteFitProfileFailed":
                        DT3oTool.closeModal();
                        break;
                    default:
                        this.closeModalAll();
                        jQuery(".js-boldmetrics-link").trigger("click");
                }
            },
            resetSelectedValue(key, value = "") {
                this.finalValues[key] = value;
            },
            // get value of a property (key) ex step, min, max, unit from sartoro_app_config.sartoro_app_config_data_dt30.generalData.steps
            getValueByKeyInInputValues(key, typeValue, unit, isRound = false) {
                if (!key || !typeValue || !unit) {
                    console.log("===** getValueByKeyInInputValues not have valid params");
                    return null;
                }
                let IsUsUkUnit = this.UsUkUnits.includes(unit);
                let IsEuAusUnit = this.EuAusUnits.includes(unit);
                let valueInUs = IsUsUkUnit ? this.measurements[key]["us"][typeValue] : "";
                let valueInEu = IsEuAusUnit
                    ? this.measurements[key]["metric"][typeValue]
                    : "";
                if (["step", "default", "selected"].includes(typeValue)) {
                    return IsUsUkUnit ? valueInUs : valueInEu;
                }
                if (["unit"].includes(typeValue)) {
                    if (["height", "weight"].includes(key)) {
                        return IsUsUkUnit ? valueInUs : valueInEu;
                    } else {
                        if (this.UkAusUnits.includes(unit)) return unit;
                        else return IsUsUkUnit ? valueInUs : valueInEu;
                    }
                }
                // other typeValue: min, max
                switch (key) {
                    case "height":
                        if (IsUsUkUnit) return valueInUs;
                        else if (IsEuAusUnit)
                            return valueInUs * DT3oConstant.CONST_FROM_INCHES_TO_CM;
                        break;
                    case "weight":
                        if (IsUsUkUnit) return valueInUs;
                        else if (IsEuAusUnit)
                            return DT3oTool.convertLbsToKg(valueInUs, isRound);
                        break;
                    default:
                        return IsUsUkUnit ? valueInUs : valueInEu;
                }
                return "";
            },
            // get value of selected step key for DT, SM
            getFinalValueStep(key, returnWhenFalse = "---") {
                let returnValue = this.finalValues[key];
                if (!returnValue || returnValue < 0 || returnValue === "n/a")
                    returnValue = "";
                switch (key) {
                    case "height":
                        returnValue = this.unitIsUsUk
                            ? this.finalValues.height_show_short
                            : this.finalValues.height_show_cm;
                        break;
                }
                return returnValue && returnValue !== returnWhenFalse
                    ? returnValue
                    : returnWhenFalse;
            },
            // get value of selected posture step key
            getFinalValueStepPosture(key, returnWhenFalse = "---") {
                console.log("getFinalValueStepPosture::", key, this.finalValues);
                let returnValue = this.finalValues[key];
                returnValue = DT3oTool.checkIsNumeric(returnValue) ? "" : returnValue;
                return returnValue && returnValue !== returnWhenFalse
                    ? returnValue
                    : returnWhenFalse;
            },
            // get value of selected step key for GM
            getFinalValueStepMG(currentMGProductType, key, returnWhenFalse = "---") {
                let returnValue = this.finalValues[currentMGProductType][key];
                return returnValue && returnValue !== returnWhenFalse
                    ? returnValue
                    : returnWhenFalse;
            },
            getProfileValue(
                parentKey,
                secondKey = "",
                keyInput,
                unit,
                returnWhenFalse = "---"
            ) {
                    let returnValue = secondKey
                    ? this.fitProfileDetails[parentKey][secondKey][keyInput]
                    : this.fitProfileDetails[parentKey][keyInput];

                if (parentKey === "garment_inputs") {
                    returnValue = returnValue ? returnValue[this.selectedUnit] : -1;
                }
                if (returnValue < 0 || !returnValue) returnValue = "";

                const { values: valuesUs = [] } = DT3o_GENERAL_DATA_STEPS[keyInput]
                    ? DT3o_GENERAL_DATA_STEPS[keyInput].us
                    : {};
                let _value = DT3oInitialTool.convertValueToOtherUnits({
                    keyInput,
                    value: returnValue,
                    unit: "us",
                    values: valuesUs,
                });
                returnValue = _value[unit];
                if (keyInput === "height" && unit === "us") {
                    returnValue = _value.us_feet_short;
                }

                return returnValue && returnValue !== returnWhenFalse
                    ? returnValue
                    : returnWhenFalse;
            },
            // get value of selected step key for DT, SM
            getProfileValueFinal(keyInput, garmentKey = "", returnWhenFalse = "---") {
                let returnValue = garmentKey && garmentKey !== "" ? this.finalValues[garmentKey][keyInput] : this.finalValues[keyInput];
                if (keyInput === "height") {
                    if (this.unitIsUsUk) {
                        returnValue = this.finalValues.height_show_short;
                    } else {
                        returnValue = this.finalValues.height_show_cm;
                    }
                }
                if (returnValue < 0 || !returnValue) returnValue = "";
                return returnValue && returnValue !== returnWhenFalse
                    ? returnValue
                    : returnWhenFalse;
            },
            // get unit of selected step key
            getSelectedUnitStep(key, isCapital = true) {
                let returnValue = this.unitIsInches ? "us" : "cm";
                switch (key) {
                    case "height":
                        returnValue = this.unitIsUsUk ? "" : "cm";
                        break;
                    case "weight":
                        returnValue = this.unitIsUsUk ? "lbs" : "kgs";
                        break;
                }
                return isCapital ? returnValue.toUpperCase() : returnValue;
            },
            getValueAnalyzed: function (key) {
                try {
                    return this.analyzedData && this.analyzedData[key]
                        ? this.analyzedData[key]
                        : null;
                } catch (error) {
                    console.log("** Error getValueAnalyzed", error);
                    return null;
                }
            },
            getValueAnalyzedSM: function (key, type = "finalAvg") {
                try {
                    if (!this.smInputsWithIssue) return null;
                    let item = this.smInputsWithIssue.find((item) => item.key === key);
                    if (!item) return null;
                    return item[type] ? item[type] : null;
                } catch (error) {
                    console.log("** Error getValueAnalyzed", error);
                    return null;
                }
            },
            getValueAnalyzedMG: function (key, type = "finalAvg") {
                try {
                    if (!this.mgProductTypeWithIssueInputsArr || !this.mgProductTypeWithIssueInputsArr[this.currentMGProductType]) return null;
                    let item = this.mgProductTypeWithIssueInputsArr[this.currentMGProductType].find(
                        (item) => item.key === key
                    );
                    if (!item) return null;
                    return item[type] ? item[type] : null;
                } catch (error) {
                    console.log("** Error getValueAnalyzed", error);
                    return null;
                }
            },
            getValueCurrentInputSM: function (key) {
                try {
                    let selector = `input#measurements-at-home-item-input-${key}[data-is-mobile="${DT3oTool.isMobile()}"]`;
                    return jQuery(selector).val() || null;
                } catch (error) {
                    console.log("** Error getValueAnalyzed", error);
                }
            },
            getValueCurrentInputMG: function (key) {
                try {
                    let selector = `input#measure-garment-item-input-${key}[data-is-mobile="${DT3oTool.isMobile()}"]`;
                    return jQuery(selector).val() || null;
                } catch (error) {
                    console.log("** Error getValueAnalyzed", error);
                }
            },
            getMgProductTypeProperty: function (productType, property) {
                return this.mgProductTypesObj[productType]
                    ? this.mgProductTypesObj[productType][property]
                    : null;
            },
            getGender() {
                if (!this.fitProfileDetails["info"]) return DT3oConstant.DEFAULT_GENDER;
                return (
                    this.fitProfileDetails["info"]["gender"] ||
                    DT3oConstant.DEFAULT_GENDER
                );
            },
            getSortedInputsSMBodyType(bodyType) {

                return !this.smInputsArr
                    ? []
                    : bodyType === "both"
                    ? this.smInputsArr
                    : this.smInputsArr.filter(
                          (item) => String(item.typeBody).toLowerCase() === bodyType || String(item.typeBody).toLowerCase() === "both"
                      );
            },
            getSortedInputsSMBodyTypeKeys(bodyType) {
                let inputs = this.getSortedInputsSMBodyType(bodyType);
                console.log("inputs::", inputs);

                return inputs.map((item) => item.metafieldKey);
            },
            getSortedInputsMGProductType: function (productType) {
                return this.mgAllProductTypesInputsArr[
                    productType ? productType : "jacket"
                ]; // default is jackets
            },
            getSortedInputsMGProductTypeKeys: function (productType) {
                let inputs = this.getSortedInputsMGProductType(productType);
                return inputs.map((item) => item.metafieldKey);
            },
            // check basic inputs issue with analyzed measurements
            checkInputsIssuesAfterRunAnalyze: async function ({ typeApp }) {
                let returnValue = { hasIssue: false, issueMetafieldKeys: [] };
                try {
                    // console.log("===== XXXX 0", this.analyzedData, this.finalValues);
                    if (!this.analyzedData) {
                        return returnValue;
                    }
                    let typeRun = {
                        dt: this.basicInputKeys,
                        sm: this.smInputsKeys,
                    };
                    const promises = [];
                    Object.keys(typeRun).forEach(type => {
                        if (type === "dt") {
                            const dtPromise = new Promise((resolve) => {
                                const inputKeys = typeRun[type];
                                if (!inputKeys) resolve();

                                Object.keys(this.finalValues).forEach((key) => {
                                    if (typeof this.finalValues[key] === "object") return;
                                    if (!this.isSkipInReconfirm(key, type)) {
                                        this.storeAnalyzedIssues(type, inputKeys, key);
                                    }
                                });
                                resolve();
                            });
                            promises.push(dtPromise);
                        }

                        // Create promise for SM type
                        if (type === "sm" && type === typeApp) {
                            const smPromise = new Promise((resolve) => {
                                const inputKeys = typeRun[type];
                                if (!inputKeys) resolve();

                                Object.keys(this.finalValues).forEach((key) => {
                                    if (typeof this.finalValues[key] === "object") return;
                                    if (!this.isSkipInReconfirm(key, type)) {
                                        this.storeAnalyzedIssues(type, inputKeys, key);
                                    }
                                });
                                resolve();
                            });
                            promises.push(smPromise);
                        }

                    });
                    // Create promise for DT type
                    await Promise.all(promises);

                    // Move all items with key containing "jacket_size" to the end of basicInputsWithIssue array
                    if (this.basicInputsWithIssue.length > 0) {
                        let jacketSizeItems = this.basicInputsWithIssue.filter((item) =>
                            item.key.includes("jacket_size")
                        );
                        let otherItems = this.basicInputsWithIssue.filter(
                            (item) => !item.key.includes("jacket_size")
                        );
                        this.basicInputsWithIssue = [...otherItems, ...jacketSizeItems];
                    }

                    console.log("===== XXXX 4", this.basicInputsWithIssue);
                    console.log("===== XXXX 4 analyzedData", this.analyzedData);
                    // console.log("===== XXXX 4", this.analyzedData, this.finalValues);
                    return returnValue;
                } catch (error) {
                    console.log("** Error checkInputsIssuesAfterRunAnalyze", error);
                    return returnValue;
                }
            },
            // check mg inputs issue with analyzed measurements
            checkMGInputsIssuesAfterRunAnalyze: async function ({ typeApp }) {
                let returnValue = { hasIssue: false, issueMetafieldKeys: [] };
                let arrMGkeys = Object.keys(this.mgAllProductTypesInputsArr);
                let type = 'mg';
                try {
                    if (!this.analyzedData) return returnValue;
                    const inputKeys = this.sortedInputsMGProductTypeKeys;
                    const mgPromise = new Promise((resolve) => {
                        if (!inputKeys) resolve();
                            arrMGkeys.forEach((_MGtype) => {
                                if (!this.lastChoices[_MGtype]) return;
                                Object.keys(this.lastChoices[_MGtype]).forEach((key) => {
                                    if (typeof this.lastChoices[_MGtype] === "object") {
                                        if (!this.isSkipInReconfirm(key, type)) {
                                            this.storeAnalyzedIssues(type, inputKeys, key, _MGtype);
                                        }
                                    }
                                });
                            });
                        resolve();
                    });
                    await mgPromise;

                    // Move all items with key containing "jacket_size" to the end of basicInputsWithIssue array
                    if (this.basicInputsWithIssue.length > 0) {
                        let jacketSizeItems = this.basicInputsWithIssue.filter((item) =>
                            item.key.includes("jacket_size")
                        );
                        let otherItems = this.basicInputsWithIssue.filter(
                            (item) => !item.key.includes("jacket_size")
                        );
                        this.basicInputsWithIssue = [...otherItems, ...jacketSizeItems];
                    }
                    console.log("===== XXXX 4", this.analyzedData, this.finalValues);
                    return returnValue;
                } catch (error) {
                    console.log("** Error checkInputsIssuesAfterRunAnalyze", error);
                    return returnValue;
                }
            },
            storeAnalyzedIssues(typeApp, inputKeys, key, MGtype = null) {
                let _this = this;
                let value = null;

                if (MGtype) {
                    value = DT3oTool.checkIsNumeric(_this.finalValues[MGtype][key])
                        ? parseFloat(_this.finalValues[MGtype][key])
                        : null;
                } else {
                    value = DT3oTool.checkIsNumeric(_this.finalValues[key])
                        ? parseFloat(_this.finalValues[key])
                        : null;
                }
                // Nguyen 16/04/2025 - skip if key is neck_size / pants_inseam / sleeve_length and value is < 0
                if (
                    ["neck_size", "pants_inseam", "sleeve_length"].includes(key) &&
                    (value < 0 || !value)
                )
                    return;

                //not have analyzed min, max of key
                let final_suffix = inputKeys.includes(key) ? "_" : "_final_";
                if (typeApp === "sm") {
                    final_suffix = inputKeys.includes(key) ? "_final_" : "_";
                } else if (typeApp === "mg") {
                    final_suffix = "_";
                }

                let keySD = `${key}${final_suffix}sd`;
                let keyAvg = `${key}${final_suffix}avg`;
                let keyMin1 = `${key}_min1`;
                let keyMax1 = `${key}_max1`;
                let keyMin2 = `${key}_min2`;
                let keyMax2 = `${key}_max2`;
                let keyMin3 = `${key}_min3`;
                let keyMax3 = `${key}_max3`;

                let finalSD = _this.analyzedData[keySD];
                let finalAvg = _this.analyzedData[keyAvg];

                if (typeApp === "mg" && MGtype && _this.analyzedData[MGtype]) {
                    finalSD = _this.analyzedData[MGtype][keySD];
                    finalAvg = _this.analyzedData[MGtype][keyAvg];
                }

                if (typeof finalSD === "undefined" || typeof finalAvg === "undefined") {
                    return false;
                }
                // Nguyen 22/04/2025 - update ratio as Andy idea
                const ratio1 = 1.3,
                    ratio2 = 1.53,
                    ratio3 = 2;
                finalSD = parseFloat(finalSD);
                finalAvg = parseFloat(finalAvg);
                let finalMin1 = Math.round(finalAvg - ratio1 * finalSD);
                let finalMax1 = Math.round(finalAvg + ratio1 * finalSD);
                let finalMin2 = Math.round(finalAvg - ratio2 * finalSD);
                let finalMax2 = Math.round(finalAvg + ratio2 * finalSD);
                let finalMin3 = finalAvg - ratio3 * finalSD;
                let finalMax3 = finalAvg + ratio3 * finalSD;

                // Nguyen 22/04/2025 - check key is thigh_height
                if (key === "thigh_height") {
                    finalMin1 = 11;
                    finalMax1 = 13;
                    finalMin2 = 10.01;
                    finalMax2 = 13.99;
                    finalMin3 = 9.01;
                    finalMax3 = 14.99;
                }

                // if (typeApp === 'mg') {
                //     console.log(
                //         "===== XXXX 3",
                //         key,
                //         value,
                //         finalMin1,
                //         finalMax1,
                //         finalMin2,
                //         finalMax2,
                //         finalMin3,
                //         finalMax3
                //     );
                // }

                if (
                    DT3oTool.checkIsNumeric(finalMin1) &&
                    DT3oTool.checkIsNumeric(finalMax1) &&
                    DT3oTool.checkIsNumeric(finalMin2) &&
                    DT3oTool.checkIsNumeric(finalMax2) &&
                    DT3oTool.checkIsNumeric(finalMin3) &&
                    DT3oTool.checkIsNumeric(finalMax3)
                ) {
                    if (typeApp === "mg") {
                        this.analyzedData[MGtype][keyMin1] = finalMin1;
                        this.analyzedData[MGtype][keyMax1] = finalMax1;
                        this.analyzedData[MGtype][keyMin2] = finalMin2;
                        this.analyzedData[MGtype][keyMax2] = finalMax2;
                        this.analyzedData[MGtype][keyMin3] = finalMin3;
                        this.analyzedData[MGtype][keyMax3] = finalMax3;
                    } else {
                        this.analyzedData[keyMin1] = finalMin1;
                        this.analyzedData[keyMax1] = finalMax1;
                        this.analyzedData[keyMin2] = finalMin2;
                        this.analyzedData[keyMax2] = finalMax2;
                        this.analyzedData[keyMin3] = finalMin3;
                        this.analyzedData[keyMax3] = finalMax3;
                    }
                }
                // console.log(key, finalMin2, value, finalMax2, "** key finalMin2, value, finalMax2");

                if (finalMin2 > value || value > finalMax2) {

                    let itemIssue = {
                        key,
                        originalValue: value,
                        finalSD,
                        finalMin1,
                        finalMax1,
                        finalMin2,
                        finalMax2,
                        finalMin3,
                        finalMax3,
                        finalAvg,
                    };
                    _this.finalValuesWithIssue.push(itemIssue);
                    if (_this.basicInputKeys.includes(key)) {
                        let existingItem = _this.basicInputsWithIssue.find(item => item.key === key);
                        if (!existingItem) {
                            _this.basicInputsWithIssue.push(itemIssue);
                        }
                    }
                    if (typeApp === "sm") {
                        // for sm inputs with selected body type
                        if (_this.smInputsBodyTypeKeys.includes(key)) {
                            let existingItem = _this.smInputsWithIssue.find(item => item.key === key);
                            if (!existingItem) {
                                _this.smInputsWithIssue.push(itemIssue);
                            }
                        }
                    } else if (typeApp === "mg") {
                        if (!Array.isArray(_this.mgProductTypeWithIssueInputsArr[MGtype])) _this.mgProductTypeWithIssueInputsArr[MGtype] = [];
                        _this.mgProductTypeWithIssueInputsArr[MGtype] = [..._this.mgProductTypeWithIssueInputsArr[MGtype].filter(item => item.key !== itemIssue.key), itemIssue];
                    }
                }

            },
            // function call when analyzed measurements success is false
            runAfterRunAnalyzedFailed: function ({ typeApp }) {
                this.analyzedData = null;
            },
            //Reconfirm: check order and email
            async handleFindOrder() {
                let _this = this;
                let orderNumberValue = document.getElementById(
                    "reconfirm-order-number"
                ).value;
                let emailValue = document.getElementById("reconfirm-email-address").value;
                try {
                    let bodyData = {
                        dataInfo: {
                            orderName: orderNumberValue,
                            email: emailValue,
                        },
                    };
                    let response = await fetch(
                        `${DT3oConstant.OMA_APP_URL}/app/locate-reconfirm-order`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                            },
                            method: "POST",
                            body: JSON.stringify(bodyData),
                        }
                    );

                    if (!response.ok) throw new Error(`Error: ${response.status}`);

                    let dataOrder = await response.json();
                    // console.log("===== dataOrder", dataOrder);

                    if (dataOrder.success) {
                        let rows = dataOrder.payload.rows;
                        if (rows.length) {
                            let dataOrderElement = rows[0];
                            // console.log(dataOrderElement, "==dataOrderElement");
                            SARTORO_APP_SM_RECONFIRM.reconfirmResponse = dataOrderElement;

                            // Get customer name and fill input
                            let firstName = dataOrderElement.customerInfo.first_name;
                            let lastName = dataOrderElement.customerInfo.last_name;
                            _this.inputOrderNameReconfirm = `${firstName} ${lastName}`;

                            // Get order date and fill input
                            let createAtOrder = dataOrderElement.orderInfo.created_at;
                            _this.inputOrderDateReconfirm =
                                _this.formatCreatedDate(createAtOrder);
                            _this.inputOrderDeliveryTypeReconfirm = dataOrderElement.orderInfo.badgeOfOrder.isPriority ? "priority" : dataOrderElement.orderInfo.badgeOfOrder.isRush ? "rush" : "regular";

                            // Get content message
                            let messageContent = dataOrderElement.reconfirmRequest.note;
                            _this.messageReconfirm = messageContent;

                            // Get image confirm
                            let imageConfirm = dataOrderElement.reconfirmRequest.images;
                            SARTORO_APP_SM_RECONFIRM.imageConfirm = imageConfirm;

                            // Get image confirm
                            let typeReconfirm = dataOrderElement.reconfirmRequest.typeReconfirm;
                            SARTORO_APP_SM_RECONFIRM.typeReconfirm = typeReconfirm;

                            // Get reconfirm data
                            _this.loadReconfirmDataToFinalValues({ reconfirmData: dataOrderElement.reconfirmRequest });
                        }
                        _this.textErrorOrderReconfirm = "";
                        _this.introStep().setStepActive("intro-reconfirm-details");
                    } else {
                        _this.textErrorOrderReconfirm =
                            SARTORO_APP_CONFIG.textsAndImages.reconfirmApp.reconfirmLocationOrderFindOrderNotFoundHeaderText;
                    }
                } catch (error) {
                    console.error("Error fetch API: ", error);
                }
            },
            storeReconfirmKeyByAppType(typeApp, key, mgKey = null) {
                if (!SARTORO_APP_SM_RECONFIRM.hasOwnProperty('dt')) {
                    SARTORO_APP_SM_RECONFIRM.dt = [];
                }
                if (!SARTORO_APP_SM_RECONFIRM.hasOwnProperty('sm')) {
                    SARTORO_APP_SM_RECONFIRM.sm = [];
                }
                if (!SARTORO_APP_SM_RECONFIRM.hasOwnProperty('mg')) {
                    SARTORO_APP_SM_RECONFIRM.mg = {};
                }
                if (typeApp === 'dt') {
                    SARTORO_APP_SM_RECONFIRM.dt.push(key);
                }
                if (typeApp === 'sm') {
                    SARTORO_APP_SM_RECONFIRM.sm.push(key);
                }
                if (typeApp === 'mg') {
                    if (!SARTORO_APP_SM_RECONFIRM.mg[mgKey]) {
                        SARTORO_APP_SM_RECONFIRM.mg[mgKey] = [];
                    }
                    SARTORO_APP_SM_RECONFIRM.mg[mgKey].push(key);
                }
            },
            //
            formatCreatedDate(createdAt) {
                let date = new Date(createdAt);
                let day = date.getDate();
                let month = new Intl.DateTimeFormat("en-US", { month: "long" }).format(
                    date
                );
                let year = date.getFullYear();

                let suffix = "th";
                if (day === 1) suffix = "st";
                if (day === 2) suffix = "nd";
                if (day === 3) suffix = "rd";

                return `${month} ${day}${suffix}, ${year}`;
            },
            // Nguyen changed add animation before rerender
            transitionNameNextStep: async function () {
                let _this = this;
                _this.isTransitioning = true;
                let direction = "left";
                const activeStep = document.querySelector(
                    `#${DT3oConstant.ID_DIGITAL_TAILOR_MODAL} .step--options--detail[data-big-page="${_this.currentBigPages}"]`
                );
                if (activeStep) activeStep.classList.add(`step-slide-${direction}`);
                _this.transitionName = `slide-${direction}`;
                // setTimeout(() => {
                //     _this.isTransitioning = false;
                // }, 300);
            },
            // Nguyen changed add animation before rerender
            transitionNamePrevStep: async function () {
                let _this = this;
                _this.isTransitioning = true;
                let direction = "right";
                const activeStep = document.querySelector(
                    `#${DT3oConstant.ID_DIGITAL_TAILOR_MODAL} .step--options--detail[data-big-page=${_this.currentBigPages}]`
                );
                if (activeStep) activeStep.classList.add(`step-slide-${direction}`);
                _this.transitionName = `slide-${direction}`;
                // setTimeout(() => {
                //     _this.isTransitioning = false;
                // }, 300);
            },
            transitionDTAnalyzeInputReview: function () {
                let willSlideLeft = this.transitionName === "slide-left";
                let anmEle = document.querySelector(
                    `.step--options--detail[data-big-page="${this.currentBigPages}"] .step-middle-content-wrapper`
                );
                if (anmEle) {
                    anmEle.style.transition = "none";
                    if (willSlideLeft) {
                        anmEle.style.transform = "translateX(100%)";
                        setTimeout(() => {
                            anmEle.style.transition = "transform 0.3s";
                            anmEle.style.transform = "translateX(0)";
                        }, 10);
                    } else {
                        anmEle.style.transform = "translateX(-100%)";
                        setTimeout(() => {
                            anmEle.style.transition = "transform 0.3s";
                            anmEle.style.transform = "translateX(0)";
                        }, 10);
                    }
                }
            },
            // Reconfirm final notes
            handleClickButtonYesNo(button) {
                let _this = this;
                _this.selectedButton = button;

                if (button === "btn-yes") {
                    _this.textErrorFinalNotes = "";
                    $(".reconfirm-final-notes-explanation").removeClass("error");
                }
            },
            handleSubmitFinalNotes(e) {
                let _this = this;
                let buttonNo = $(".reconfirm-final-notes-buttons .btn-no");
                let buttonYes = $(".reconfirm-final-notes-buttons .btn-yes");
                let valueExplanation = _this.valueFinalNotesExplanation;

                if (
                    (buttonNo.hasClass("selected") && valueExplanation !== "") ||
                    buttonYes.hasClass("selected")
                ) {
                    _this.textErrorFinalNotes = "";
                    $(".reconfirm-final-notes-explanation").removeClass("error");
                    _this.sendRCDataToServer();
                } else if (buttonNo.hasClass("selected") && valueExplanation === "") {
                    _this.textErrorFinalNotes =
                        "Please provide details on the date you need to receive your order.";
                    $(".reconfirm-final-notes-explanation").addClass("error");
                } else {
                    _this.textErrorFinalNotes = "Please select YES OR NO above.";
                }
            },
            // handle click on gender switch
            handleClickGender: function (value) {
                if (!value) return false;
                this.fitProfileStep().updateProfile({
                    parentKey: "info",
                    fieldName: "gender",
                    value,
                });
            },
            // handle change on "have you purchased custom..." dropdown
            handleChangeHaveYouPurchasedCustom(value) {
                this.fitProfileDetails["info"]["purchasedCustomBefore"] = value
                    ? value
                    : "";
            },
            handleMeasurementsInstructionStep() {
                let $section = jQuery(this.modalSelector).find(
                    `#Measurements-At-Home-Intro-Slider`
                );
                if ($section.length) {
                    $section.css("opacity", "0");
                    $section.css("max-height", "0");
                    $section.css("overflow", "hidden");
                }

                // Initialize slider and show section
                this.initSliderMeasurementsInstructions();
                setTimeout(() => {
                    $section.css({
                        "max-height": "unset",
                        "overflow": "unset",
                        "transition": "opacity 0.3s",
                        "opacity": "1"
                    });
                }, 100);

                // Initialize video
                DT3oTool.initVideo('[data-big-page="sm_at_home_intro"]');

                this.$set(this.flags, "isLastItemOfMeasureAtHomeIntro", false);
                // this.currentInputSM = null; // Thanh comment
            },
            checkToSetTypeAction: function () {
                if (!this.typeAction) {
                    this.typeAction = "create_fit_profile";
                    this.createNewFitProfile({});
                }
            },
            // change App by typeApp
            changeMainApp: function (typeApp, action = true, initInputs = true) {
                this.doWhenChangeMainApp(typeApp, initInputs);
                if (typeApp) {
                    this.typeApp = typeApp;
                    DT3oState.currentApp = typeApp;
                }
                if (!action) return;
                if (typeApp === "dt" && this.typeApp === "dt") {
                    this.goToPageAndInput("body_size_detail");
                }
            },
            doWhenChangeMainApp: function (typeApp, isDirect = true, initInputs = true) {
                this.checkBaseOnTypeApp(typeApp, initInputs);
                this.introStep().initStepActive();
                if (!isDirect) return;
                if (this.typeAction === "continue_fit_profile") return;
                // go to default step

                if (typeApp === "dt") {
                    this.goToPageAndInput("intro"); // default intro
                } else if (typeApp === "sm") {
                    this.goToPageAndInput("body_size_detail"); // default sm_intro
                    DT3oTool.preloadImagesSMInputs();
                } else if (typeApp === "mg") {
                    this.currentMGProductType = this.currentMGProductType || this.mgProductTypesArr[0].type;
                    this.goToPageAndInput("body_size_detail"); // default mg_intro
                    // DT3oTool.preloadImagesMGInputs();
                } else if (typeApp === "sm-reconfirm") {
                     this.goToPageAndInput("intro_reconfirm"); // default intro_reconfirm   sm_at_home_intro rc_final_notes  rc_photo_opt_out
                }
            },
            checkBaseOnTypeApp: function (typeApp, initInputs = true) {
                this.isTypeAppDT = typeApp === "dt" ? true : false;
                this.isTypeAppSM = typeApp === "sm" ? true : false;
                this.isTypeAppMG = typeApp === "mg" ? true : false;
                this.isTypeAppReconfirm = typeApp === "sm-reconfirm" ? true : false;
                this.bigPages = this.isTypeAppDT
                    ? this.bigPages_DigitalTailor
                    : this.isTypeAppSM
                    ? this.bigPages_SelfMeasure
                    : this.isTypeAppMG
                    ? this.bigPages_MeasureGarment
                    : this.bigPages_Reconfirm;
                this.progressSteps = this.isTypeAppDT
                    ? this.progressSteps_DT
                    : this.isTypeAppSM
                    ? this.progressSteps_SM
                    : this.isTypeAppMG
                    ? this.progressSteps_MG
                    : this.progressSteps_DT;
                this.keysOfBigPages = Object.keys(this.bigPages);
                if (!initInputs) return;
                if (this.isTypeAppSM ) {
                    this.addInputsToSelfMeasures();
                } else if (this.isTypeAppMG) {
                    this.addInputsToMeasureGarment();
                }
                this.setIsSkippedPhotos();
            },
            reload: function () {
                this.$forceUpdate();
            },
            setActiveClassForStep: function (page, previousPage) {
                let indexPage = this.keysOfBigPages.indexOf(page);
                let indexPreviousPage = this.keysOfBigPages.indexOf(previousPage);
                let el = jQuery(
                    `#${DT3oConstant.ID_DIGITAL_TAILOR_MODAL} .boldmetrics-page-container`
                );
                let direction = indexPage < indexPreviousPage ? "back" : "next";
                if (this.stepsNotSetActiveStep.indexOf(this.currentBigPages) === -1) {
                    el.addClass(`step-set-active active-step`);
                } else {
                    el.removeClass(`step-set-active active-step-back active-step-next`);
                }
                setTimeout(function () {
                    el.removeClass(
                        `${
                            direction === "next" ? "active-step-back" : "active-step-next"
                        }`
                    );
                }, 0);
                setTimeout(function () {
                    el.addClass(
                        `${
                            direction === "back" ? "active-step-back" : "active-step-next"
                        }`
                    );
                }, 100);
                //setTimeout(function() { el.removeClass(`active-step-back active-step-next'}`); }, 2000);
            },
            checkCurrentPhotoStepFromStateHasData: function () {
                if (this.isTypeAppReconfirm) {
                    console.log('** checkCurrentPhotoStepFromStateHasData', DT3oState.currentUploadPhotos);
                }

                return DT3oState.currentUploadPhotos[
                    DT3oState.currentUploadPhotos.currentStep
                ].current
                    ? true
                    : false;
            },
            checkCurrentPhotoStepFromState: function (step = "") {
                return DT3oState.currentUploadPhotos.currentStep === step;
            },
            getCurrentPhotoStepFromState: function () {
                return DT3oState.currentUploadPhotos.currentStep;
            },
            exportMeasurementsByTailor: function () {
                if (!jspdf) {
                    console.log("===== Error: Not Load jspdf");
                    return false;
                }
                let _this = this;
                // const { jsPDF } = jspdf;
                let fileName = "Sartoro-Measurements-By-Tailor";
                let selector = jQuery(
                    ".self-measure-measurements-by-tailor-print-container"
                )[0];
                /* Method 1 */
                const doc = new jspdf.jsPDF({
                    orientation: "portrait",
                    unit: "px",
                    format: "a4",
                    putOnlyUsedFonts: true,
                    compressPdf: true,
                    compress: true,
                    hotfixes: ["px_scaling"],
                });
                doc.html(selector, {
                    callback: function (doc) {
                        doc.save(fileName, { returnPromise: true }).then((data) => {
                            _this.$set(_this.flags, "isExportingPDF", false);
                        });
                    },
                    x: 0,
                    y: 10,
                    margin: [10, 5, 10, 5],
                    autoPaging: "text",
                    html2canvas: { scale: 1, backgroundColor: null },
                });
                // End Method 1

                /* Method 2 */
                //  const quality = 1 // Higher the better but larger file
                //   html2canvas(selector,
                //       { scale: quality }
                //   ).then(canvas => {
                //       const pdf = new jspdf.jsPDF({
                //         orientation: 'portrait',
                //         unit: 'px',
                //         format: 'a4',
                //         putOnlyUsedFonts: true,
                //         compress: true,
                //         hotfixes: ["px_scaling"],
                //       });
                //       pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 0, 0, 211, 298);
                //       pdf.save(fileName);
                //   });
                // End Method 2
            },
            setIsSkippedPhotos: function () {
                let reconfirmItem = this.getReconfirmItem;
                if (reconfirmItem) {
                    this.$set(
                        this.flags,
                        "isSkippedPhotos",
                        typeof reconfirmItem.require_photo === "undefined"
                            ? false
                            : reconfirmItem.require_photo === 0 ||
                              reconfirmItem.require_photo === false
                            ? true
                            : false
                    );
                }
            },
            // set show / hide Fit Precision for Pants, Jacket, Shirt.
            // typeStep = 'pants', 'jacket', 'shirt'
            setShowHideFitPrecision: function (typeStep) {
                try {
                    if (typeStep === "pants") {
                        this.$set(
                            this.flags,
                            "showFitPrecisionPants",
                            !this.flags.showFitPrecisionPants
                        );
                    } else if (typeStep === "jacket") {
                        this.$set(
                            this.flags,
                            "showFitPrecisionJacket",
                            !this.flags.showFitPrecisionJacket
                        );
                    } else if (typeStep === "shirt") {
                        this.$set(
                            this.flags,
                            "showFitPrecisionShirt",
                            !this.flags.showFitPrecisionShirt
                        );
                    }
                } catch (error) {
                    console.log("** Error setShowHideFitPrecision", error);
                }
            },
            // set selected value to size info: pants_size_info, jacket_size_info, shirt_size_info in finalValues
            // typeStep = 'pants', 'jacket', 'shirt'
            setSelectedValueToSizeInfo: function (typeStep, optionsItem, indexValue) {
                try {
                    if (!typeStep || !optionsItem) {
                        return null;
                    }
                    let keyOption = optionsItem.key;
                    let value = optionsItem.values[indexValue];
                    if (typeStep === "pants") {
                        this.finalValues.pants_size_info = {
                            ...this.finalValues.pants_size_info,
                            [keyOption]: value,
                        };
                    } else if (typeStep === "jacket") {
                        this.finalValues.jacket_size_info = {
                            ...this.finalValues.jacket_size_info,
                            [keyOption]: value,
                        };
                    } else if (typeStep === "shirt") {
                        this.finalValues.shirt_size_info = {
                            ...this.finalValues.shirt_size_info,
                            [keyOption]: value,
                        };
                    }
                } catch (error) {
                    console.log("** Error setSelectedValueToSizeInfo", error);
                }
            },
            // Nguyen 10/05/2025 -> set type MG in fit profile details
            setTypeMGInFitProfileDetails: function (typeMG) {
                this.selectMGProductType(typeMG, false);
                this.currentMGProductTypeProfileDetail = typeMG;
                this.doWhenChangeTypeMGInFitProfileDetails(typeMG);
            },
            doWhenChangeTypeMGInFitProfileDetails: function (typeMG) {
                let _this = this;
                this.fitProfileTabs.mgInputs = [];
                this.mgProductTypesArr.some((item) => {
                    if (item.type === typeMG) {
                        return (_this.fitProfileTabs.mgInputs = item.inputs);
                    }
                });
            },
            // Nguyen 14/04/2025 -> handle open popup input confirm
            checkValidInputSMNextStep: function () {
                console.log("** checkValidInputSMNextStep::", this.smInputsWithIssue);

                const { metafieldKey } = this.currentInputSM;
                if (!metafieldKey) return false;
                let selector = `input#measurements-at-home-item-input-${metafieldKey}[data-is-mobile="${DT3oTool.isMobile()}"]`;
                let checkValid = DT3oTool.checkValidInput(jQuery(selector));
                if (!checkValid.isValid) {
                    this.sm_at_home_input_error.isValid = false;
                    if (checkValid.reason === "empty") {
                        if (this.currentBigPages === "edit_one_input") {
                            this.edit_one_input_error.errorMsg =
                                this.edit_one_input_error.errorMsgEmpty;
                        } else {
                            this.sm_at_home_input_error.errorMsg =
                                this.sm_at_home_input_error.errorMsgEmpty;
                        }
                    } else {
                        if (this.currentBigPages === "edit_one_input") {
                            this.edit_one_input_error.errorMsg =
                                this.edit_one_input_error.errorMsgInvalid;
                        } else {
                            this.sm_at_home_input_error.errorMsg =
                                this.sm_at_home_input_error.errorMsgInvalid;
                        }
                    }
                    return false;
                }
                // Check value with analyzed data if have analyzed data
                if (
                    this.smInputsWithIssue &&
                    !this.smInputConfirmed &&
                    this.currentBigPages !== "edit_one_input"
                ) {
                    let minAnalyzedData = this.getValueAnalyzedSM(metafieldKey , 'finalMin2');
                    let maxAnalyzedData = this.getValueAnalyzedSM(metafieldKey , 'finalMax2');
                    if (minAnalyzedData && maxAnalyzedData) {
                        let value = this.valueInputSM;
                        if (value < minAnalyzedData || value > maxAnalyzedData) {
                            DT3oTool.openModalInputAnalyzeConfirm();
                            return false;
                        }
                    }
                }
                this.sm_at_home_input_error.isValid = true;
                return true;
            },
            checkValidInputMGNextStep: function () {
                const { metafieldKey } = this.currentInputMG || {};
                if (!metafieldKey) return false;

                let selector = `input#measure-garment-item-input-${metafieldKey}[data-is-mobile="${DT3oTool.isMobile()}"]`;
                let checkValid = DT3oTool.checkValidInput(jQuery(selector));

                if (!checkValid.isValid) {
                    return false;
                }

                let inputMGIsIssue = this.mgProductTypeWithIssueInputsArr[this.currentMGProductType] ?
                    this.mgProductTypeWithIssueInputsArr[this.currentMGProductType].find(
                        (item) => item.key === metafieldKey
                    ) : null;

                if (
                    inputMGIsIssue &&
                    !this.mgInputConfirmed &&
                    this.currentBigPages !== "edit_one_input"
                ) {
                    let minAnalyzedData = inputMGIsIssue["finalMin2"];
                    let maxAnalyzedData = inputMGIsIssue["finalMax2"];

                    if (minAnalyzedData && maxAnalyzedData) {
                        let value = this.valueInputMG;
                        if (value < minAnalyzedData || value > maxAnalyzedData) {
                            DT3oTool.openModalInputAnalyzeConfirm();
                            return false;
                        }
                    }
                }
                return true;
            },
            addInputsToSelfMeasures: function () {
                let _this = this;
                // console.log("========== addInputsToSelfMeasures::");

                if (SARTORO_APP_CONFIG.selfMeasureInputs !== "undefined") {
                    let inputs_raw_obj = SARTORO_APP_CONFIG.selfMeasureInputs;
                    // console.log("inputs_raw_obj::", inputs_raw_obj);

                    let reconfirmItems = SARTORO_APP_SM_RECONFIRM.sm || [];
                    let inputs_obj = [];

                    Object.keys(inputs_raw_obj).forEach((key) => {
                        if (_this.isTypeAppSM && inputs_raw_obj[key].show) {
                            // app is SM
                            inputs_obj.push(inputs_raw_obj[key]);
                        } else if (
                            _this.isTypeAppReconfirm &&
                            inputs_raw_obj[key].show &&
                            reconfirmItems &&
                            reconfirmItems.length
                        ) {
                            let found = reconfirmItems.some(
                                (input) =>
                                    input.toString().toLowerCase() ===
                                    key.toString().toLocaleLowerCase()
                            );
                            if (found) {
                                inputs_obj.push(inputs_raw_obj[key]);
                            }
                        }
                    });
                    inputs_obj.sort((a, b) => {
                        return a.order > b.order;
                    });
                    // console.log("inputs_obj::", inputs_obj);

                    inputs_obj.forEach((item, index) => {
                        // console.log("item:: addInputsToSelfMeasures", item);

                        if (!_this.isTypeAppReconfirm) {
                            _this.finalValues[item.metafieldKey] = "";
                        } else {
                            _this.finalValues[item.metafieldKey] = _this.finalValues[item.metafieldKey] || "";
                        }
                        _this.measurements[item.metafieldKey] = item;
                        _this.bigPages["sm_at_home_input"]["steps"].push(
                            item.metafieldKey
                        );
                    });
                    _this.smInputsArr = inputs_obj;
                }
            },
            getTypeShowProductTypeMG: function (productType = "") {
                try {
                    let productTypes =
                        SARTORO_APP_CONFIG["measureGarmentProductTypes"] || {};
                    let showInDt3o = productTypes["showInDt3o"] || {};
                    return showInDt3o[productType] || "inactive";
                } catch (error) {
                    console.log("===** Error getTypeShowProductTypeMG", error);
                    return "inactive";
                }
            },
            getMGProductTypesWithInputsFromDTConfig: function () {
                let productTypes = {
                    ...{},
                    ...(SARTORO_APP_CONFIG["measureGarmentProductTypes"] || {}),
                };
                let notProductTypeKeys = ["showInDt3o"];
                notProductTypeKeys.forEach((item) => delete productTypes[item]);
                return productTypes;
            },
            addInputsToMeasureGarment: function () {
                let _this = this;
                if (typeof SARTORO_APP_CONFIG.measureGarmentInputs !== "undefined") {
                    let inputs_raw_obj = SARTORO_APP_CONFIG.measureGarmentInputs;
                    let reconfirmItems = SARTORO_APP_SM_RECONFIRM.mg || [];
                    let productTypes = this.getMGProductTypesWithInputsFromDTConfig();
                    let mgTypeInputs = this.mgProductTypesArr.map((item) => item.type);
                    let inputs_obj = [];
                    Object.keys(inputs_raw_obj).forEach((key) => {
                        if (_this.isTypeAppMG && inputs_raw_obj[key].show) {
                            // app is MG
                            inputs_obj.push(inputs_raw_obj[key]);
                        } else if (
                            _this.isTypeAppReconfirm &&
                            inputs_raw_obj[key].show &&
                            reconfirmItems
                        ) {
                            inputs_obj = inputs_obj || {};
                            mgTypeInputs.map((mgType) => {
                                if (!reconfirmItems[mgType]) {
                                    inputs_obj[mgType] = [];
                                    return;
                                };
                                inputs_obj[mgType] = inputs_obj[mgType] || [];
                                reconfirmItems[mgType].map((itemRC) => {
                                    if (itemRC.toString().toLowerCase() === key.toString().toLowerCase()) {
                                        inputs_obj[mgType].push(inputs_raw_obj[key]);
                                    }
                                })
                            });
                        }
                    });

                    if (!_this.isTypeAppReconfirm) {
                        inputs_obj.sort((a, b) => {
                            return a.order > b.order;
                        });
                        Object.keys(productTypes).forEach((productTypeItem) => {
                            let _inputByProductType = [];
                            _inputByProductType = inputs_obj.filter((item, index) =>
                                productTypes[productTypeItem].find(
                                    (item2) => item2.key === item.metafieldKey
                                )
                            );
                            if (!_inputByProductType) return false;
                            _this.mgAllProductTypesInputsArr[productTypeItem] =
                                _inputByProductType;
                        });
                        _this.mgProductTypeInputsArr = _this.getSortedInputsMGProductType();

                    } else {
                        Object.keys(_this.mgAllProductTypesInputsArr).forEach((key) => {
                            _this.mgAllProductTypesInputsArr[key] = inputs_obj[key] || [];
                        })
                        // console.log(_this.mgAllProductTypesInputsArr, "** addInputsToMeasureGarment _this.mgAllProductTypesInputsArr");
                    }

                }
            },
            clickNextStepAuto: function (step) {
                setTimeout(() => {
                    /*_this.nextStep_V2();*/
                    jQuery(".btn-next-waiting-result").trigger("click");
                }, 3.5 * DT3oConstant.TIMEOUT_PROGRESS_BAR);
            },
            checkStepNeedRoundUp: function (stepName) {
                let value = false;
                this.stepsNeedConvert.some((item, index) => {
                    if (stepName === item.key && item.needRound) {
                        return (value = true);
                    }
                });
                return value;
            },
            goToPageAndInput: function (page = "", input = "") {
                if (!page) {
                    return false;
                }
                switch (page) {
                    case "fit_profile_details":
                        return (this.currentBigPages = "fit_profile_details");
                    case "mg_input":
                        return (this.currentBigPages = "mg_input");
                }
                let indexPage = this.keysOfBigPages.indexOf(page);
                if (indexPage >= 0) {
                    this.currentBigPages = page;
                    this.step = indexPage;
                    return true;
                }
                return false;
            },
            // Thanh 08/25/2023, func go to page of flags.fromStep
            goToPageAndInputFromStep: function () {
                if (!this.flags.fromStep) {
                    return false;
                }
                this.goToPageAndInput(this.flags.fromStep);
                this.flags.fromStep = ""; // remove from Step
            },
            // next image direction (front, back, rear)
            goToNextImageDirection: async function (direction = "next") {
                if (direction == "next") {
                    if (
                        this.currentPhotoStepIndex >= 0 &&
                        this.currentPhotoStepIndex < this.mainPhotoSteps.length - 1
                    ) {
                        this.currentPhotoStep =
                            this.mainPhotoSteps[++this.currentPhotoStepIndex];
                        return true;
                    }
                    this.flags.isSubmittedPhotos = true;
                    if (this.isTypeAppReconfirm) {
                        this.goToPageAndInput("rc_final_notes");
                        return
                    }
                    // for loggedin customer with profile
                    if (this.customer.loggedIn && this.fitProfileDetails.id) {
                        let resUpload = await DT3oTool.uploadPhotosOfProfileToServer({ idProfile: this.fitProfileDetails.id, typeApp: this.typeApp });
                        console.log("resUpload::", resUpload);
                        if (resUpload.success) {
                            // create images from payload
                            let images = DT3oTool.createImagesFromPayload(resUpload.payload);
                            if (images.length) {
                                this.fitProfileDetails.images = { ...this.fitProfileDetails.images, ...images };
                                let respUpdate = await DT3oTool.checkToAddOrUpdateFitProfile({ typeAction: "update", fitProfile: this.fitProfileDetails, typeApp: this.typeApp });
                            }
                        }
                    }
                    this.goToPageAndInput("create_account");
                } else {
                    if (this.currentPhotoStepIndex > 0) {
                        this.currentPhotoStep =
                            this.mainPhotoSteps[--this.currentPhotoStepIndex];
                        return true;
                    }
                    // Nguyen added 10/07/2025 for case this.previousBigPages === "intro" -> back photo to intro in account page
                    if (this.previousBigPages === "fit_profile_details") {
                        this.goToPageAndInput(this.previousBigPages);
                        return true;
                    }

                    // Nguyen added 10/07/2025 for case this.previousBigPages === "intro" -> back photo to intro in account page
                    if ( this.previousBigPages === "intro") {
                        DT3oTool.closeModal();
                        return true;
                    }

                    switch (this.typeApp) {
                        case "dt":
                            // this.goToPageAndInput("customer_input_review");
                            // break;
                        case "sm":
                        case "mg":
                        case "sm-reconfirm":
                            this.introStepActive = "photo_intro";
                        default:
                            this.goToPageAndInput("profile_creation");
                            break;
                    }
                }
            },
            // handle of clicking Confirm in Create new fit profile
            createNewFitProfile: function ({ closeGeneralModal = false }) {
                try {
                    this.typeAction = "create_fit_profile";
                    DT3oTool.clearTrackProgress();
                    DT3oTool.clearFitProfileOnLocalStorage();
                    // storage measurements
                    DT3oTool.resetSessionMeasurement();
                    let nowDate = new Date();
                    this.finalValues = Object.assign(
                        {},
                        DT3oConstant.DEFAULT_VALUES_FINAL_VALUES
                    );
                    this.fitProfileDetails = JSON.parse(
                        JSON.stringify(this.fitProfileTemplate)
                    );
                    this.fitProfileDetails.id = new Date().getTime().toString(); // timestamp of created date
                    this.fitProfileDetails.name = DT3oTool.createNameFitProfileFromDate(); // default is 'Month Day, YYYY'
                    this.fitProfileDetails.created_date = nowDate.toISOString();
                    this.fitProfileDetails.from = this.typeApp;
                    this.introStep().setStepActive('intro_dt');

                    if (this.currentBigPages !== "intro") this.goToPageAndInput("intro");
                    if (closeGeneralModal) DT3oTool.closeGeneralModal();
                } catch (error) {
                    console.log("** Error createNewFitProfile", error);
                }
            },
            // handle of continue new fit profile
            continuePartialProfile: function () {
                this.typeAction = "continue_fit_profile";
                this.fitProfileDetails = JSON.parse(
                    JSON.stringify(this.getFitProfileDetailsTemp())
                );
                // console.log(this.fitProfileDetails, "** this.fitProfileDetails");

                this.loadSelectedFitProfileToFinalValues({
                    fitProfile: this.fitProfileDetails,
                });
            },
            editFitProfile: function ({ idProfile }) {
                this.typeAction = "edit_fit_profile";
                this.fitProfileDetails = DT3oTool.getFitProfileStateById({
                    idProfile,
                    typeApp: "dt",
                });
            },
            deleteFitProfile: function ({ idProfile }) {
                this.typeAction = "delete_fit_profile";
                this.fitProfileDetails = null;
            },
            // call modal to confirm when clicking Create new fit profile
            confirmCreateNewFitProfile: function () {
                try {
                    // console.log("confirmCreateNewFitProfile");

                    this.$set(
                        this.flags,
                        "customModalType",
                        "confirmCreateNewFitProfile"
                    );
                    DT3oTool.openModalCustomSizeExit();
                } catch (error) {
                    console.log("** Error confirmCreateNewFitProfile", error);
                }
            },
            // Thanh comment 02/21/2025
            /*
            openModal: function() {
                let _this = this;
                sessionStorage.setItem('last_accessed_tool', 'boldmetrics');
                // Arn Thanh 09/11/2021
                if (!sessionStorage.getItem('boldmetrics_complete_last_step')) {
                    sessionStorage.setItem('boldmetrics_complete_last_step', 'false');
                }
                if (!_this.currentBigPages || _this.flags.isGoFirstPage) {
                    _this.currentBigPages = 'intro';
                }

                // Arn 31/10/2021
                if (DT3oTool.isMediaScreen('maxWidth767')) {
                    let currentScroll = jQuery(document).scrollTop();
                    let bodyDocument = jQuery(document.body);
                    if (bodyDocument.length > 0) {
                        jQuery(document).scrollTop(-1);
                        _this.objShowToolbarOfBrowser.position = bodyDocument.css('position');
                        setTimeout(() => {
                            bodyDocument.css({
                                "position": _this.objShowToolbarOfBrowser.position
                            });
                            jQuery(document).scrollTop(currentScroll);
                        }, 1000);
                        bodyDocument.css({ "position": "fixed", });
                    }
                }
                $.fancybox.open({
                    src: '#boldmetrics-app .boldmetrics-modal',
                    type: 'inline',
                    fullScreen: true,
                    touch: false,
                    buttons: [],
                    opts: {
                        trapFocus: true,
                        clickSlide: false,
                        clickOutside: false,
                        touch: false,
                        afterShow: function(instance, current) {
                            _this.$set(_this, 'modalOpen', !_this.modalOpen);
                        },
                        afterClose: function() {
                            _this.clearError();
                            _this.$set(_this, 'modalOpen', !_this.modalOpen);
                        }
                    }
                });
            },*/
            // Thanh comment 02/21/2025
            /*
            closeModal: function(e, reload = false) {
                $.fancybox.close();
                this.flags.fromStep = ''; // remove from Step
                if (reload) {
                    setTimeout(() => { location.reload(); }, 600);
                }
            },*/
            // Arn - 08/10/2021
            closeModal_V2: function () {
                if (
                    this.currentBigPages !== "intro" &&
                    this.currentBigPages !== "save_result" &&
                    this.currentBigPages !== "create_account" &&
                    !this.flags.savedChangedInputs &&
                    this.customer.loggedIn
                ) {
                    DT3oTool.openModalCustomSizeExit();
                    return false;
                }
                if (this.currentBigPages === "fit_guarantee" && !this.customer.loggedIn) {
                    DT3oTool.openModalCustomSizeExit();
                    return false;
                }
                if (
                    (this.currentBigPages === "result" ||
                        this.currentBigPages === "save_result") &&
                    !this.customer.loggedIn
                ) {
                    DT3oTool.openModalCustomSizeExit();
                    return false;
                }
                // show exit double confirm
                // Nguyen update 04/04/2025 - add posture_shoulder_width / posture_stance / posture_seat / posture_rise / posture_fit_preference
                if (
                    [
                        "posture_torso",
                        "posture_arm_length",
                        "posture_shoulder_width",
                        "posture_shoulder_slope",
                        "posture_stance",
                        "posture_seat",
                        "posture_rise",
                        "shoulder_width_seat",
                        "posture_fit_preference",
                        "pants_preference",
                        "additional_input",
                        "fit_preference",
                        "customer_note",
                        "customer_input_review",
                    ].indexOf(this.currentBigPages) !== -1
                ) {
                    DT3oTool.openModalCustomSizeExit();
                    return false;
                }
                $.fancybox.close();
                this.flags.fromStep = ""; // remove from Step
                this.flags.isAnchorFitProfileDetailsStep = false; // remove anchor point at fit profile details

                if (window.isProfileCreated) {
                    if (window.isFitProfileAdded)
                        window.dispatchEvent(new Event("fitProfile:updated"));
                    else {
                        window.isFitProfileAdded = true;
                        window.dispatchEvent(new Event("fitProfile:added"));
                    }
                }
            },
            resetApp: function () {
                this.currentBigPages = "intro";
                this.step = 0;
                this.typeApp = "dt";
            },
            refreshStepsSlider: function () {
                var _this = this;
                if (
                    jQuery(_this.selectors.modal)
                        .find(_this.selectors.stepsWrapper)
                        .hasClass("slick-initialized")
                ) {
                    jQuery(_this.selectors.modal)
                        .find(_this.selectors.stepsWrapper)
                        .slick("setPosition");
                }
            },
            /*
            destroyStepsSlider: function() {
                jQuery(this.selectors.modal).find(this.selectors.stepsWrapper).slick('unslick');
            },
            */
            /*
            getCurrentStep: function() {
                return jQuery('.boldmetrics-modal .slick-active').find('.step').data('step-id');
            },
            */
            // click back / measure body type button on top header
            clickBackTopHeader: function () {
                if (this.flags.isAnchorFitProfileDetailsStep) {
                    this.flags.isAnchorFitProfileDetailsStep = false;
                    this.goToPageAndInput("fit_profile_details");
                    return;
                }
                switch (this.currentBigPages) {
                    case "sm_at_home_input":
                    case "sm_profile_review":
                        if (this.isTypeAppReconfirm) {
                            this.flags.fromStep = "rc_sm_intro";
                        } else {
                            this.flags.fromStep = "sm_intro";
                        }
                        this.goToPageAndInputFromStep();
                        break;
                    case "sm_at_home_intro":
                        if (this.isTypeAppReconfirm) {
                            this.flags.fromStep = "rc_sm_intro";
                            this.goToPageAndInputFromStep();
                            break;
                        }
                        // console.log("** this.flags.isAnchorFitProfileDetailsStep", this.flags.isAnchorFitProfileDetailsStep);
                        // console.log("** this.flags.fromStep", this.flags.fromStep);

                        if (this.flags.isAnchorFitProfileDetailsStep) {
                            this.flags.isAnchorFitProfileDetailsStep = false; // remove anchor point at fit profile details step
                            this.flags.fromStep = "fit_profile_details";
                            this.goToPageAndInputFromStep();
                            break;
                        } else {
                            this.goToPageAndInput("sm_intro");
                            break;
                        }
                    case "mg_profile_review":
                        this.flags.fromStep = "mg_intro";
                        this.goToPageAndInputFromStep();
                        break;
                    case "fit_profile_details":
                        this.closeModalAll();
                        break;
                    default:
                        if (this.flags.fromStep) {
                            this.goToPageAndInputFromStep();
                        } else {
                            this.previousStep_V2();
                        }
                        break;
                }
            },
            /*
            stepError: function() {
            },
            */
            clearError: function () {
                var _this = this;
                _this.$set(_this.error, "message", "");
                _this.$set(_this.error, "active", false);
                setTimeout(_this.refreshStepsSlider, 0);
            },
            /*
            setError: function(valid, message) {
                var _this = this;
                _this.$set(_this.error, 'message', !valid ? message : '');
                _this.$set(_this.error, 'active', !valid);
                setTimeout(_this.refreshStepsSlider, 0);
            },
            */
            trackCompletion: function () {
                var _this = this;
                sessionStorage.setItem("measurement_complete", "boldmetrics");
                sessionStorage.setItem("measurement_complete_timestamp", new Date());
                sessionStorage.setItem(
                    "measurement_complete_loggedin",
                    _this.customer.loggedIn
                );
            },
            // autoAdvance: function() {
            //     var _this = this;
            //     setTimeout(function() {
            //         _this.hideStepInfo();
            //         _this.nextStep();
            //     }, 500);
            // },

            // changeUnit: function(e, units, unit) {
            //     this.units.selected = unit;
            //     this.clearError();
            //     setTimeout(this.refreshStepsSlider, 150);
            // },

            // Thanh comment 01/21/2025
            /*
            boldmetricsApi: function() {
                var _this = this;
                var client = 'notuse';
                var apiKey = 'notuse';
                var weight = _this.measurementValues.weight;
                var height = _this.measurementValues.height;
                var waist_size = _this.measurementValues.waist_size;
                var waist_size_post_api = typeof waist_size === 'number' ? waist_size + 2.7 : parseFloat(waist_size) + 2.7; // Arn Thanh 21/12/2021
                var shoe_size = _this.measurementValues.shoe_size;
                var jacket_size = _this.measurementValues.jacket_size;
                var neck_size = _this.measurementValues.neck_size;
                var sleeve_length = _this.measurementValues.sleeve_length;
                var pants_inseam = _this.measurementValues.pants_inseam;
                var age = _this.measurementValues.age;
                var url = `https://api.boldmetrics.io/virtualtailor/get?client_id=${client}&user_key=${apiKey}&weight=${weight}&height=${height}&waist_circum_preferred=${waist_size_post_api}&age=${age}`;
                if (shoe_size !== 'n/a') {
                    url += `&shoe_size_us=${shoe_size}`;
                }

                if (neck_size !== 'n/a') {
                    url += `&neck_circum_base=${neck_size}`;
                }

                if (sleeve_length !== 'n/a') {
                    url += `&sleeve=${sleeve_length}`;
                }

                url += `&sleeve_type=ARS`;
                if (pants_inseam !== 'n/a') {
                    url += `&jean_inseam=${pants_inseam}`;
                }
                console.log(url);

                // return false;

                $.getJSON(url).then(function(data) {
                    console.log(data);
                    _this.$set(_this, 'boldmetricsData', data);
                    _this.saveBoldmetricsData();
                });
            },
            */

            // Thanh comment 01/21/2025
            /*
            saveBoldmetricsData: function() {
                var _this = this;
                var dimensions = _this.boldmetricsData.dimensions;
                var map_data = {
                    neck: DT3oTool.roundUp(dimensions.neck_circum_larynx),
                    chest: DT3oTool.roundUp(dimensions.chest_circum),
                    upper_waist: DT3oTool.roundUp(dimensions.waist_circum_natural),
                    belly: DT3oTool.roundUp(dimensions.waist_circum_stomach),
                    bicep: DT3oTool.roundUp(dimensions.biceps_circum),
                    shoulder: DT3oTool.roundUp(dimensions.fm_shoulder),
                    arm_length: DT3oTool.roundUp(dimensions.arm_len_shoulder_wrist),
                    // jacket_length: DT3oTool.roundUp(dimensions.shirt_len_tucked_2),
                    jacket_length: DT3oTool.roundUp(dimensions.cervical_height / 2), // Thanh 21/12/2021
                    beltline: DT3oTool.roundUp(dimensions.waist_circum_preferred),
                    hips: DT3oTool.roundUp(dimensions.hip_circum),
                    crotch: DT3oTool.roundUp(dimensions.u_crotch),
                    thigh: DT3oTool.roundUp(dimensions.thigh_circum_proximal),
                    thigh_height: DT3oTool.roundUp(dimensions.jean_inseam),
                    calf: DT3oTool.roundUp(dimensions.thigh_circum_distal),
                    //calf_height: '',
                    pants_outseam: DT3oTool.roundUp(dimensions.waist_height_preferred)
                };
                //console.log(map_data);

                var map_api_data = [];
                _.each(map_data, function(value, key) {
                    _this.$set(_this.measurements, `api_${key}`, {
                        name: `api_${key}`,
                        value: value
                    });

                    map_api_data.push({
                        name: key,
                        value: value
                    });
                });
                console.log(map_api_data);

                map_api_data.forEach(function(item, index) {
                    setSessionMeasurement(`boldmetrics_api_${item.name}`, _this.measurementValues[`api_${item.name}`]);
                });

                // Arn 20/10/2021
                _this.$set(_this.flags, 'doneBoldmetricsAPI', true);
                if (!_this.flags.doneBoldmetricsAPI) {
                    // _this.nextStep_V2();
                }

                // Thanh comment 19/05/2022
                if (_this.customer.loggedIn) {
                    // let index = 0;
                    // const timeoutRequest = 600; //ms - Arn 20/08/2021

                    // async.each(map_api_data, function(item, callback) {
                    //   let timeout = index * timeoutRequest
                    //   ++index
                    //   // console.log(timeout, index)
                    //   setTimeout(() => {
                    //   _this.saveMeasurementMetafield(`boldmetrics_api_${item.name}`)
                    //   .then(function() {
                    //     callback();
                    //   })
                    //   }, timeout)
                    // }, function(err) {
                    //   if (err) {
                    //     console.error(err);
                    //   }
                    //   setTimeout(() => { _this.editTestPage(); }, timeoutRequest );
                    //   // After all done
                    //   //console.log('All Saved!');
                    // });
                }
            },
            */
            saveMeasurement: function (model, notSaveWhenLogin = false) {
                setSessionMeasurement(model, this.measurementValues[model]);
                if (this.customer.loggedIn && !notSaveWhenLogin) {
                    this.saveMeasurementMetafield(model);
                }
            },
            saveMeasurementMetafield: async function (model) {
                var _this = this;
                var key = model;
                var value = getSessionMeasurement(key);
                if (!key || !value) {
                    return false;
                }
                var data = {
                    resourceType: "customers",
                    resourceID: _this.customer.id,
                    namespace: "measurement_data",
                    key: key,
                    value: value,
                    value_type: "string",
                };

                _this.$set(_this.flags, "saving", true);

                return new Promise(function (resolve, reject) {
                    _this
                        .saveMetafieldData(data)
                        .then(function (data) {
                            _this.$set(_this.flags, "saving", false);
                            resolve(data);
                        })
                        .catch(function (error) {
                            reject(error);
                        });
                });
            },

            saveMetafieldData: function (payload) {
                //console.log(payload);
                return new Promise(function (resolve, reject) {
                    $.ajax({
                        type: "POST",
                        url: `${remoteAppUrl}/postMetafields`,
                        data: payload,
                        dataType: "json",
                        success: function (data) {
                            console.log({ payload, data });
                            resolve(data);
                        },
                        error: function (error) {
                            console.error(error);
                            reject(error);
                        },
                    });
                });
            },

            saveAllMeasurements: function () {
                var _this = this;
                var models = [];
                _.each(_this.measurementValues, function (model, key) {
                    models.push(key);
                });
                let index = 0;
                const timeoutRequest = 600; //ms Arn 20/08/2021
                // need async-3.2.0.min.js
                async.each(
                    models,
                    function (model, callback) {
                        let timeout = index * timeoutRequest;
                        ++index;
                        // console.log(timeout, index)
                        setTimeout(() => {
                            _this.saveMeasurementMetafield(model).then(function () {
                                callback();
                            });
                        }, timeout);
                    },
                    function (err) {
                        if (err) {
                            console.log(err);
                        }

                        // After all done
                        console.log("All Measurements Saved!");

                        // after all metafields saved, clear recent login overlay
                        sessionStorage.removeItem("measurement_complete_loggedin");

                        sessionStorage.setItem("measurements_saved_boldmetrics", true);

                        _this.savePreference();

                        var isSessionMeasurement =
                            sessionStorage.getItem("redirect_url") !== null;
                        if (isSessionMeasurement) {
                            window.location.href = sessionStorage.getItem("redirect_url");
                            sessionStorage.removeItem("redirect_url");
                        }
                    }
                );
            },

            editTestPage: function () {
                let _this = this;
                if (!_this.customer.loggedIn) {
                    return false;
                }
                let payload = { themeId: DT3oConstant.SHOPIFY_THEME_ID };
                return new Promise(function (resolve, reject) {
                    $.ajax({
                        type: "POST",
                        url: `${remoteAppUrl}/editTestPage`,
                        // url: `http://thanhbp-shopify-1987.ap.ngrok.io/storefront/editTestPage`,
                        data: payload,
                        dataType: "json",
                        success: function (data) {
                            console.log({ payload, data });
                            resolve(data);
                        },
                        error: function (error) {
                            console.error(error);
                            reject(error);
                        },
                    });
                });
            },

            addCustomerMeasuredTag: function () {
                var _this = this;

                var customer = {
                    customer_id: _this.customer.id,
                    tags: ["measured"],
                };

                return new Promise(function (resolve, reject) {
                    $.ajax({
                        type: "POST",
                        url: `${remoteAppUrl}/addCustomerTags`,
                        data: customer,
                        dataType: "json",
                        success: function (data) {
                            //console.log(data);
                            resolve(data);
                        },
                        error: function (error) {
                            console.error(error);
                            reject(error);
                        },
                    });
                });
            },

            valueEntered(e, model) {
                var _this = this;
                jQuery(e.currentTarget).closest("fieldset").removeClass("error");
                model.isValid = true;
                _this.clearError();
                _this.hideStepInfo();
            },

            savePreference: function () {
                var _this = this;
                var data = {
                    resourceType: "customers",
                    resourceID: _this.customer.id,
                    namespace: "measurement_data",
                    key: "preference",
                    value: "boldmetrics",
                    value_type: "string",
                };

                _this
                    .saveMetafieldData(data)
                    .then(function (data) {})
                    .catch(function (error) {
                        console.error(error);
                    });
            },

            saveLastDateTheDigitalTailor: function () {
                let _this = this;
                let dateDT = new Date();
                let data = {
                    resourceType: "customers",
                    resourceID: _this.customer.id,
                    namespace: "measurement_all",
                    key: "digital_tailor_date",
                    value: dateDT.toISOString(),
                    value_type: "string",
                };
                _this
                    .saveMetafieldData(data)
                    .then(function (data) {})
                    .catch(function (error) {
                        console.error(error);
                    });
            },

            toggleStepInfo: function (e) {
                jQuery(e.target)
                    .closest(".boldmetrics--step")
                    .find(".measurements__info")
                    .toggleClass("active");
                jQuery(e.target)
                    .closest(".boldmetrics--step")
                    .find(".tooltip-overlay")
                    .toggleClass("active");
            },

            hideStepInfo: function (e) {
                var isToolTipActive = jQuery(".measurements__info").hasClass("active");
                if (isToolTipActive) {
                    jQuery(".measurements__info").removeClass("active");
                    jQuery(".tooltip-overlay").removeClass("active");
                }
            },
            // close all modals
            closeModalAll: function () {
                $.fancybox.close(true);
                this.flags.fromStep = ""; // remove from Step
                this.flags.isAnchorFitProfileDetailsStep = false; // remove anchor point at fit profile details step
                this.$set(this.flags, "customModalType", "confirmExitOrSaveData");
            },
            //
            initSliderMeasurementsInstructions: function () {
                let _this = this;
                // let $section = jQuery(_this.modalSelector).find(`[data-big-page="${_this.currentBigPages}"] #Measurements-At-Home-Intro-Slider`);
                let $section = jQuery(_this.modalSelector).find(
                    `#Measurements-At-Home-Intro-Slider`
                );
                if ($section.length) {
                    // Set initial opacity to 0
                    $section.css("opacity", "0");
                    $section.on("afterChange", function (slick, currentSlide, nextSlide) {
                        if (currentSlide.currentSlide === currentSlide.slideCount - 1) {
                            _this.$set(
                                _this.flags,
                                "isLastItemOfMeasureAtHomeIntro",
                                true
                            );
                            return true;
                        }
                    });
                    $section.slick({
                        speed: 200,
                        arrows: false,
                        swipe: true,
                        swipeToSlide: true,
                        adaptiveHeight: true,
                        infinite: true,
                        accessibility: false,
                        dots: true,
                        cssEase: "ease",
                        easing: "linear",
                    });

                }
            },
            // init slider for customer reviews at waiting result
            initSliderCustomerReview: function () {
                let _this = this;
                let isMobile = DT3oTool.isMobile();

                let $section = jQuery(_this.modalSelector).find(
                    ".customer-reviews-wrapper"
                );
                if ($section.length) {
                    $section.slick({
                        slidesToShow: isMobile ? 1 : 2,
                        speed: 100,
                        arrows: false,
                        swipe: true,
                        swipeToSlide: true,
                        infinite: true,
                        accessibility: false,
                        dots: isMobile ? true : false,
                        cssEase: "ease",
                        easing: "linear",
                    });
                }
            },
            // destroy slider for customer reviews at waiting result
            destroySliderCustomerReview: function () {
                let _this = this;
                let $section = jQuery(_this.modalSelector).find(
                    ".customer-reviews-wrapper"
                );
                if ($section.length && typeof $section.slick === "function") {
                    try {
                        $section.slick("unslick");
                    } catch (error) {}
                }
            },
            // Arn - 08/10/2021
            postureStepIsSelected: function (e, step = "", index = 0) {
                // Nguyen 22/04/2025 updated to remove active class from all items
                this.isTransitioning = true;
                let isAutoNextSteps = this.stepsHideNextBtnBodyProportions.map(item => `body_${item}`).includes(step);
                let isFromFitProfileDetails = this.currentEditStep['fromStep'] === "fit_profile_details";
                isAutoNextSteps = isFromFitProfileDetails ? false :isAutoNextSteps;
                let $radio = jQuery(e.currentTarget);
                $radio
                    .closest("fieldset")
                    .find("div.measurements__optionList__item")
                    .removeClass("active")
                $radio
                    .closest("div.measurements__optionList__item")
                    .addClass("active")
                this.updatePostureValue(step, $radio.val());
                if (isAutoNextSteps) {
                    const nextBtn = document.querySelector(`.js-next-btn[data-current-big-page="${this.currentBigPages}"]`);
                    if (nextBtn) {
                        nextBtn.style.visibility = 'hidden';
                        nextBtn.style.opacity = '0';
                    }
                }

                setTimeout(
                    () => {
                        if (isAutoNextSteps) {
                            this.transitionNameNextStep();
                            const nextBtn = document.querySelector(`.js-next-btn[data-current-big-page="${this.currentBigPages}"]`);
                            if (nextBtn) {
                                nextBtn.style.removeProperty('visibility');
                                nextBtn.style.removeProperty('opacity');
                                nextBtn.classList.add('hide-ui');
                            }
                        }

                        setTimeout(() => {
                            if (isAutoNextSteps) this.nextStep_V2();
                        }, isAutoNextSteps ? 300 : 0);
                    },
                    isAutoNextSteps ? 700 : 0
                );
            },
            // Arn - 08/10/2021
            postureStepPreferredLengthIsSelected(e, idx) {
                let items = document.querySelectorAll(".jsOptItem");
                let itemTexts = document.querySelectorAll(".jsOptItemText");
                items.forEach(item => {
                    parseInt(item.dataset.index) === parseInt(idx) ? item.classList.add("active") : item.classList.remove("active");
                });
                itemTexts.forEach(item => {
                    parseInt(item.dataset.index) === parseInt(idx) ? item.classList.add("active") : item.classList.remove("active");
                });
            },
            saveGarmentNote(e) {
                let modal = document.querySelector(".jsModalGarmentNote");
                if (!modal) return;

                let garmentType = modal.dataset.type || "";
                garmentType = garmentType === "sm" ? "body" : "garment";
                let note = modal.querySelector(`.jsGarmentNoteInput[data-type="${garmentType === 'body' ? 'sm' : 'mg'}"]`)?.value || "";
                this.fitProfileDetails["info"][`${garmentType}_measurement_note`] = note;
                DT3oTool.updateValuesFitProfileToLocal_Caller({ idProfile: this.fitProfileDetails.id, parentKey: 'info', targetKey: `${garmentType}_measurement_note`, value: note });
                DT3oTool.closeModalInfoInput();
            },

            // Arn - 11/10/2021
            afterCreateCustomerHanlder: function () {
                let _this = this;
                sessionStorage.setItem("boldmetrics_complete_last_step", "true");
                sessionStorage.removeItem("measurement_complete_loggedin");
                sessionStorage.setItem("measurements_saved_boldmetrics", true);
                var islastAccessed =
                    sessionStorage.getItem("last_accessed_tool") == "boldmetrics";
                // var allSaved = sessionStorage.getItem('measurements_saved_boldmetrics') == 'true';
                if (islastAccessed /* && !allSaved */ && !_this.customer.loggedIn) {
                    setTimeout(() => {
                        _this.savePreference();
                    }, DT3oConstant.TIMEOUT_POST_METAFIELD);
                    setTimeout(() => {
                        _this.addCustomerMeasuredTag();
                    }, DT3oConstant.TIMEOUT_POST_METAFIELD * 2);
                    setTimeout(() => {
                        _this.saveAllMeasurements_V2("register");
                    }, DT3oConstant.TIMEOUT_POST_METAFIELD * 3); // backup method post all metafields to new customer
                }
                if (typeof updateCreateYourSizeWhenSaved_Arn === "function") {
                    updateCreateYourSizeWhenSaved_Arn();
                }
            },

            // Arn - 11/10/2021
            showOnlyOnePage: function (page, step = {}) {
                let _this = this;
                let indexPage = _this.keysOfBigPages.indexOf(page);
                if (indexPage >= 0) {
                    _this.currentBigPages = page;
                    _this.step = indexPage;
                    _this.isShowOnlyOnePage = true;
                    jQuery(".js-boldmetrics-link").trigger("click");
                } else {
                    _this.isShowOnlyOnePage = false;
                }
            },

            // Arn - 12/10/2021
            relaunchBoldmetricsModal: function (e, page = "intro") {
                let _this = this;
                let indexPage =
                    _this.keysOfBigPages.indexOf(page) >= 0
                        ? _this.keysOfBigPages.indexOf(page)
                        : 0;
                _this.step = indexPage;
                _this.currentBigPages = _this.keysOfBigPages[indexPage];
                _this.isShowOnlyOnePage = false;
                jQuery(".js-boldmetrics-link").trigger("click");
            },

            // Arn - 12/10/2021
            saveEditProportion: function (e) {
                let _this = this;
                let timeout = DT3oConstant.TIMEOUT_POST_METAFIELD;
                let isValid = true;

                let container = jQuery(".boldmetrics-edit-body-proportion-modal")
                    .find(".body-proportion-modal__items")
                    .first();

                _this.stepBodyProportions.forEach((step, index) => {
                    let item = container.find(
                        `.body-proportion-modal__item_options[data-step='${step}']`
                    );
                    // console.log(step, item.val(), _this.measurements[step].value);
                    item.removeClass("error-shake");
                    if (!item.val() || _this.measurements[step].value === "") {
                        item.addClass("error-shake");
                        isValid = false;
                    }
                });

                if (!isValid) {
                    return false;
                } else {
                    _this.bodyProportionRequest.numberRequest =
                        _this.stepBodyProportions.length;
                    _this.stepBodyProportions.forEach((step, index) => {
                        setTimeout(() => {
                            _this.saveMeasurement_V2(
                                step,
                                "edit_body_proportion_account_page"
                            );
                            ++_this.bodyProportionRequest.numberRequestSend;
                        }, index * timeout);
                    });
                    setTimeout(() => {
                        _this.editTestPage();
                    }, (_this.stepBodyProportions.length + 2) * timeout);
                }
            },

            // Arn - 18/10/2021
            saveMetafieldForSelfMeasurement: function (key, value) {
                let _this = this;
                var data = {
                    resourceType: "customers",
                    resourceID: _this.customer.id,
                    namespace: "measurement_data",
                    key: key,
                    value: value,
                    value_type: "string",
                };

                return new Promise(function (resolve, reject) {
                    _this
                        .saveMetafieldData(data)
                        .then(function (data) {
                            ++_this.selfMeasurementRequest.numberRequestDone;
                            if (data.metafield) {
                                let metafield = data.metafield;
                                setSessionMeasurement(metafield.key, metafield.value);
                                jQuery(
                                    `.boldmetrics-account-measurement-edit-self-measurement-item-text[data-step="${metafield.key}"]`
                                ).text(
                                    `${metafield.value} ${
                                        DT3oTool.checkIsNumeric(metafield.value)
                                            ? '"'
                                            : ""
                                    }`
                                );
                            }
                            if (
                                _this.selfMeasurementRequest.numberRequest ===
                                _this.selfMeasurementRequest.numberRequestDone
                            ) {
                                _this.selfMeasurementRequest.numberRequest = 0;
                                _this.selfMeasurementRequest.numberRequestDone = 0;
                                _this.selfMeasurementRequest.numberRequestSend = 0;
                                DT3oTool.closeModal();
                                _this.getAllSelfMeasureBeforeEdit();
                            }

                            resolve();
                        })
                        .catch(function () {
                            reject();
                        });
                });
            },

            // Arn - 18/10/2021
            saveEditSelfMeasurement: function (e) {
                e.preventDefault();
                let _this = this;
                let timeout = DT3oConstant.TIMEOUT_POST_METAFIELD;
                let isValid = true;
                let items = [];

                let container = jQuery(".boldmetrics-edit-self-measurement-modal")
                    .find(".boldmetrics-edit-modal__items")
                    .first();
                // console.log(_this.customer.id);
                _this.stepSelfMeasurements.forEach((step, index) => {
                    let item = container.find(
                        `input.boldmetrics-edit-modal__item_value[data-step='${step.key}']`
                    );
                    // console.log(step.key, item.val());
                    items.push({ key: step.key, value: item.val() });
                    item.removeClass("error-shake");
                    let itemVal = item.val();
                    if (
                        _this.checkHasChangeForSelfMeasureEle(items[items.length - 1]) &&
                        itemVal != "" &&
                        (!itemVal ||
                            !DT3oTool.checkIsNumeric(itemVal) ||
                            parseInt(itemVal) <
                                DT3oConstant.MIN_VALUE_STEP_SELF_MEASURE ||
                            parseInt(itemVal) >= DT3oConstant.MAX_VALUE_STEP_SELF_MEASURE)
                    ) {
                        item.addClass("error-shake");
                        isValid = false;
                    }
                });

                if (!isValid) {
                    return false;
                } else {
                    container
                        .find(`input.boldmetrics-edit-modal__item_value`)
                        .prop("disabled", true);
                    _this.selfMeasurementRequest.numberRequest = 0;
                    items.forEach((item, index) => {
                        if (
                            !_this.checkHasChangeForSelfMeasureEle(item) ||
                            item.value.toString().trim() == ""
                        ) {
                            return false;
                        }
                        ++_this.selfMeasurementRequest.numberRequest;
                        setTimeout(() => {
                            ++_this.selfMeasurementRequest.numberRequestSend;
                            _this.saveMetafieldForSelfMeasurement(
                                item.key,
                                DT3oTool.roundUp(item.value)
                            );
                        }, index * timeout);
                    });
                    setTimeout(() => {
                        _this.editTestPage();
                    }, (items.length + 2) * timeout);
                }
            },

            // Arn - 21/10/2021
            saveEditProportion_Callback: function (data) {
                let _this = this;
                ++_this.bodyProportionRequest.numberRequestDone;
                if (data.metafield) {
                    let metafield = data.metafield;
                    jQuery(
                        `.boldmetrics-account-measurement-edit-proportion-item-text[data-step="${metafield.key}"]`
                    ).text(metafield.value);
                }

                if (
                    _this.bodyProportionRequest.numberRequestDone ===
                    _this.bodyProportionRequest.numberRequest
                ) {
                    _this.bodyProportionRequest.numberRequestSend = 0;
                    _this.bodyProportionRequest.numberRequestDone = 0;
                    _this.bodyProportionRequest.numberRequest = 0;
                    _this.getAllSelfMeasureBeforeEdit();
                    DT3oTool.closeModal();
                }
            },

            // Arn - 21/10/2021
            saveEditFitPreference_Callback: function (data) {
                let _this = this;
                if (data.metafield) {
                    let metafield = data.metafield;
                    jQuery(`.boldmetrics-account-measurement-fit-preference-value`).text(
                        metafield.value
                    );
                    jQuery(
                        ".boldmetrics-account-measurement-fit-preference-content"
                    ).trigger("click");
                }
                DT3oTool.closeModal();
            },

            // Arn - 20/01/2022
            getAllSelfMeasureBeforeEdit: function () {
                let _this = this;
                _this.selfMeasurementBeforeEdit = {};
                _this.stepSelfMeasurements.forEach((step, index) => {
                    _this.selfMeasurementBeforeEdit[step.key] = getSessionMeasurement(
                        step.key
                    );
                });
            },

            checkHasChangeForSelfMeasureEle: function (step = null) {
                let _this = this;
                if (
                    !step ||
                    typeof _this.selfMeasurementBeforeEdit[step.key] === "undefined" ||
                    _this.selfMeasurementBeforeEdit[step.key] !== step.value
                ) {
                    return true;
                } else {
                    return false;
                }
            },

            checkValidValuePostureAndSaveWhenNextStep: function (redirect = true) {
                let _this = this;
                let stepsInPage = _this.bigPages[_this.currentBigPages].steps;
                let error_obj = { isValid: false, message: "" };
                let notSaveWhenLogin = true;
                for (let i = 0; i < stepsInPage.length; i++) {
                    let step = stepsInPage[i];
                    if (!_this.finalValues[step]) {
                        error_obj.isValid = false;
                        error_obj.message = "invalidValue";
                        return error_obj;
                    }
                    _this.measurements[step].value = _this.finalValues[step];
                    setTimeout(() => {
                        _this.savePostureInputValueSessionAndProfile({ inputKey: step, notSaveMetafieldWhenLogin: true });

                        if (this.flags.fromStep !== "" && redirect) {
                            this.goToPageAndInputFromStep();
                            return true;
                        }
                    }, i * DT3oConstant.TIMEOUT_SET_SESSION);
                }
                error_obj.isValid = true;
                return error_obj;
            },

            // Task 10423
            checkValidAllInputs: function (
                inputs = [],
                options = { addClassError: true, showErrorMessage: true }
            ) {
                let type = "unit";
                let errors = [];
                let numberValidItems = 0;
                $.each(inputs, (index, item) => {
                    let checkValid = DT3oTool.checkValidInput(jQuery(item));
                    if (!checkValid.isValid) {
                        if (options.showErrorMessage) {
                            type = "error";
                        }
                        errors.push(index);
                        if (options.addClassError) {
                            jQuery(item).addClass("error");
                        }
                    } else {
                        jQuery(item).removeClass("error");
                        ++numberValidItems;
                    }
                });
                console.log(
                    "=====",
                    inputs.length,
                    errors.length === 0,
                    numberValidItems === inputs.length
                );
                if (errors.length === 0 && numberValidItems === inputs.length) {
                    type = "checkbox";
                }
                this.measurements_by_tailor_input_error.type = type;
                return errors.length ? false : true;
            },
            // Nguyen 18/04/2025 updated current edit step
            setCurrentEdit1InputStep: function (currentBigPages = "", value = null) {
                this.currentEditStep = {
                    isEditOneInput: true,
                    oldValue: value,
                    fromStep: currentBigPages,
                };
            },

            clearCurrentEditStep: function () {
                this.currentEditStep = {
                    isEditOneInput: false,
                    oldValue: null,
                    fromStep: "",
                };
            },
            handleBackNextSMInput: function (isNext = true) {
                // set before step Basic is only on SM
                if (this.typeApp === "sm" || this.isTypeAppReconfirm) {
                    this.beforeStepBasicOfSM = this.currentBigPages;
                    this.currentInputBeforeStepBasicOfSM = this.currentInputSM;
                }

                this.bigPages["sm_at_home_input"].progressStep = isNext
                    ? this.currentInputSMIndex + 1
                    : this.currentInputSMIndex - 1;

                let { metafieldKey } = this.currentInputSM;
                let foundIndex = this.smInputsBodyTypeArr.findIndex((element, index) => {
                    return element.metafieldKey === metafieldKey;
                });
                console.log("foundIndex::", foundIndex);

                // Nguyen 15/04/2025 updated to go to intro sm when found index is 0
                if (!isNext && foundIndex == 0) {
                    this.goToPageAndInput("sm_intro");
                    return true;
                }
                if (foundIndex > -1) {
                    this.lastChoices[metafieldKey][this.selectedUnit] = this.valueInputSM;
                    this.finalValues[metafieldKey] = this.unitIsUsUk
                        ? this.valueInputSM
                        : DT3oTool.convertCmToInches(this.valueInputSM, true);
                    this.convertOtherUnitType(metafieldKey, this.selectedUnit);
                    setSessionMeasurement(metafieldKey, this.valueInputSM);

                    if (isNext && foundIndex < this.smInputsBodyTypeArr.length - 1) {
                        this.currentInputSM =
                            this.smInputsBodyTypeArr[foundIndex + 1];
                        return true;
                    }

                    if (!isNext && foundIndex <= this.smInputsBodyTypeArr.length) {
                        this.currentInputSM =
                            this.smInputsBodyTypeArr[foundIndex - 1];
                        return true;
                    }
                }
                return false;
            },
            // Nguyen 05/06/2025 convert other unit type
            convertOtherUnitType: function (keyInput, unit) {
                let unitTypes = ["us", "eu", "metric", "uk", "aus"];
                let remainUnitTypes = unitTypes.filter((item) => item !== unit);
                remainUnitTypes.forEach((unitType) => {
                    let convert = DT3oInitialTool.convertValueToOtherUnits({
                        keyInput,
                        value: this.lastChoices[keyInput][unit],
                        unit: unit,
                        values: unitTypes,
                    });
                    this.lastChoices[keyInput][unitType] = convert[unitType];
                });
            },
            handleBackNextMGInput: function (isNext = true) {
                this.bigPages["mg_input"].progressStep = isNext
                    ? this.currentInputMGIndex + 1
                    : this.currentInputMGIndex - 1;
                let { metafieldKey } = this.currentInputMG;
                let foundIndex = this.mgProductTypeInputsArr.findIndex(
                    (element, index) => {
                        return element.metafieldKey === metafieldKey;
                    }
                );
                // Nguyen 18/04/2025 updated to go to intro mg when found index is 0
                if (!isNext && foundIndex == 0) {
                    this.goToPageAndInput("mg_intro");
                    return true;
                }
                if (foundIndex > -1) {
                    if (!this.lastChoices[this.currentMGProductType][metafieldKey]) {
                        this.lastChoices[this.currentMGProductType][metafieldKey] = {
                            us: "",
                            metric: "",
                            eu: "",
                            uk: "",
                            aus: "",
                        };
                    }
                    if (
                        typeof this.finalValues[this.currentMGProductType] === "undefined"
                    ) {
                        this.finalValues[this.currentMGProductType] = "";
                    }
                    this.finalValues[this.currentMGProductType][metafieldKey] = this.valueInputMG;

                    // Initialize garment_inputs if it doesn't exist
                    if (!this.fitProfileDetails["garment_inputs"]) {
                        this.fitProfileDetails["garment_inputs"] = {};
                    }

                    // Initialize the specific product type as an object if it doesn't exist
                    if (!this.fitProfileDetails["garment_inputs"][this.currentMGProductType]) {
                        this.fitProfileDetails["garment_inputs"][this.currentMGProductType] = {};
                    }

                    // Set the value for the specific metafield key
                    this.fitProfileDetails["garment_inputs"][this.currentMGProductType][metafieldKey] = this.valueInputMG;
                    if (isNext) {
                        if (foundIndex < this.mgProductTypeInputsArr.length - 1) {
                            this.currentInputMG =
                                this.mgProductTypeInputsArr[foundIndex + 1];
                            return true;
                        }
                    } else {
                        if (foundIndex > 0) {
                            this.currentInputMG =
                                this.mgProductTypeInputsArr[foundIndex - 1];
                            return true;
                        }
                    }
                }
                return false;
            },
            handleBackNextAnalyzeInputReview: function (isNext = true) {
                let nextIndexCurrentBasic = -1;

                if (
                    isNext &&
                    this.currentBasicInputHasIssueIndex <
                        this.basicInputsWithIssue.length - 1
                ) {
                    nextIndexCurrentBasic = this.currentBasicInputHasIssueIndex + 1;
                }
                if (!isNext && this.currentBasicInputHasIssueIndex > 0) {
                    nextIndexCurrentBasic = this.currentBasicInputHasIssueIndex - 1;
                }
                console.log("nextIndexCurrentBasic::", nextIndexCurrentBasic);

                if (nextIndexCurrentBasic > -1) {
                    this.currentBasicInputHasIssue = {
                        ...this.measurements[
                            this.basicInputsWithIssue[nextIndexCurrentBasic].key
                        ],
                        ...this.basicInputsWithIssue[nextIndexCurrentBasic],
                    };

                    if (nextIndexCurrentBasic >= this.basicInputsWithIssue.length) {
                        this.handleBackNextPostureJacketLengthPerferred(true);
                    }
                    return true;
                }
                if (isNext) {
                    if (this.basicInputsWithIssue.find((item) => item.key == "jacket_size")) {
                        this.goToPageAndInput("posture_jacket_length_preferred");
                        return true;
                    } else {
                        if (this.typeApp === "mg" || this.typeApp === "sm") {
                            this.goToPageAndInput("sm_mg_transition");
                            return true;
                        } else {
                            this.goToPageAndInput("profile_creation");
                            return true;
                        }
                    }
                }
                return false;
            },
            handleBackNextPostureJacketLengthPerferred: function (isNext = true) {
                let nextStep =
                    this.typeApp === "dt"
                        ? "profile_creation"
                        : this.typeApp === "sm"
                        ? "sm_mg_transition"
                        : this.typeApp === "mg"
                        ? "sm_mg_transition"
                        : "sm_intro";
                let previousStepWhenIssue = this.basicInputsIssueNumber
                    ? "analyze_input_review"
                    : "profile_issue_found";
                if (isNext) this.goToPageAndInput(nextStep);
                else this.goToPageAndInput(previousStepWhenIssue);
                return true;
            },
            handleBackNextSaveResult: async function (isNext = true) {
                let _this = this;
                if (!this.registerName || !this.registerName.replace(/\s/g, "")) {
                    this.registerNameIsValid = false;
                    this.registerNameErrorMesg = "Name is not empty.";
                } else {
                    this.registerNameIsValid = true;
                    this.registerNameErrorMesg = "";
                }
                this.registerEmailIsValid = DT3oTool.checkValidEmail(this.registerEmail);
                if (!this.registerEmailIsValid) {
                    this.registerEmailIsValid = false;
                    this.registerEmailErrorMesg =
                        "Your email is invalid. Please check again.";
                } else if (!this.registerEmailAccept) {
                    this.registerEmailErrorMesg =
                        "You must accept the terms to register your account.";
                } else {
                    this.registerEmailErrorMesg = "";
                }
                if (this.registerEmail !== this.registerEmailConfirm) {
                    this.registerEmailConfirmIsValid = false;
                    this.registerEmailConfirmErrorMesg =
                        "The email addresses do not match.";
                } else {
                    this.registerEmailConfirmIsValid = true;
                }
                if (
                    !this.registerNameIsValid ||
                    !this.registerEmailIsValid ||
                    !this.registerEmailAccept ||
                    !this.registerEmailConfirmIsValid
                ) {
                    return true;
                }
                await this.sendRequestCustomerCreation()
                    .then((data) => {
                        _this.$set(_this.flags, "saving", false);
                        if (data.customer) {
                            let customer = data.customer;
                            _this.customer.id = customer.id;
                            _this.customer.loggedIn = false;
                            // console.log(customer.id);
                            sessionStorage.setItem("redirect_url", `/account`);
                            this.afterCreateCustomerHanlder(customer.id);
                            _this.$set(_this.flags, "saving", true);
                            setTimeout(() => {
                                _this.$set(_this.flags, "saving", false);
                                _this.currentBigPages =
                                    _this.keysOfBigPages[++_this.step];
                            }, DT3oConstant.TIMEOUT_NEXT_STEP_SAVE_RESULT_SUCCESS);
                            return true;
                        }
                        if (data.error) {
                            _this.registerEmailIsValid = false;
                            let { code, error } = data;

                            if (
                                code == 402 ||
                                error.email[0] === "has already been taken"
                            ) {
                                _this.registerEmailErrorMesg =
                                    "An account with that email exists. Use a different email or log in.";
                            } else if (
                                code == 422 ||
                                error.email[0] === "contains an invalid domain name"
                            ) {
                                _this.registerEmailErrorMesg =
                                    "Your email contains an invalid domain. Please check again.";
                            } else if (code == -1) {
                                _this.registerEmailErrorMesg =
                                    "Your email is invalid. Please check again.";
                            } else if (code == -2) {
                                _this.registerEmailErrorMesg =
                                    "Your shop URL is invalid. Please contact the administrator of website.";
                            } else {
                                _this.registerEmailErrorMesg =
                                    "There is an error when register account. Please try again.";
                            }
                            return true;
                        }
                        return false;
                    })
                    .catch((error) => {
                        _this.$set(_this.flags, "saving", false);
                        return true;
                    });
            },
            handleBackNextProfileCreateAtPhotoIntro: function (isNext = true) {
                if (isNext) this.nextStep_V2();
                else this.previousStep_V2();
                return true;
            },
            // save value to localStorage and fit profile
            saveInputValueSessionAndProfile: function ({
                inputKey,
                notSaveMetafieldWhenLogin = true,
            }) {
                try {
                    this.saveMeasurement(inputKey, notSaveMetafieldWhenLogin);
                    this.updateMeasurementValuesToProfile();
                } catch (error) {
                    console.log("===** Error saveInputValueSessionAndProfile", error);
                }
            },
            previousStep_V2: function () {
                let stepItem = document.querySelector(
                    `#${DT3oConstant.ID_DIGITAL_TAILOR_MODAL} .step--options--detail[data-big-page="${this.currentBigPages}"]`
                );
                if (stepItem)
                    stepItem.classList.remove(`step-slide-left`, `step-slide-right`);
                if (this.isShowOnlyOnePage) {
                    return true;
                }

                // go to previous step (ex sm_profile_review)
                if (
                    this.currentEditStep["isEditOneInput"] &&
                    this.currentEditStep["fromStep"]
                ) {
                    this.goToPageAndInput(this.currentEditStep["fromStep"]);
                    this.clearCurrentEditStep();
                }

                if (this.flags.isAnchorFitProfileDetailsStep) {
                    this.flags.isAnchorFitProfileDetailsStep = false; // remove anchor point at fit profile details step
                    this.goToPageAndInput("fit_profile_details");
                    return true;
                }
                // Self Measure
                // Nguyen changed using if else to switch case
                switch (this.currentBigPages) {
                    case "intro_sm": // a Thanh check this case is use or not
                        this.resetApp();
                        return true;
                    case "sm_at_home_intro":
                        if (this.typeApp === "sm" || this.typeApp === "sm-reconfirm") {
                            this.goToPageAndInput("sm_intro");
                            return true;
                        }
                    case "measurements_by_tailor":
                        this.goToPageAndInput("intro_sm");
                        return true;
                    case "sm_at_home_input":
                        if (this.handleBackNextSMInput(false)) return true;
                        break;
                    case "mg_input":
                        if (this.handleBackNextMGInput(false)) return true;
                        break;
                    case "measurements_intro":
                        if (this.typeApp === "sm") {
                            this.goToPageAndInput("intro_sm");
                            return true;
                        }
                        break;
                    case "body_size_detail":
                        if (this.typeApp === "sm") {
                            if (this.beforeStepBasicOfSM === "sm_at_home_input") {
                                this.currentInputSM =
                                    this.currentInputBeforeStepBasicOfSM;
                            }

                            if (this.beforeStepBasicOfSM === "") {
                                this.currentBigPages = "intro";
                                this.typeApp = "dt";
                                this.goToPageAndInput(this.currentBigPages);
                            } else {
                                this.goToPageAndInput(this.beforeStepBasicOfSM);
                            }
                            return true;
                        } else if (this.typeApp === "mg") {
                            this.currentBigPages = "intro";
                            this.typeApp = "dt";
                            this.goToPageAndInput(this.currentBigPages);
                            return true;
                        }
                        break;
                    case "photo_upload":
                        if (this.currentPhotoStepIndex > 0) {
                            this.photo_upload_error.isValid = true;
                            this.currentPhotoStep =
                                this.bigPages.photo_upload.steps[
                                    this.currentPhotoStepIndex - 1
                                ];
                            return true;
                        }
                        let stepPage = window.currentUser
                            ? "photo_intro_new"
                            : "photo_requirement";
                        this.goToPageAndInput(stepPage);
                        return true;
                    case "photo_requirement":
                        this.goToPageAndInput("photo_intro_new");
                        return true;
                    case "fit_preference":
                        this.goToPageAndInput("additional_input");
                        return true;
                    case "save_result_success":
                        sessionStorage.removeItem("redirect_url");
                        return true;
                    case "posture_jacket_length_preferred":
                        return this.handleBackNextPostureJacketLengthPerferred(false);
                    case "analyze_input_review":
                        let isTrue = this.handleBackNextAnalyzeInputReview(false);
                        if (isTrue) return true;
                        break;
                    case "sm_intro":
                    case "mg_intro":
                        this.goToPageAndInput("customer_input_review");
                        return true;
                    case "profile_creation":
                        break;
                    case "profile_issue_found":
                        if (this.typeApp === "dt")
                            this.goToPageAndInput("customer_input_review");
                        else if (this.typeApp === "sm")
                            this.goToPageAndInput("sm_at_home_input");
                        else if (this.typeApp === "mg") this.goToPageAndInput("mg_input");
                        return true;
                }
                this.currentBigPages = this.keysOfBigPages[--this.step];
                return true;
            },
            //
            nextStep_V2: async function () {
                let _this = this;
                let stepItem = document.querySelector(
                    `#${DT3oConstant.ID_DIGITAL_TAILOR_MODAL} .step--options--detail[data-big-page="${_this.currentBigPages}"]`
                );
                if (stepItem)
                    stepItem.classList.remove(`step-slide-left`, `step-slide-right`);

                let stepsInPage = _this.bigPages[_this.currentBigPages]
                    ? _this.bigPages[_this.currentBigPages].steps
                    : [];
                let unit = _this.selectedUnit;
                let timeout = DT3oConstant.TIMEOUT_POST_METAFIELD;
                let notSaveWhenLogin = true;
                // go to previous step (ex sm_profile_review)
                if (
                    _this.currentEditStep["isEditOneInput"] &&
                    _this.currentEditStep["fromStep"]
                ) {
                    let isEditFitProfile = _this.currentEditStep['fromStep'] === "fit_profile_details";
                    // 05/05/25
                    if (stepsInPage.length && _this.flags.hasChangeFinalValues) {
                        stepsInPage.forEach((inputKey, index) => {
                            setTimeout(() => {
                                _this.saveMeasurement(inputKey, notSaveWhenLogin);
                            }, index * timeout);
                        });
                    }

                    if (isEditFitProfile) {
                        _this.updateLastChoicesToFinalValues();
                        _this.updateMeasurementValuesToProfile();
                        _this.updatePostureValuesToProfile();
                    } else {
                        if (_this.typeApp === "sm") {
                            _this.updateSMValuesToProfileByLastChoices();
                        } else if (_this.typeApp === "mg") {
                            _this.updateMGValuesToProfileByLastChoices();
                        }
                    }

                    _this.goToPageAndInput(_this.currentEditStep["fromStep"]);
                    _this.clearCurrentEditStep();
                    return true;
                }

                if (
                    _this.flags.saving &&
                    _this.currentBigPages !== "save_result_success" &&
                    _this.currentBigPages !== "waiting_result" &&
                    _this.currentBigPages !== "rc_analyzing_inputs"
                ) {
                    return false;
                }

                // Nguyen changed using if else to switch case
                switch (_this.currentBigPages) {
                    case "measurements_by_tailor": // SM, SM-Reconfirm
                        // set before step Basic is only on SM
                        if (_this.typeApp === "sm") {
                            _this.beforeStepBasicOfSM = _this.currentBigPages;
                        }
                        // Task 10423
                        let inputs = jQuery(_this.modalSelector).find(
                            'input[name="measurements-by-tailor-item-input"]'
                        );
                        let checkValid = _this.checkValidAllInputs(inputs, {
                            addClassError: true,
                            showErrorMessage: false,
                        });
                        if (!checkValid) {
                            return false;
                        } else {
                            // Save to MeasurementValues and sessionStorage
                            $.each(inputs, (index, item) => {
                                let metafieldKey = jQuery(item).data("step");
                                if (metafieldKey) {
                                    _this.finalValues[metafieldKey] = DT3oTool.roundUp(
                                        jQuery(item).val()
                                    );
                                    setSessionMeasurement(
                                        metafieldKey,
                                        _this.finalValues[metafieldKey]
                                    );
                                }
                            });
                            _this.goToPageAndInput("body_size_detail");
                        }
                        return;

                    case "body_size_detail":
                        for (let i = 0; i < stepsInPage.length; i++) {
                            let step = stepsInPage[i];
                            if (step === "height") {
                                _this.saveHeightToStorage();
                                _this.measurements[step][unit].selected =
                                    unit === _this.unitIsUsUk
                                        ? _this.finalValues["height_show_inches"]
                                        : _this.finalValues["height_show_cm"];

                            } else {
                                _this.measurements[step][unit].selected =
                                    _this.finalValues[step];
                            }
                            setTimeout(() => {
                                _this.saveInputValueSessionAndProfile({ inputKey: step });
                            }, i * timeout);
                        }
                        break;

                    case "pants_size":
                    case "jacket_size":
                    case "shirt_size":
                        for (let i = 0; i < stepsInPage.length; i++) {
                            let step = stepsInPage[i];
                            _this.measurements[step][unit].selected =
                                _this.finalValues[step];
                            setTimeout(() => {
                                _this.saveInputValueSessionAndProfile({ inputKey: step });
                            }, i * timeout);
                        }
                        let stepInfoName = _this.currentBigPages + "_info";
                        _this.measurements[stepInfoName].selected =
                            _this.finalValues[_this.currentBigPages + "_info"];
                        setTimeout(() => {
                            _this.saveInputValueSessionAndProfile({
                                inputKey: stepInfoName,
                            });
                        }, timeout);
                        // for jacket_size has jacket_size_srl
                        if (_this.currentBigPages === "jacket_size") {
                            _this.saveInputValueSessionAndProfile({
                                inputKey: "jacket_size_srl",
                            });
                        }
                        break;

                    case "posture_torso":
                    case "posture_arm_length":
                    case "posture_shoulder_width":
                    case "posture_shoulder_slope":
                    case "posture_stance":
                    case "posture_seat":
                    case "posture_rise":
                    case "posture_fit_preference":
                    case "torso":
                    case "pants_preference":
                        _this.checkValidValuePostureAndSaveWhenNextStep();
                        break;

                    case "posture_jacket_length_preferred":
                        return _this.handleBackNextPostureJacketLengthPerferred(true);

                    case "additional_input":
                        for (let i = 0; i < stepsInPage.length; i++) {
                            let step = stepsInPage[i];
                            if (
                                _this.finalValues[step] ==
                                    _this.measurements[step][unit].min ||
                                _this.finalValues[step] ==
                                    _this.measurements[step][unit].max
                            ) {
                                _this.measurements[step][unit].selected = "n/a";
                            } else {
                                if (step === "jacket_size") {
                                    _this.measurements[step][
                                        unit
                                    ].selected = `${_this.finalValues[step]}${_this.finalValues["jacket_size_srl"]}`;
                                } else {
                                    // other steps
                                    _this.measurements[step][unit].selected =
                                        _this.finalValues[step];
                                }
                            }
                            setTimeout(() => {
                                _this.saveInputValueSessionAndProfile({ inputKey: step });
                            }, i * timeout);
                        }
                        break;

                    case "photo_requirement":
                        _this.goToPageAndInput("photo_intro_new");
                        return true;

                    case "photo_intro_new":
                        if (_this.customer.loggedIn) {
                            // close
                            _this.closeModalAll();
                            setTimeout(() => {
                                _this.resetApp();
                            }, 200);
                        } else {
                            _this.goToPageAndInput("save_options");
                        }
                        return true;

                    case "save_options":
                        if (_this.customer.loggedIn) {
                            _this.$set(_this.flags, "isGoFirstPage", true);
                        }
                        break;
                    case "result":
                        if (_this.customer.loggedIn) {
                            _this.saveAllChangedMeasurements_V2_Handle("manual");
                            return true;
                        }
                        break;

                    case "sm_at_home_input":
                        _this.smInputConfirmed = _this.smInputConfirmed || false;
                        let isValid = _this.checkValidInputSMNextStep();
                        if (!isValid) return false;
                        if (_this.handleBackNextSMInput(true)) return true;
                        _this.beforeStepPhotoIntro = _this.currentBigPages;
                        _this.goToPageAndInput("sm_profile_review");
                        return true;

                    case "mg_input":
                        _this.mgInputConfirmed = _this.mgInputConfirmed
                            ? _this.mgInputConfirmed
                            : false;
                        let isValidMG = _this.checkValidInputMGNextStep();
                        if (!isValidMG) return false;
                        if (_this.handleBackNextMGInput(true)) return true;
                        _this.goToPageAndInput("mg_profile_review");
                        return true;
                    case "measurements_at_home_confirm":
                        if (_this.typeApp === "sm") {
                            _this.beforeStepBasicOfSM = _this.currentBigPages;
                        }
                        // 9933, convert value to inches (round up) if unit is cm
                        _this.smInputsBodyTypeArr.forEach((sortedInputItem) => {
                            let sortedInputItemKey = sortedInputItem.metafieldKey;
                            let valueStep =
                                _this.lastChoices[sortedInputItemKey][_this.selectedUnit];
                            _this.finalValues[sortedInputItemKey] = _this.unitIsUsUk
                                ? valueStep
                                : DT3oTool.convertCmToInches(valueStep, true);
                            setSessionMeasurement(
                                sortedInputItemKey,
                                _this.finalValues[sortedInputItemKey]
                            );
                        });
                        _this.goToPageAndInput("body_size_detail");
                        return true;

                    case "save_result":
                        if (_this.handleBackNextSaveResult(true)) return true;
                        break;

                    case "save_result_success":
                        _this.currentBigPages = "intro";
                        _this.step = 0;
                        DT3oTool.closeModal();
                        return true;

                    case "fit_preference":
                        _this.fit_preference_error.isValid = true;
                        let step = "body_posture_fit_preference";
                        _this.measurements[step].value = _this.finalValues[step];
                        // reload content fit preference on account page
                        if (_this.isEditFitPreference) {
                            _this.saveMeasurement_V2(
                                step,
                                "edit_fit_preference_account_page"
                            );
                            setTimeout(() => {
                                _this.editTestPage();
                            }, DT3oConstant.TIMEOUT_POST_METAFIELD * 2);
                        } else {
                            _this.saveInputValueSessionAndProfile({ inputKey: step });
                            // ***** Set variable for customer not loggin
                            _this.trackCompletion();
                            if (!_this.customer.loggedIn) {
                                sessionStorage.setItem(
                                    "measurements_saved_boldmetrics",
                                    false
                                );
                            }
                        }
                        break;
                    case "sm_intro":
                        _this.currentInputSM = null;
                        _this.flags.fromStep = "";
                        break;
                    case "sm_at_home_intro":
                        let slick_dots_container = jQuery(
                            `[data-big-page="${_this.currentBigPages}"] #Measurements-At-Home-Intro-Slider .slick-dots`
                        );
                        if (slick_dots_container.length) {
                            let slick_dots = slick_dots_container.find("li");
                            if (slick_dots.length) {
                                let slick_dot_active =
                                    slick_dots_container.find(".slick-active");
                                let indexActive = slick_dots.index(slick_dot_active);
                                if (indexActive === slick_dots.length - 2) {
                                    _this.$set(
                                        _this.flags,
                                        "isLastItemOfMeasureAtHomeIntro",
                                        true
                                    );
                                }
                                if (indexActive < slick_dots.length - 1) {
                                    jQuery(slick_dots[indexActive + 1]).trigger("click");
                                    return false;
                                }
                                DT3oTool.destroySlickSlider(
                                    "#Measurements-At-Home-Intro-Slider"
                                );
                            }
                        }
                        break;
                    case "mg_profile_review":
                        _this.goToPageAndInput("mg_intro");
                        return true;
                    case "profile_issue_found":
                        if (_this.basicInputsIssueNumber) {
                            _this.goToPageAndInput("analyze_input_review");
                            return true;
                        }
                        break;

                    case "analyze_input_review":
                        let isTrue = _this.handleBackNextAnalyzeInputReview(true);
                        if (isTrue) return true;
                        break;

                    case "customer_input_review":
                        // Nguyen 10/04/2025 - Default to both for sm
                        if (_this.typeApp === "sm") {
                            _this.currentSMBodyType =
                                _this.currentSMBodyType === ""
                                    ? "both"
                                    : _this.currentSMBodyType;
                        }
                        // Nguyen - Save measurements when update inputs stage
                        let measurementsSession = JSON.parse(
                            sessionStorage.getItem("measurements") || "{}"
                        );
                        Object.keys(measurementsSession).forEach((key) => {
                            if (_this.finalValues[key] && measurementsSession[key]) {
                                measurementsSession[key] = _this.finalValues[key];
                            }
                            if (key === "height") {
                                measurementsSession[key] = _this.unitIsUsUk
                                    ? _this.finalValues["height_show_inches"]
                                    : _this.finalValues["height_show_cm"];
                            }
                        });
                        sessionStorage.setItem(
                            "measurements",
                            JSON.stringify(measurementsSession)
                        );
                        localStorage.setItem(
                            "measurements",
                            JSON.stringify(measurementsSession)
                        );
                        break;
                }
                // show only one page, such as Edit Fit Preference At Account Page
                if (_this.isShowOnlyOnePage) {
                    return true;
                }
                if (_this.customer.loggedIn && _this.currentBigPages === "result") {
                    _this.$set(_this.flags, "saving", true);
                }
                if (_this.flags.fromStep) {
                    _this.goToPageAndInputFromStep();
                    return true;
                }
                _this.currentBigPages = _this.keysOfBigPages[++_this.step];
            },
            goToPhotoUpload: function () {
                this.currentBigPages = "photo_requirement";
            },
            getCurrentPage: function () {
                return jQuery(".boldmetrics-modal .slick-active")
                    .find(".step--options--detail")
                    .data("step-number");
            },
            redoQuestion: function () {
                this.step = 1;
                this.currentBigPages = this.keysOfBigPages[_this.step];
            },
            // Arn 30/09/2021 - Fit Guarantee Exit Intent
            showResultModal: function (e) {
                $.fancybox.close();
                this.step = this.keysOfBigPages.indexOf("result");
                this.currentBigPages = "result";
            },
            // Arn 24/05/2022 - Close Modal
            closeGeneralModal: function () {
                let _this = this;
                $.fancybox.close();
                _this.$set(_this.flags, "customModalType", "confirmExitOrSaveData");
            },
            // Arn 30/09/2021 - Saved success info when logged in
            showSaveResultSuccessModal: function () {
                $.fancybox.close();
                $.fancybox.open({
                    src: ".boldmetrics-is-saved-success-modal",
                    type: "inline",
                    fullScreen: true,
                    touch: false,
                    buttons: [],
                    opts: {
                        trapFocus: true,
                        clickSlide: false,
                        clickOutside: false,
                        touch: false,
                        afterShow: function (instance, current) {},
                    },
                    modal: true,
                });
            },
            // Arn 11/06/2022 - Saving
            showSavingResultModal: function () {
                $.fancybox.close();
                $.fancybox.open({
                    src: ".boldmetrics-is-saving-modal",
                    type: "inline",
                    fullScreen: true,
                    touch: false,
                    buttons: [],
                    opts: {
                        trapFocus: true,
                        clickSlide: false,
                        clickOutside: false,
                        touch: false,
                        afterShow: function (instance, current) {},
                    },
                    modal: true,
                });
            },
            // Arn 30/09/2021 - Open Measurement Options Modal
            showMeasurementOptions: function (e) {
                e.preventDefault();
                $.fancybox.close();
                $.fancybox.open({
                    src: ".boldmetrics-other-measurement-options-modal",
                    type: "inline",
                    fullScreen: true,
                    touch: false,
                    buttons: [],
                    opts: {
                        trapFocus: true,
                        clickSlide: false,
                        clickOutside: false,
                        touch: false,
                        afterShow: function (instance, current) {},
                    },
                    modal: true,
                });
            },
            // Arn 12/10/2021 - Edit Self Measurement
            showEditSelfMeasurementInAccountPage: function () {
                let _this = this;
                _this.getAllSelfMeasureBeforeEdit();
                //$.fancybox.close();
                $.fancybox.open({
                    src: ".boldmetrics-edit-self-measurement-modal",
                    type: "inline",
                    fullScreen: true,
                    touch: false,
                    buttons: [],
                    opts: {
                        trapFocus: true,
                        clickSlide: false,
                        clickOutside: false,
                        touch: false,
                        afterShow: function (instance, current) {},
                    },
                    modal: true,
                });
            },
            // change TypeBodySelfMeasure: upper, lower, both
            selectSMBodyType: function (typeValue) {
                this.currentSMBodyType = typeValue;
            },
            // select garment type in measure a garment intro
            selectMGProductType: function (garmentType, redirect = true) {
                try {
                    this.currentMGProductType = garmentType;
                    this.currentMGProductTypeProfileDetail = garmentType;
                    if (!redirect) return;
                    this.currentBigPages = "mg_instruction";
                    this.nextStep_V2();
                } catch (error) {
                    console.log("** Error selectMGProductType", error);
                }
            },
            // Arn 11/01/2022 - Show Result Of Self and Digital Tailor Popup
            showResultSavedSelfAndTheDigitalTailorPopup: function () {
                //$.fancybox.close();
                $.fancybox.open({
                    src: ".boldmetrics-saved-result-self-and-digital-tailor-modal",
                    type: "inline",
                    fullScreen: true,
                    touch: false,
                    buttons: [],
                    opts: {
                        trapFocus: true,
                        clickSlide: false,
                        clickOutside: false,
                        touch: false,
                        afterShow: function (instance, current) {},
                    },
                    modal: true,
                });
            },
            // Arn 17/10/2021 -
            showContentAsFitPreference: function (e) {
                let _this = this;
                let fit_preference_value = getSessionMeasurement(
                    "body_posture_fit_preference"
                );
                let indexOfFitPreference = -1;
                let content = "";
                _this.measurements["body_posture_fit_preference"].us.values.some(
                    (item, index) => {
                        if (
                            item.value.toLowerCase() == fit_preference_value.toLowerCase()
                        ) {
                            indexOfFitPreference = index;
                            content = item.description;
                            return true;
                        }
                    }
                );
                // let containerAccountMeasurement = jQuery('.measurement-content-wrapper');
                // containerAccountMeasurement.find('.test-echo').html(indexOfFitPreference >= 0 ? _this.measurements['body_posture_fit_preference'].values_content[indexOfFitPreference] : '');
                jQuery(e.currentTarget).html(indexOfFitPreference >= 0 ? content : "");
            },
            // Arn 17/10/2021
            savePreferenceWithValue: async function (value) {
                if (value !== "self" && value !== "boldmetrics") {
                    console.log("Preference value is not valid");
                    return false;
                }

                var _this = this;
                var data = {
                    resourceType: "customers",
                    resourceID: _this.customer.id,
                    namespace: "measurement_data",
                    key: "preference",
                    value: value,
                    value_type: "string",
                };

                return new Promise(function (resolve, reject) {
                    _this
                        .saveMetafieldData(data)
                        .then(function (data) {
                            _this.$set(_this.flags, "saving", false);
                            resolve(data);
                        })
                        .catch(function (error) {
                            reject(error);
                        });
                });
            },
            // Arn 10/10/2021
            sendRequestCustomerCreation: async function () {
                let _this = this;
                let accepts_marketing_updated_at = new Date();
                let metafields = [];
                let valueAll = "";
                _.each(_this.measurementValues, function (model, key) {
                    let valueItem = getSessionMeasurement(key);
                    if (valueItem) {
                        valueAll +=
                            valueAll != ""
                                ? `;${key}:${valueItem}`
                                : `${key}:${valueItem}`;
                        var metafield = {
                            namespace: "measurement_data",
                            key: key,
                            value: valueItem,
                            // value_type: 'string'
                            type: "multi_line_text_field",
                        };
                        metafields.push(metafield);
                    }
                });

                let metafieldPreference = {
                    namespace: "measurement_data",
                    key: "preference",
                    value: "boldmetrics",
                    // value_type: 'string'
                    type: "multi_line_text_field",
                };
                metafields.unshift(metafieldPreference);

                let metafieldAll = {
                    namespace: "measurement_all", // maximum 20 characters
                    key: "digital_tailor_all_values", // maximum 30 characters
                    value: valueAll,
                    // value_type: 'string'
                    type: "multi_line_text_field",
                };
                metafields.unshift(metafieldAll);

                let dateDT = new Date();
                let metafielLastDateTheDigitalTailor = {
                    namespace: "measurement_all", // maximum 20 characters
                    key: "digital_tailor_date", // maximum 30 characters
                    value: dateDT.toISOString(),
                    // value_type: 'string'
                    type: "multi_line_text_field",
                };
                metafields.unshift(metafielLastDateTheDigitalTailor);

                let name_customer = _this.registerName.split(" ");
                let first_name = name_customer.length ? name_customer.shift() : "";
                let last_name = name_customer.length ? name_customer.join(" ") : "";

                var _data = {
                    customer: {
                        first_name: first_name,
                        last_name: last_name,
                        email: _this.registerEmail,
                        send_email_invite: false,
                        verified_email: true,
                        accepts_marketing: true,
                        accepts_marketing_updated_at:
                            accepts_marketing_updated_at.toISOString(),
                        marketing_opt_in_level: "single_opt_in",
                    },
                    other: {
                        shopUrl: "hoiana.myshopify.com",
                    },
                    metafields: metafields,
                };
                //console.log(_data)
                // console.log('*****', first_name + ' -- ' + last_name + ';');
                // return false;

                _this.$set(_this.flags, "saving", true);
                return new Promise(function (resolve, reject) {
                    $.ajax({
                        type: "POST",
                        url: `${remoteAppUrl}/createCustomer`,
                        data: _data,
                        dataType: "json",
                        success: function (data) {
                            resolve(data);
                        },
                        error: function (error) {
                            reject(error);
                        },
                    });
                });
            },
            /**
             *
             * @returns
             */
            setValueOfHeight: function ({
                value = 0,
                isFeet = false,
                isInches = false,
                isCm = false,
            }) {
                try {
                    if (isFeet) {
                        let valueInches = DT3oTool.convertFeetToInches(value);
                        let indexValue =
                            this.measurements.height[this.selectedUnit].values.indexOf(
                                value
                            );
                        let arrValue = value.toString().split(".");
                        // this.finalValues.height = valueInches;
                        this.finalValues.height_show = `${arrValue[0]}ft ${
                            arrValue[1] ? arrValue[1] : 0
                        }in`;
                        this.finalValues.height_show_short = `${arrValue[0]}' ${
                            arrValue[1] ? arrValue[1] : 0
                        }"`;
                        this.finalValues.height_show_feet = `${arrValue[0]}.${
                            arrValue[1] ? arrValue[1] : 0
                        }`;
                        this.finalValues.height_show_inches = valueInches;
                        this.finalValues.height_index_value_feet = indexValue;
                    } else if (isInches) {
                        let valueFeet = DT3oInitialTool.convertInchesToFeet(value, "dot");
                        let indexValue =
                            this.measurements.height[this.selectedUnit].values.indexOf(
                                valueFeet
                            );
                        let arrValue = valueFeet.toString().split(".");
                        // this.finalValues.height = value;
                        this.finalValues.height_show = `${arrValue[0]}ft ${
                            arrValue[1] ? arrValue[1] : 0
                        }in`;
                        this.finalValues.height_show_short = `${arrValue[0]}' ${
                            arrValue[1] ? arrValue[1] : 0
                        }"`;
                        this.finalValues.height_show_feet = `${arrValue[0]}.${
                            arrValue[1] ? arrValue[1] : 0
                        }`;
                        this.finalValues.height_show_inches = value;
                        this.finalValues.height_index_value_feet = indexValue;
                    } else if (isCm) {
                        // this.finalValues.height = value;
                        this.finalValues.height_show_cm = value;
                    }
                    this.lastChoices["height"][this.selectedUnit] =
                        this.finalValues["height"];
                } catch (error) {
                    console.log("** Error setValueOfHeight", error);
                }
            },
            // Thanh 05/19/2025
            setValueOfHeight_V2: function ({}) {
                let keyInput = "height";
                let _keyInput = this.unitIsUsUk ? "height_show_inches" : "height_show_cm";
                const {
                    values: valuesUs,
                    min: minUs,
                    max: maxUs,
                    step: stepUs,
                } = DT3o_GENERAL_DATA_STEPS[keyInput].us;
                let _value = DT3oInitialTool.convertValueToOtherUnits({
                    keyInput,
                    value: this.finalValues[_keyInput],
                    unit: this.selectedUnit,
                    values: valuesUs,
                });

                this.finalValues.height = this.selectedUnit === 'us' ? _value["us"] : _value["eu"];
                this.finalValues.height_show = _value["us_feet_long"];
                this.finalValues.height_show_short = _value["us_feet_short"];
                this.finalValues.height_show_feet = _value["us_feet_dot"];
                this.finalValues.height_show_inches = _value["us"];
                this.finalValues.height_show_cm = _value["eu"];
                this.finalValues.height_index_value_feet = _value["us_index_feet"];

                this.lastChoices["height"][this.selectedUnit] =
                    this.finalValues["height"];
            },
            // Arn 02/10/2021
            // Nguyen changed _this to this
            updateSelectedWhenChangeHeight: function () {
                let heightEle = jQuery("#boldmetrics_step_height");
                if (!heightEle.length) {
                    console.log("***** Height element is undefined");
                    return false;
                }
                if (this.unitIsUsUk) {
                    let heightValIndex = heightEle.val();
                    let heightVal =
                        this.measurements["height"][this.selectedUnit].values[
                            heightValIndex
                        ];
                    this.setValueOfHeight({ value: heightVal, isFeet: true });
                    this.setValueOfHeight_V2({});
                } else {
                    let heightVal = heightEle.val();
                    this.setValueOfHeight({ value: heightVal, isCm: true });
                    this.setValueOfHeight_V2({});
                }
                this.lastChoices["height"][this.selectedUnit] =
                    this.finalValues["height"];
            },
            //=====
            updateSliderWhenChangeInput: function (
                step = "",
                e,
                typeUnitOfHeight = "inches",
                isSaveToStorage = false
            ) {
                if (!step) return false;
                let value = jQuery(e.currentTarget).val();
                let valuesOfSteps = this.measurements[step][this.selectedUnit];
                let isValidValue =
                    value >= valuesOfSteps.min && value <= valuesOfSteps.max;

                if (step === "height") {
                    let valueFeet = this.unitIsUsUk
                        ? value
                        : DT3oInitialTool.convertInchesToFeet(value, "dot");
                    if (this.unitIsUsUk) {
                        let heightValue = isValidValue
                            ? value
                            : DT3oTool.convertFeetToInches(defaultValue);
                        this.setValueOfHeight({
                            value: heightValue,
                            isFeet: typeUnitOfHeight === "feet",
                            isInches: typeUnitOfHeight === "inches",
                        });
                    } else {
                        this.setValueOfHeight({
                            value: isValidValue ? value : defaultValue,
                            isCm: true,
                        });
                    }
                } else {
                    // Nguyen fix bug for first time input value
                    let finalValue =
                        this.finalValues[step] < 0 ? value : this.finalValues[step];
                    finalValue = isValidValue
                        ? finalValue
                        : value >= valuesOfSteps.max
                        ? valuesOfSteps.max
                        : valuesOfSteps.min;
                    this.finalValues[step] = finalValue;
                }

                this.lastChoices[step][this.selectedUnit] = this.finalValues[step];
                if (isSaveToStorage) {
                    let notSaveWhenLogin = true;
                    setTimeout(
                        () => {
                            _this.saveInputValueSessionAndProfile({ inputKey: step });
                        },
                        notSaveWhenLogin ? DT3oConstant.TIMEOUT_POST_METAFIELD : 0
                    );
                    if (step === "height") this.saveHeightToStorage();
                }
            },
            saveHeightToStorage: function () {
                try {
                    let _this = this;
                    setSessionMeasurement('height', _this.selectedUnit === 'us' ? _this.finalValues.height_show_inches : _this.finalValues.height_show_cm);
                    setSessionMeasurement("height_show", _this.finalValues.height_show);
                    setSessionMeasurement(
                        "height_show_short",
                        _this.finalValues.height_show_short
                    );
                    setSessionMeasurement(
                        "height_show_inches",
                        _this.finalValues.height_show_inches
                    );
                    setSessionMeasurement(
                        "height_show_cm",
                        _this.finalValues.height_show_cm
                    );
                    setSessionMeasurement(
                        "height_show_feet",
                        _this.finalValues.height_show_feet
                    );
                } catch (error) {
                    console.error("===** Error saveHeightToStorage", error);
                }
            },
            // Arn 02/10/2021
            updateSelectedWhenChangeSlider: function (step, e) {
                try {
                    this.transitionName = "no-transition";
                    this.lastChoices[step][this.selectedUnit] = this.finalValues[step];
                } catch (error) {
                    console.log("** Error updateSelectedWhenChangeSlider", error);
                }
            },
            // Nguyen update wheel 02/04/2025
            updateSelectedWhenChangeWheel: function (step, e) {
                try {
                    if (this.checkTrackpadEvent(e)) return;
                    const input = document.getElementById(`boldmetrics_step_${step}`);
                    if (!input) {
                        console.log("***** Input element is undefined");
                        return false;
                    }
                    const min = input.min.includes(",")
                        ? parseFloat(input.min)
                        : parseInt(input.min);
                    const max = input.max.includes(",")
                        ? parseFloat(input.max)
                        : parseInt(input.max);
                    const { step: stepSize } = this.measurements[step][this.selectedUnit];
                    let currentValue =
                        this.finalValues[step] < min
                            ? min
                            : this.finalValues[step] > max
                            ? max
                            : this.finalValues[step];

                    if (e.deltaY < 0) {
                        currentValue = Math.min(currentValue + stepSize, max);
                    } else {
                        currentValue = Math.max(currentValue - stepSize, min);
                    }

                    this.finalValues[step] = currentValue;
                    this.lastChoices[step][this.selectedUnit] = currentValue;
                } catch (error) {
                    console.log("** Error updateSelectedWhenChangeWheel", error);
                }
            },
            //
            updatePostureValue: function (key, value) {
                this.finalValues[key] = value;
                this.measurementValues[key] = value;
            },
            //
            checkTrackpadEvent: function (e) {
                if (e.wheelDeltaY !== undefined) {
                    if (Math.abs(e.wheelDeltaY) < 40) {
                        return true;
                    }
                } else if (e.deltaMode === 0 && Math.abs(e.deltaY) < 5) {
                    return true;
                }
                return false;
            },
            // Arn 03/10/2021
            toggleStepInfo_V2: function (step, e) {
                let _this = this;
                jQuery(e.target)
                    .closest("div.step--options--detail")
                    .find("span.boldmetrics_svg_question")
                    .removeClass("boldmetrics_svg_question_active");
                jQuery(e.target)
                    .closest("span.boldmetrics_svg_question")
                    .addClass("boldmetrics_svg_question_active");
                jQuery(".arn-tooltip-container")
                    .removeClass("arn-tooltip-container-active")
                    .empty();
                let hasActive = jQuery(e.target)
                    .closest("div")
                    .find(".arn-tooltip-container")
                    .hasClass("arn-tooltip-container-active");
                if (hasActive) {
                    return false;
                }
                // let tooltip = `<div class="row center-xs arn-tooltip-container" onClick="hideStepInfo_V2(event)">`;
                let tooltip = `<div class="start-xs col-xs-12">`;
                tooltip += `<div class="box">`;
                tooltip += `<span class="measurements__tooltip_title"> ${_this.measurements[step].tooltip_title} </span>`;
                tooltip += `<p class="measurements__tooltip_content"> ${
                    _this.measurements[step].tooltip_content
                        ? _this.measurements[step].tooltip_content
                        : _this.measurements[step].description
                } </p>`;
                tooltip += `</div>`;
                // tooltip += `</div>`;
                tooltip += `</div>`;
                jQuery(e.target)
                    .closest("div")
                    .find(".arn-tooltip-container")
                    .append(tooltip)
                    .addClass("arn-tooltip-container-active");
                _this.isShowTooltip = true;
            },
            // show popup info of step
            toggleStepInfo_V3: function (step, parentKey = "") {
                try {
                    this.setSelectedStepOfInputInfoPopup(step, parentKey);
                    setTimeout(() => {
                        DT3oTool.openModalInfoInput();
                    }, 0);
                } catch (error) {
                    console.log("** Error toggleStepInfo_V3", error);
                }
            },
            // set value for selectedStepOfInputInfoPopup
            setSelectedStepOfInputInfoPopup: function (input_key, parentKey) {
                try {
                    const { coreApp, measureGarmentApp } =
                        SARTORO_APP_CONFIG.textsAndImages;
                    let text = "";
                    let title = "";
                    let image = "";
                    switch (input_key) {
                        case "height":
                            text = coreApp.coreRequireInfoHeightInfoText;
                            title = coreApp.coreRequireInfoHeightInfoTitle;
                            image = coreApp.coreRequireInfoHeightInfoImage;
                            break;
                        case "weight":
                            text = coreApp.coreRequireInfoWeightInfoText;
                            title = coreApp.coreRequireInfoWeightInfoTitle;
                            image = coreApp.coreRequireInfoWeightInfoImage;
                            break;
                        case "age":
                            text = coreApp.coreRequireInfoAgeInfoText;
                            title = coreApp.coreRequireInfoAgeInfoTitle;
                            image = coreApp.coreRequireInfoAgeInfoImage;
                            break;
                        case "shoe_size":
                            text = coreApp.coreRequireInfoShoeSizeInfoText;
                            title = coreApp.coreRequireInfoShoeSizeInfoTitle;
                            image = coreApp.coreRequireInfoShoeSizeInfoImage;
                            break;
                        case "waist_size":
                            text = coreApp.coreRequireInfoPantsWaistInfoText;
                            title = coreApp.coreRequireInfoPantsWaistInfoTitle;
                            image = coreApp.coreRequireInfoPantsWaistInfoImage;
                            break;
                        case "pants_inseam":
                            text = coreApp.coreRequireInfoPantsInseamInfoText;
                            title = coreApp.coreRequireInfoPantsInseamInfoTitle;
                            image = coreApp.coreRequireInfoPantsInseamInfoImage;
                            break;
                        case "jacket_size":
                            title = coreApp.coreRequireInfoJacketSizeJacketSizeInfoTitle;
                            text = coreApp.coreRequireInfoJacketSizeJacketSizeInfoText;
                            image = coreApp.coreRequireInfoJacketSizeJacketSizeInfoImage;
                            break;
                        case "jacket_length_preferred":
                            title = coreApp.coreJacketLengthInfoTitle;
                            text = coreApp.coreJacketLengthInfoText;
                            image = coreApp.coreJacketLengthInfoImage;
                            break;
                        case "neck_size":
                            text = coreApp.coreRequireInfoShirtSizeShirtNeckInfoText;
                            title = coreApp.coreRequireInfoShirtSizeShirtNeckInfoTitle;
                            image = coreApp.coreRequireInfoShirtSizeShirtNeckInfoImage;
                            break;
                        case "sleeve_length":
                            title = coreApp.coreRequireInfoShirtSizeShirtSleeveInfoTitle;
                            text = coreApp.coreRequireInfoShirtSizeShirtSleeveInfoText;
                            image = coreApp.coreRequireInfoShirtSizeShirtSleeveInfoImage;
                            break;
                        case "posture_torso":
                            title = coreApp.coreBodyType1InfoTitle;
                            text = coreApp.coreBodyType1InfoText;
                            image = coreApp.coreBodyType1InfoImage;
                            break;
                        case "posture_arm_length":
                            title = coreApp.coreBodyType2InfoTitle;
                            text = coreApp.coreBodyType2InfoText;
                            image = coreApp.coreBodyType2InfoImage;
                            break;
                        case "arm_length":
                            if (parentKey == "jacket") {
                                title = coreApp.coreJacketArmLengthInfoTitle;
                                text = coreApp.coreJacketArmLengthInfoText;
                                image = coreApp.coreJacketArmLengthInfoImage;
                            } else if (parentKey == "shirt") {
                                title = coreApp.coreShirtArmLengthInfoTitle;
                                text = coreApp.coreShirtArmLengthInfoText;
                                image = coreApp.coreShirtArmLengthInfoImage;
                            }
                            break;
                        case "posture_shoulder_width":
                            title = coreApp.coreBodyType3InfoTitle;
                            text = coreApp.coreBodyType3InfoText;
                            image = coreApp.coreBodyType3InfoImage;
                            break;
                        case "shoulders":
                            title = coreApp.coreShoulderInfoTitle;
                            text = coreApp.coreShoulderInfoText;
                            image = coreApp.coreShoulderInfoImage;
                            break;
                        case "posture_shoulder_slope":
                            title = coreApp.coreBodyType4InfoTitle;
                            text = coreApp.coreBodyType4InfoText;
                            image = coreApp.coreBodyType4InfoImage;
                            break;
                        case "posture_stance":
                            title = coreApp.coreBodyType5InfoTitle;
                            text = coreApp.coreBodyType5InfoText;
                            image = coreApp.coreBodyType5InfoImage;
                            break;
                        case "posture_seat":
                            title = coreApp.coreBodyType6InfoTitle;
                            text = coreApp.coreBodyType6InfoText;
                            image = coreApp.coreBodyType6InfoImage;
                            break;
                        case "posture_rise":
                            title = coreApp.coreBodyType7InfoTitle;
                            text = coreApp.coreBodyType7InfoText;
                            image = coreApp.coreBodyType7InfoImage;
                            break;
                        case "posture_fit_preference":
                            title = coreApp.coreBodyType8InfoTitle;
                            text = coreApp.coreBodyType8InfoText;
                            image = coreApp.coreBodyType8InfoImage;
                            break;
                        case "waistline":
                            title = coreApp.coreWaistLineInfoTitle;
                            text = coreApp.coreWaistLineInfoText;
                            image = coreApp.coreWaistLineInfoImage;
                            break;
                        case "hips_seat":
                            title = coreApp.coreHipsSeatInfoTitle;
                            text = coreApp.coreHipsSeatInfoText;
                            image = coreApp.coreHipsSeatInfoImage;
                            break;
                        case "thighs":
                            title = coreApp.coreThighsInfoTitle;
                            text = coreApp.coreThighsInfoText;
                            image = coreApp.coreThighsInfoImage;
                            break;
                        case "calves":
                            title = coreApp.coreCalvesInfoTitle;
                            text = coreApp.coreCalvesInfoText;
                            image = coreApp.coreCalvesInfoImage;
                            break;
                        case "length":
                            title = coreApp.coreLengthInfoTitle;
                            text = coreApp.coreLengthInfoText;
                            image = coreApp.coreLengthInfoImage;
                            break;
                        case "chest":
                            if (parentKey == "jacket") {
                                title = coreApp.coreJacketChestInfoTitle;
                                text = coreApp.coreJacketChestInfoText;
                                image = coreApp.coreJacketChestInfoImage;
                            } else if (parentKey == "shirt") {
                                title = coreApp.coreShirtChestInfoTitle;
                                text = coreApp.coreShirtChestInfoText;
                                image = coreApp.coreShirtChestInfoImage;
                            }
                            break;
                        case "belly":
                            if (parentKey == "jacket") {
                                title = coreApp.coreJacketBellyInfoTitle;
                                text = coreApp.coreJacketBellyInfoText;
                                image = coreApp.coreJacketBellyInfoImage;
                            } else if (parentKey == "shirt") {
                                title = coreApp.coreShirtBellyInfoTitle;
                                text = coreApp.coreShirtBellyInfoText;
                                image = coreApp.coreShirtBellyInfoImage;
                            }
                            break;
                        case "biceps":
                            if (parentKey == "jacket") {
                                // not have biceps for jacket
                            } else if (parentKey == "shirt") {
                                title = coreApp.coreShirtBicepsInfoTitle;
                                text = coreApp.coreShirtBicepsInfoText;
                                image = coreApp.coreShirtBicepsInfoImage;
                            }
                            break;
                        case "jacket_length":
                            title = coreApp.coreJacketLengthInfoTitle;
                            text = coreApp.coreJacketLengthInfoText;
                            image = coreApp.coreJacketLengthInfoImage;
                            break;
                        case "select_garment":
                            title = measureGarmentApp.mgSelectGarmentInfoTitle;
                            text = measureGarmentApp.mgSelectGarmentInfoText;
                            image = measureGarmentApp.mgSelectGarmentInfoImage;
                            break;
                    }
                    this.selectedStepOfInputInfoPopup = { input_key, text, title, image };
                } catch (error) {
                    console.log("** Error setSelectedStepOfInputInfoPopup", error);
                }
            },
            //
            hideStepInfo_V2: function (e) {
                let _this = this;
                jQuery("span.boldmetrics_svg_question").removeClass(
                    "boldmetrics_svg_question_active"
                );
                jQuery(".arn-tooltip-container").removeClass(
                    "arn-tooltip-container-active"
                );
                jQuery(".arn-tooltip-container").empty();
                _this.isShowTooltip = false;
            },
            //
            jacketSizeAddSRL: function (step, srl, e) {
                let _this = this;
                // is SKIPPED so disable SRL option
                if (
                    jQuery(e.currentTarget).hasClass("boldmetrics_letter_circle_disable")
                ) {
                    e.preventDefault();
                    return false;
                }

                if (
                    _this.finalValues.jacket_size ==
                        _this.measurements.jacket_size[_this.selectedUnit].min ||
                    _this.finalValues.jacket_size ==
                        _this.measurements.jacket_size[_this.selectedUnit].max
                ) {
                    return false;
                }

                _this.finalValues.jacket_size_srl = srl.toUpperCase();
                // _this.updateSelectedWhenChangeSliderAdditionalInput(step, e);
                jQuery(e.target)
                    .closest("div")
                    .find(".boldmetrics_letter_circle_active")
                    .removeClass("boldmetrics_letter_circle_active");
                jQuery(e.target).addClass("boldmetrics_letter_circle_active");
            },
            //
            minimizeYourInput: function (e) {
                let items = jQuery(e.target)
                    .closest("div.boldmetrics-page-result-items-your-input")
                    .find(".boldmetrics-page-result-items");

                if (jQuery(e.target).data("show") === "show") {
                    items
                        .addClass("boldmetrics-page-result-items-hide")
                        .removeClass("boldmetrics-page-result-items-show");
                    jQuery(e.target).data("show", "hide");
                    jQuery(e.target)
                        .removeClass("fa-chevron-up")
                        .addClass("fa-chevron-down");
                } else {
                    items
                        .addClass("boldmetrics-page-result-items-show")
                        .removeClass("boldmetrics-page-result-items-hide");
                    jQuery(e.target).data("show", "show");
                    jQuery(e.target)
                        .removeClass("fa-chevron-down")
                        .addClass("fa-chevron-up");
                }
            },
            //
            getSessionMeasurement_V2: function (name) {
                let item = sessionStorage.getItem("measurements");
                var measurements = JSON.parse(item === "" ? null : item);
                var value =
                    measurements && measurements[name] ? measurements[name] : "---";
                if (value === "n/a") {
                    value = DT3oConstant.TEXT_LABEL_SKIP;
                }
                return value;
            },
            //
            convertInchesToCm: function (value) {
                console.log(
                    value,
                    value * DT3oConstant.CONST_FROM_INCHES_TO_CM,
                    DT3oConstant.CONST_FROM_INCHES_TO_CM
                );
                return value * DT3oConstant.CONST_FROM_INCHES_TO_CM;
            },
            //
            convertCmToInches: function (value) {
                // console.log(value, value * DT3oConstant.CONST_FROM_CM_TO_INCHES, DT3oConstant.CONST_FROM_CM_TO_INCHES)
                return value * DT3oConstant.CONST_FROM_CM_TO_INCHES;
            },
            //
            roundToNearest05: function (value) {
                return Math.round(value * 2) / 2;
            },
            //
            changeProgressBar: function (current, total) {
                let value = parseInt((current / total) * 100);
                jQuery("div.arn-progress-now").css({
                    width: `${value}%`,
                    // transition: 'width 1s',
                    // '-webkit-transition': 'width 1s',
                    // '-moz-transition': 'width 1s',
                    // '-o-transition': 'width 1s',
                    // '-ms-transition': 'width 1s'
                });
            },
            // convert finalValues with new unit
            convertFinalValues: function (oldUnit, newUnit) {
                let _type = this.currentMGProductTypeProfileDetail;
                let _finalValues = JSON.parse(JSON.stringify(this.finalValues));
                Object.keys(_finalValues).forEach((keyInput) => {
                    // Handle for MG
                    if (keyInput === "age") return;
                    let isMgInputType = this.mgProductTypesArr.find(
                        (item) => item.type === _type
                    );
                    if (
                        isMgInputType &&
                        isMgInputType.type === keyInput &&
                        typeof _finalValues[keyInput] === "object"
                    ) {
                        Object.keys(_finalValues[keyInput]).forEach((_itm) => {
                            let convertData = {
                                keyInput,
                                value: _finalValues[keyInput][_itm],
                                unit: oldUnit,
                                values: [],
                            };

                            let _value =
                                DT3oInitialTool.convertValueToOtherUnits(convertData);
                            _finalValues[keyInput][_itm] = _value[newUnit];
                            if (this.lastChoices[keyInput][_itm]) {
                                this.lastChoices[keyInput][_itm][newUnit] = _value[newUnit];
                            }
                        });
                        return;
                    }
                    // Handle for SM
                    let isSmInput = this.smInputsArr.find(
                        (item) => item.metafieldKey === keyInput
                    );
                    // console.log(keyInput, isSmInput , this.smInputsArr , "** isSmInput this.smInputsArr");
                    // console.log(DT3o_GENERAL_DATA_STEPS, "** DT3o_GENERAL_DATA_STEPS");
                    if (!isSmInput && !DT3o_GENERAL_DATA_STEPS[keyInput]) return;
                    let inputUs = isSmInput
                        ? isSmInput.us
                        : DT3o_GENERAL_DATA_STEPS[keyInput].us;
                    const {
                        values: valuesUs,
                        min: minUs,
                        max: maxUs,
                        step: stepUs,
                    } = inputUs;
                    let _keyInput = keyInput;
                    switch (keyInput) {
                        case "height":
                            _keyInput = this.UsUkUnits.includes(oldUnit)
                                ? "height_show_inches"
                                : "height_show_cm";
                            break;
                        case "height_show":
                        case "height_show_short":
                        case "height_show_feet":
                        case "height_show_inches":
                        case "height_show_cm":
                        case "height_index_value_feet":
                            return false;
                    }
                    if (typeof _finalValues[keyInput] === "object") return;
                    let convertData = {
                        keyInput,
                        value: _finalValues[_keyInput],
                        unit: oldUnit,
                        values: valuesUs,
                    };

                    let _value = DT3oInitialTool.convertValueToOtherUnits(convertData);

                    // for height, need to update more keys
                    if (keyInput === "height") {
                        _finalValues.height_show = _value["us_feet_long"];
                        _finalValues.height_show_short = _value["us_feet_short"];
                        _finalValues.height_show_feet = _value["us_feet_dot"];
                        _finalValues.height_show_inches = _value["us"];
                        _finalValues.height_show_cm = _value["eu"];
                        _finalValues.height_index_value_feet = _value["us_index_feet"];
                    }
                    _finalValues[keyInput] = _value[newUnit];
                });
                this.finalValues = JSON.parse(JSON.stringify(_finalValues));
            },
            // Arn 13/10/2021
            changeUnit_V2: function (e, units, unit) {
                var _this = this;
                _this.units.selected = unit;
                _this.stepsNeedConvert.forEach((item, index) => {
                    _this.finalValues[item.key] = _this.lastChoices[item.key][
                        _this.selectedUnit
                    ]
                        ? _this.lastChoices[item.key][_this.selectedUnit]
                        : 0;
                    // : _this.measurements[item.key][selectedUnit].default;
                    if (item.needUpdateSlider) {
                        _this.updateSelectedWhenChangeSlider(item.key, null);
                    }
                    // Nguyen update 02/04/2025 comment because not defined
                    // if (item.needUpdateSliderAdditional) {
                    //     _this.updateSelectedWhenChangeSliderAdditionalInput(item.key, null);
                    // }
                });
            },

            changeUnit_V2_Caller: function (e) {
                try {
                    let nextUnit = this.unitIsMetric ? "us" : "metric";
                    this.changeUnit_V2(e, this.units, nextUnit);
                } catch (error) {
                    console.log("** Error changeUnit_V2_Caller", error);
                }
            },
            changeUnit_V3: function (newUnit) {
                let oldUnit = this.units.selected;
                this.units.selected = newUnit;
                this.convertFinalValues(oldUnit, newUnit);
                this.convertAnalyzedValues(oldUnit, newUnit);
                this.setValueOfHeight_V2({});

            },
            changeUnit_V3_Caller: function (unit) {
                try {
                    this.changeUnit_V3(unit);
                } catch (error) {
                    console.log("** Error changeUnit_V3_Caller", error);
                }
            },
            convertAnalyzedValues: function (oldUnit, newUnit) {
                this.basicInputsWithIssue.forEach(item => {
                    Object.keys(item).forEach(key => {
                        if (key.includes('final')) {
                            if ((oldUnit === 'us' || oldUnit === 'uk') && (newUnit === 'eu' || newUnit === 'metric' || newUnit === 'aus')) {
                                item[key] = DT3oInitialTool.convertInchesToCm(item[key], true);
                            } else if ((oldUnit === 'eu' || oldUnit === 'metric' || oldUnit === 'aus') && (newUnit === 'us' || newUnit === 'uk')) {
                                item[key] = DT3oInitialTool.convertCmToInches(item[key], true);
                            }
                        }
                    });
                });
                this.smInputsWithIssue.forEach(item => {
                    Object.keys(item).forEach(key => {
                        if (key.includes('final')) {
                            if ((oldUnit === 'us' || oldUnit === 'uk') && (newUnit === 'eu' || newUnit === 'metric' || newUnit === 'aus')) {
                                item[key] = DT3oInitialTool.convertInchesToCm(item[key], true);
                            } else if ((oldUnit === 'eu' || oldUnit === 'metric' || oldUnit === 'aus') && (newUnit === 'us' || newUnit === 'uk')) {
                                item[key] = DT3oInitialTool.convertCmToInches(item[key], true);
                            }
                        }
                    });
                });
                // Loop through object entries instead of using forEach since mgProductTypeWithIssueInputsArr is an object
                Object.entries(this.mgProductTypeWithIssueInputsArr).forEach(([garmentKey, garmentItems]) => {
                    garmentItems.forEach(item => {
                        Object.keys(item).forEach(key => {
                            if (key.includes('final')) {
                                if ((oldUnit === 'us' || oldUnit === 'uk') && (newUnit === 'eu' || newUnit === 'metric' || newUnit === 'aus')) {
                                    item[key] = DT3oInitialTool.convertInchesToCm(item[key], true);
                                } else if ((oldUnit === 'eu' || oldUnit === 'metric' || oldUnit === 'aus') && (newUnit === 'us' || newUnit === 'uk')) {
                                    item[key] = DT3oInitialTool.convertCmToInches(item[key], true);
                                }
                            }
                        });
                    });
                });
            },
            setEmailAccept: function (e) {
                this.registerEmailAccept = jQuery(e.target).prop("checked");
            },
            // Arn 12/10/2021
            changeValueStepOfSelfMeasure: function (e, step, action, stepValue) {
                let input = jQuery(e.currentTarget)
                    .closest("div")
                    .find("input.boldmetrics-edit-modal__item_value");
                let value = parseFloat(jQuery(input).val());
                switch (action) {
                    case "plus":
                        value += value + stepValue > 100 ? 0 : stepValue;
                        break;
                    case "minus":
                        value -= value - stepValue < 0 ? 0 : stepValue;
                        break;
                }
                jQuery(input).val(value.toFixed(1));
            },
            // Arn 21/10/2021
            saveMeasurement_V2: async function (model, action = "") {
                var _this = this;
                setSessionMeasurement(model, _this.measurementValues[model]);
                if (_this.customer.loggedIn) {
                    let data = await _this.saveMeasurementMetafield(model);
                    switch (action) {
                        case "edit_body_proportion_account_page":
                            _this.saveEditProportion_Callback(data);
                            break;

                        case "edit_fit_preference_account_page":
                            _this.saveEditFitPreference_Callback(data);
                            break;

                        default:
                            return false;
                    }
                } else {
                    return false;
                }
            },
            // Arn 29/10/2021
            saveAllMeasurements_V2: function (update_type = "unknown") {
                var _this = this;
                let value = "";
                _.each(_this.measurementValues, function (model, key) {
                    let valueItem = getSessionMeasurement(key);
                    if (valueItem)
                        value +=
                            value != "" ? `;${key}:${valueItem}` : `${key}:${valueItem}`;
                });
                var data = {
                    resourceType: "customers",
                    resourceID: _this.customer.id,
                    namespace: "measurement_all", // maximum 20 characters
                    key: "digital_tailor_all_values", // maximum 30 characters
                    value: value,
                    value_type: "string",
                    update_type: update_type,
                };
                new Promise(function (resolve, reject) {
                    $.ajax({
                        type: "POST",
                        url: `${remoteAppUrl}/saveAllMetafields`,
                        data: data,
                        dataType: "json",
                        success: function (payload) {
                            console.log({ payload, data });
                            if (payload.success) {
                                // after all metafields saved, clear recent login overlay
                                sessionStorage.removeItem(
                                    "measurement_complete_loggedin"
                                );
                                sessionStorage.setItem(
                                    "measurements_saved_boldmetrics",
                                    true
                                );
                                var isSessionMeasurement =
                                    sessionStorage.getItem("redirect_url") !== null;
                                if (isSessionMeasurement) {
                                }
                            } else {
                                sessionStorage.setItem(
                                    "measurements_saved_boldmetrics",
                                    false
                                );
                            }
                            _this.$set(_this.flags, "saving", false);
                            resolve(payload);
                        },
                        error: function (error) {
                            console.error(error);
                            reject(error);
                        },
                    });
                });
            },
            // Arn 19/05/2022
            saveAllChangedMeasurements_V2: async function (update_type = "unknown") {
                var _this = this;
                let value_all = "";
                let value_changed = "";
                _.each(_this.measurementValues, function (model, key) {
                    let valueItem = getSessionMeasurement(key);
                    if (valueItem) {
                        value_all +=
                            value_all != ""
                                ? `;${key}:${valueItem}`
                                : `${key}:${valueItem}`;
                        if (
                            typeof ARN_LOADED_METAFIELDS_VALUES[key] === "undefined" ||
                            (typeof ARN_LOADED_METAFIELDS_VALUES[key] !== "undefined" &&
                                ARN_LOADED_METAFIELDS_VALUES[key]
                                    .toString()
                                    .toLowerCase() !== valueItem.toString().toLowerCase())
                        ) {
                            value_changed +=
                                value_changed != ""
                                    ? `;${key}:${valueItem}`
                                    : `${key}:${valueItem}`;
                        }
                        // console.log('====', key, typeof ARN_LOADED_METAFIELDS_VALUES[key], typeof ARN_LOADED_METAFIELDS_VALUES[key], typeof valueItem, ARN_LOADED_METAFIELDS_VALUES[key], valueItem, '====', value_changed)
                    }
                });
                if (!value_changed) {
                    return Promise.resolve({ noDataToSave: true });
                }
                var data = {
                    resourceType: "customers",
                    resourceID: _this.customer.id,
                    value_all: value_all,
                    value_changed: value_changed,
                    update_type: update_type,
                };
                return new Promise(function (resolve, reject) {
                    _this.closeModalAll();
                    _this.$set(_this.flags, "customModalType", "pleaseWaitForComplete");
                    _this.showSavingResultModal();
                    $.ajax({
                        type: "POST",
                        url: `${remoteAppUrl}/saveAllChangedMetafields`,
                        data: data,
                        dataType: "json",
                        success: function (payload) {
                            console.log({ payload, data });
                            if (payload.success) {
                                sessionStorage.removeItem(
                                    "measurement_complete_loggedin"
                                );
                                sessionStorage.setItem(
                                    "measurements_saved_boldmetrics",
                                    true
                                );
                            } else {
                                sessionStorage.setItem(
                                    "measurements_saved_boldmetrics",
                                    false
                                );
                            }
                            resolve(payload);
                        },
                        error: function (error) {
                            console.error(error);
                            reject(error);
                        },
                    });
                });
            },
            // Arn 10/06/2022
            saveAllChangedMeasurements_V2_Handle: async function (
                update_type = "unknown"
            ) {
                let _this = this;
                _this.$set(_this.flags, "saving", true);
                _this
                    .saveAllChangedMeasurements_V2(update_type)
                    .then((data) => {
                        if (data.success === true) {
                            setTimeout(() => {
                                _this.savePreference();
                            }, DT3oConstant.TIMEOUT_POST_METAFIELD);
                            setTimeout(() => {
                                _this.saveLastDateTheDigitalTailor();
                            }, DT3oConstant.TIMEOUT_POST_METAFIELD * 2);
                            setTimeout(() => {
                                _this.editTestPage();
                            }, DT3oConstant.TIMEOUT_POST_METAFIELD * 3);
                            if (typeof updateCreateYourSizeWhenSaved_Arn === "function") {
                                // update product page
                                updateCreateYourSizeWhenSaved_Arn();
                            }
                            if (typeof Arn_SetArnLoadedMetafieldsValue === "function") {
                                Arn_SetArnLoadedMetafieldsValue(true, false, true); // not update Self Measure = false
                            }
                            _this.$set(_this.flags, "savedChangedInputs", true);
                            setTimeout(() => {
                                if (
                                    _this.flags.customModalType ===
                                    "pleaseWaitForComplete"
                                ) {
                                    _this.closeModalAll();
                                }
                                _this.showSaveResultSuccessModal();
                                _this.$set(
                                    _this.flags,
                                    "customModalType",
                                    "confirmExitOrSaveData"
                                );
                            }, DT3oConstant.TIMEOUT_POST_METAFIELD);
                        } else if (data.success === false) {
                            _this.$set(
                                _this.flags,
                                "customModalType",
                                "savedDataIsError"
                            );
                            DT3oTool.openModalCustomSizeExit();
                        }
                        if (data.noDataToSave) {
                            // _this.$set(_this.flags, 'customModalType', 'noDataToSave');
                            // DT3oTool.openModalCustomSizeExit();
                            _this.closeModalAll();
                        }
                        _this.$set(_this.flags, "saving", false);
                        sessionStorage.setItem("measurements_saved_boldmetrics", "true");
                    })
                    .catch((error) => {
                        _this.$set(_this.flags, "saving", false);
                        _this.closeGeneralModal();
                        _this.$set(_this.flags, "customModalType", "savedDataIsError");
                        DT3oTool.openModalCustomSizeExit();
                    });
            },
            // Nguyen update 23/07/2025
            saveCustomerNote: function () {
                sessionStorage.setItem(DT3oConstant.SESSION_CUSTOMER_NOTE,
                    this.fitProfileDetails.customer_note
                );
            },
            // loadselectedFitProfile to finalValues
            loadSelectedFitProfileToFinalValues: function ({ fitProfile }) {
                try {

                    if (!fitProfile) {
                        console.log("===** Error load fit profile: not valid fit profile");
                        return false;
                    }
                    let _this = this;
                    const { dt_sm_input, garment_inputs, info = {} } = fitProfile;
                    // Basic, SM inputs
                    Object.keys(dt_sm_input).forEach((key) => {
                        if (key === 'jacket_size_srl') return; // handle in key "jacket_size"
                        _this.finalValues[key] = dt_sm_input[key];

                        if (key === 'jacket_size') {
                            let jacketSize = dt_sm_input['jacket_size'].split(/[a-zA-Z]/)[0];
                            _this.finalValues[key] = jacketSize;
                            _this.finalValues['jacket_size_srl'] = dt_sm_input['jacket_size'].split(jacketSize)[1];
                        }
                        // for height we have some special values, default value is in inch
                        if (key == "height") {
                            _this.setValueOfHeight({
                                value: dt_sm_input[key],
                                isInches: true,
                            }); // inch
                            // _this.setValueOfHeight({ value: heightVal, isCm: true }); // cm
                        }
                    });
                    // MG Inputs
                    Object.keys(_this.mgAllProductTypesInputsArr).forEach(
                        (productTypeKey) => {
                            _this.finalValues[productTypeKey] =
                                garment_inputs[productTypeKey] || {};
                        }
                    );
                    // Info
                    info &&
                        Object.keys(info).forEach((infoKey) => {
                            _this.finalValues[infoKey] = info[infoKey];
                        });
                    // Basic Info ex name, id
                    DT3oConstant.LIST.basicInfoProfile.forEach((key) => {
                        _this.finalValues[key] = fitProfile[key];
                    });
                } catch (error) {
                    console.log("** Error loadSelectedFitProfileToFinalValues", error);
                }
            },
            // load reconfirm data to finalValues
            loadReconfirmDataToFinalValues: function ({ reconfirmData }) {
                // Modify key because data return from OMA is type "jacketInputs, pantsInputs, etc"
                const mgTypeKeys = [];
                Object.keys(this.mgAllProductTypesInputsArr).map((key) => {
                    mgTypeKeys.push(key + "Inputs");
                });

                const { coreInputs, selfInputs } = reconfirmData;
                // Core inputs
                Object.keys(coreInputs).map((key) => {
                    if (coreInputs[key].reconfirm) {
                        const value = coreInputs[key] && coreInputs[key].value ? coreInputs[key].value : '';
                        this.storeReconfirmKeyByAppType('dt', key);
                        this.finalValues[key] = value;

                        if (this.lastChoices[key]) {
                            this.lastChoices[key][this.selectedUnit] = value;
                        }
                    }
                });
                // Self inputs
                Object.keys(selfInputs).map((key) => {
                    if (selfInputs[key].reconfirm) {
                        const value = selfInputs[key] && selfInputs[key].value ? selfInputs[key].value : '';
                        this.storeReconfirmKeyByAppType('sm', key);
                        this.finalValues[key] = value;

                        if (this.lastChoices[key]) {
                            this.lastChoices[key][this.selectedUnit] = value;
                        }
                    }
                });

                // // MG inputs
                Object.keys(reconfirmData).map((key) => {
                    if (mgTypeKeys.includes(key)) {
                        const mgKey = key.replace('Inputs', '');
                        Object.keys(reconfirmData[key]).map((_key) => {
                            if (reconfirmData[key][_key].reconfirm) {
                                const value = reconfirmData[key][_key] && reconfirmData[key][_key].value ? reconfirmData[key][_key].value : '';

                                this.storeReconfirmKeyByAppType('mg', _key, mgKey);
                                if (!this.finalValues[mgKey]) {
                                    this.finalValues[mgKey] = {};
                                }
                                this.finalValues[mgKey][_key] = value;
                                // Ensure all nested properties exist before assigning
                                if (this.lastChoices[mgKey] && this.lastChoices[mgKey][_key] && this.lastChoices[mgKey][_key][this.selectedUnit] !== undefined) {
                                    this.lastChoices[mgKey][_key][this.selectedUnit] = value;
                                }
                            }
                        });
                    }
                });

                // this.addInputsToSelfMeasures();
                // this.addInputsToMeasureGarment();
                this.setValueOfHeight({ value: this.finalValues.height, isCm: true });
                this.setValueOfHeight({ value: this.finalValues.height, isInches: true });
                this.updateKeyofBigPagesRC();
                // this.changeUnit_V3_Caller(this.selectedUnit);
            },
            introStep: function () {
                return {
                    setStepActive: (step, preventChangeStepActive = false) => {
                        // this.introPreviousStepActive = this.introStepActive;
                        this.introStepActive = step;
                        this.introStepActivePreventChange = preventChangeStepActive;
                    },
                    setTabActive: (tab) => {
                        this.introStepTabs.selected = tab;
                    },
                    initStepActive: () => {
                        let progress = DT3oTool.getTrackProgress();
                        this.checkFitProfileHasImage();

                        if (!progress) {
                            // Nguyen updated 26/06/2025 - fix reopen DT after create new FP not open the listing FP intro
                            // this.introStepActive = this.customer.loggedIn ? "intro_loggedin" : "intro_guest";
                            return;
                        }
                        let { typeApp } = progress;

                        if (this.customer.loggedIn) {
                            this.introStepActive = this.customer.loggedIn
                                ? this.showAddonIntroAccount ? "ca-fit-profile" : "intro_incomplete_loggedin"
                                : "intro_incomplete_guest";
                        } else if (
                            this.customer.loggedIn &&
                            DT3oTool.getFitProfiles()?.length > 0
                        ) {
                            this.introStepActive = "intro_loggedin";
                        } else if (
                            !this.customer.loggedIn &&
                            this.checkIsLocalCompleteProfile()
                        ) {
                            this.introStepActive = "intro_complete_guest";
                        } else if (
                            !this.customer.loggedIn &&
                            this.checkIsPartialProfile()
                        ) {
                            this.introStepActive = "intro_incomplete_guest";
                        } else {
                            this.introStepActive =
                                typeApp === "dt"
                                    ? "intro_dt"
                                    : typeApp === "sm"
                                    ? "intro_sm"
                                    : "intro_mg";
                        }
                    },
                };
            },
            fitProfileStep: function () {
                return {
                    setTabActive: (newTab, typeApp) => {
                        console.log("** setTabActive", newTab, typeApp);

                        let isDirect = false;
                        let initInputs = false;
                        this.fitProfileTabs.selected = newTab;
                        this.typeApp = typeApp;
                        this.updateFinalValuesToLastChoices();
                        this.doWhenChangeMainApp(typeApp, isDirect, initInputs);
                        // set mg inputs for default
                        if (newTab === "garment-measure") {
                            this.setTypeMGInFitProfileDetails(
                                this.currentMGProductTypeProfileDetail
                            );
                        }
                    },
                    updateProfile: ({ parentKey = "", fieldName = "", value }) => {
                        switch (parentKey) {
                            case "name":
                                this.fitProfileDetails[parentKey] = value;
                                break;
                            case "info":
                                this.fitProfileDetails[parentKey][fieldName] = value;
                                break;
                            default:
                                break;
                        }
                        DT3oTool.updateFitProfileToLocal_Caller({
                            fitProfile: JSON.parse(
                                JSON.stringify(this.fitProfileDetails)
                            ),
                            idProfile: this.fitProfileDetails.id,
                            typeTab: "info",
                            typeApp: DT3oConstant.TYPE_APP.EDIT_FIT_MODAL,
                        });
                    },
                    updateProfileLoggedIn: ({ parentKey = "", fieldName = "", value }) => {
                        DT3oTool.updateFitProfileToServer_Caller({
                            fitProfile: JSON.parse(
                                JSON.stringify(this.fitProfileDetails)
                            ),
                            idProfile: this.fitProfileDetails.id,
                            typeTab: "info",
                            typeApp: DT3oConstant.TYPE_APP.EDIT_FIT_MODAL,
                        });
                    },
                };
            },
            checkHandlerToContinuePartialProfile: function () {
                this.flags.fromStep = "intro";
                switch (this.introStepActive) {
                    case "intro_incomplete_guest":
                        this.continuePartialProfile();
                        this.goToCurrentProgressStep();
                        break;
                    case "intro_guest":
                        this.goToFitProfileDetails();
                        break;
                }
            },
            //
            handleViewExistingProfile() {
                let isLoggedIn = DT3oState.CUSTOMER_IS_LOGGED_IN;
                let selectedFitProfileId = isLoggedIn ? DT3oTool.getFitProfileId() : DT3oTool.getFitProfileIdLocal();
                if (selectedFitProfileId) {
                    this.goToFitProfileDetails(selectedFitProfileId);
                    // if (isLoggedIn) {
                    //     DT3oTool.setFitProfileId({ id: selectedFitProfileId, openEditFitProfile: true, typeApp: 'edit-fit-profile-modal', callUpdateFitProfileCartItems: false });
                    // } else {
                    //     DT3oTool.setFitProfileIdLocal({ id: selectedFitProfileId, openEditFitProfile: true, typeApp: 'edit-fit-profile-modal', callUpdateFitProfileCartItems: false });
                    // }
                    // this.currentBigPages = "fit_profile_details";
                }
            },
            goToCurrentProgressStep() {
                let progress = DT3oTool.getTrackProgress();
                if (progress) {
                    let {
                        typeApp,
                        currentStep,
                        lastStepProfileInput,
                        currentInput,
                        previousStep = "",
                        currentSMBodyType,
                        currentMGProductType,
                    } = progress;
                    let isProfileInput = this.checkIsProfileInput(currentStep);
                    // console.log("=== typeApp", this.typeApp, typeApp, currentStep);
                    if (!currentStep) {
                        console.log(
                            "** Error goToCurrentProgressStep: NotValidCurrentStep"
                        );
                    }
                    // if
                    if (
                        !this.checkThisPageInBigPages(
                            this.getBigPages(typeApp),
                            currentStep
                        )
                    ) {
                        console.log(
                            "=== Error not has this page in the big pages of this app."
                        );
                        return false;
                    }
                    // if (this.typeApp !== typeApp && typeApp) {
                    //     this.changeMainApp(typeApp)
                    // }
                    this.changeMainApp(typeApp, false);

                    // this.flags.fromStep = previousStep;
                    this.flags.fromStep = "";
                    if (typeApp === "sm") {
                        this.selectSMBodyType(currentSMBodyType);
                        let inputsBodyTypeKeys =
                            this.getSortedInputsSMBodyTypeKeys(currentSMBodyType);
                        if (
                            currentInput &&
                            inputsBodyTypeKeys.includes(currentInput.metafieldKey)
                        ) {
                            this.currentInputSM = currentInput;
                        }
                    } else if (typeApp === "mg") {
                        this.selectMGProductType(currentMGProductType);
                        let inputsProductTypeKeys =
                            this.getSortedInputsMGProductTypeKeys(currentMGProductType);
                        if (
                            currentInput &&
                            inputsProductTypeKeys.includes(currentInput.metafieldKey)
                        ) {
                            this.currentInputMG = currentInput;
                        }
                    }
                    this.goToPageAndInput(
                        currentStep === "intro" && previousStep
                            ? previousStep
                            : currentStep
                    );
                }
            },
            goToFitProfileDetails(fitProfileId) {
                // console.log("===== goToFitProfileDetails::");

                let fitProfile = null;
                if (fitProfileId) {
                    if (DT3oState.CUSTOMER_IS_LOGGED_IN) {
                        fitProfile = DT3oTool.getFitProfileById(fitProfileId);
                    } else {
                        fitProfile = DT3oTool.getFitProfileByIdLocal(fitProfileId);
                    }
                } else {
                    const profiles = DT3oTool.getFitProfilesLocal();
                    fitProfile = profiles && profiles.length > 0 ? profiles[0] : profiles;
                }

                this.currentBigPages = "fit_profile_details";
                let _fitProfile = JSON.parse(JSON.stringify(fitProfile));

                this.setFitProfileDetails({ fitProfile: _fitProfile });
                this.loadSelectedFitProfileToFinalValues({ fitProfile: _fitProfile });
            },
            setFitProfileDetails({ fitProfile }) {
                this.fitProfileDetails = { ...this.fitProfileDetails, ...fitProfile };
            },
            // 05/08/25 click Fit Profile Photos at
            clickFitProfilePhotosInFitProfileDetails() {
                this.changeStepActivePhotoIntro = false;
                this.changeMainApp("dt");
                this.introStep().setStepActive("photo_requirement", true); // has true
                this.goToPageAndInput("profile_creation");
            },
            // check fit profile has image (not need 3 images)
            checkFitProfileHasImage() {
                let hasProfile = this.fitProfileDetails && this.fitProfileDetails.id;
                if (this.customer.loggedIn) {
                    this.fitProfileHasImage =
                        hasProfile &&
                        this.fitProfileDetails.images &&
                        this.fitProfileDetails.images.length === 3;

                    return this.fitProfileHasImage;
                } else if (hasProfile) {
                    DT3oTool.getPhotosFromIndexedDB(this.fitProfileDetails.id).then(
                        (resp) => {
                            const photos = resp.msg || [];
                            this.fitProfileHasImage = photos.length > 0;
                            return this.fitProfileHasImage;
                        }
                    );
                    console.log("-----");
                    return false;
                } else {
                    this.fitProfileHasImage = false;
                    return false;
                }
            },
            // check show step in reconfirm
            isSkipInReconfirm(stepInPage, appType) {
                if (!this.isTypeAppReconfirm || !SARTORO_APP_SM_RECONFIRM) return false;
                if (appType === 'mg') return this.isSkipRCForMg(stepInPage);
                const stepMappings = {'pants_waist': 'waist_size' };
                let step = stepMappings[stepInPage] || stepInPage;

                return this.isSkipForDtSm(step, appType);
            },
            //
            isSkipRCForMg(step) {
                const mgConfig = SARTORO_APP_SM_RECONFIRM['mg'];
                if (!mgConfig) return false;
                const mgConfigGarment = mgConfig[this.currentMGProductType];
                return mgConfigGarment && !mgConfigGarment.includes(step);
            },
            //
            isSkipForDtSm(step, appType) {
                const appConfig = SARTORO_APP_SM_RECONFIRM[appType];
                return appConfig && !appConfig.includes(step);
            },
            //
            updateKeyofBigPagesRC(appType = 'dt') {
                if (!SARTORO_APP_SM_RECONFIRM) return;
                let isSkip = false;
                if (appType === 'dt') {
                    Object.keys(this.bigPages).map(bigPage => {
                        switch (bigPage) {
                            case "body_size_detail":
                            case "pants_size":
                            case "jacket_size":
                            case "shirt_size":

                                if (this.bigPages[bigPage].steps.length > 0) {
                                    this.bigPages[bigPage].steps.map(step => {
                                        isSkip = false;
                                        isSkip = this.isSkipInReconfirm(step, 'dt');
                                        if (isSkip) {
                                            // also skip bigpage posture_jacket_length_preferred when step is jacket_size
                                            if (step === 'jacket_size') {
                                                this.keysOfBigPages = this.keysOfBigPages.filter(key => key !== 'posture_jacket_length_preferred');
                                            }
                                            this.keysOfBigPages = this.keysOfBigPages.filter(key => key !== step);
                                        }
                                    });
                                }
                                break;
                        }
                    });
                }
            },
            // RC check have request to measure a garment type
            showGarmentType(type) {
                if (!this.isTypeAppReconfirm) return true;
                if (!SARTORO_APP_SM_RECONFIRM || !SARTORO_APP_SM_RECONFIRM.mg) return true;

                return SARTORO_APP_SM_RECONFIRM.mg[type] && SARTORO_APP_SM_RECONFIRM.mg[type].length > 0;
            },
            // Send reconfirm data to server
            sendRCDataToServer() {
                const reconfirmResponse = this.convertRCInputsByFinalValues();
                this.sendRCDataToServer_Helper(reconfirmResponse);
            },
            convertRCInputsByFinalValues() {
                const responseRC = SARTORO_APP_SM_RECONFIRM.reconfirmResponse;
                if (!responseRC?.reconfirmRequest) return null;

                const requestRC = responseRC.reconfirmRequest;
                const mgTypeKeys = Object.keys(this.mgAllProductTypesInputsArr)
                    .map(key => `${key}Inputs`);

                Object.entries(requestRC)
                    .filter(([key]) => key.includes('Inputs'))
                    .forEach(([key]) => {
                        const finalKey = key.replace('Inputs', '');

                        if (mgTypeKeys.includes(key)) {
                            // Handle MG type inputs
                            Object.entries(this.finalValues[finalKey] || {})
                                .forEach(([type, value]) => {
                                    const reqType = requestRC[key][type];
                                    if (reqType?.reconfirm && value) {
                                        reqType.value = value;
                                    }
                                });
                        } else {
                            // Handle other inputs
                            Object.entries(requestRC[key])
                                .forEach(([type, reqType]) => {
                                    if (reqType?.reconfirm && this.finalValues[type]) {
                                        reqType.value = this.finalValues[type];
                                    }
                                });
                        }
                    });

                responseRC.reconfirmRequest = requestRC;
                return responseRC;
            },
            //
            async sendRCDataToServer_Helper(reconfirmResponse) {
                try {
                    let bodyData = {
                        dataInfo: {
                            orderId: reconfirmResponse.orderInfo.id,
                            reconfirmResponse: reconfirmResponse,
                            userName: reconfirmResponse.customerInfo.email
                        },
                    };
                    console.log('** DT3oState.AppDT', DT3oState);
                    console.log('** bodyData', bodyData);
                    setTimeout(() => {
                        this.introStep().setStepActive("reconfirm-complete-wrapper");
                    }, 100);
                    return;
                    let response = await fetch(
                        `${DT3oConstant.OMA_APP_URL}/app/response-reconfirm-order`,
                        {
                            headers: {
                                "Content-Type": "application/json",
                            },
                            method: "POST",
                            body: JSON.stringify(bodyData),
                        }
                    );
                    console.log('** response', response);

                    if (!response.ok) throw new Error(`Error: ${response.status}`);

                    let updateRes = await response.json();
                    console.log('** updateRes', updateRes);

                    if (updateRes.success) {
                        console.log('** updateRes success');
                        setTimeout(() => {
                            this.introStep().setStepActive("reconfirm-complete-wrapper");
                        }, 100);
                    } else {
                        console.log('** updateRes error');
                        setTimeout(() => {
                            this.introStep().setStepActive("final-notes-wrapper");
                        }, 100);
                    }
                } catch (error) {
                    console.log('** error sendRCDataToServer_Helper', error);
                }

            },
            //checkSkipWaitingResultRC
            checkSkipWaitingResultRC(e, type) {
                if (!['height', 'weight'].includes(type)) return;
                this.skipWaitingResult = false;
                this.originalHeightRC = this.originalHeightRC || e.target.dataset.rcValue;
                this.originalWeighttRC = this.originalWeighttRC || e.target.dataset.rcValue;

                if (type === 'height') {
                    if (e.target.value === this.originalHeightRC) {
                        this.skipWaitingResult = true;
                    }
                }
                if (type === 'weight') {
                    if (e.target.value === this.originalWeighttRC) {
                        this.skipWaitingResult = true;
                    }
                }
            },
            //
            showUnit_V3(key, us, eu, uk, aus) {
                let unit = this.units.selected.toLowerCase();
                switch (this.units.selected.toLowerCase()) {
                    case 'us':
                        return us;
                    case 'eu':
                    case 'metric':
                        return eu === 'metric' ? 'EU' : eu;
                    case 'uk':
                        return uk;
                    case 'aus':
                        return aus;
                }
                return unit;
            },

        },
        // ======= end methods
        filters: {
            resize: function (src, size) {
                var resized = src || "";
                resized = resized.replace(".png", `_${size}.png`);
                resized = resized.replace(".jpg", `_${size}.jpg`);
                return resized;
            },
            handle: function (value) {
                return value.toLowerCase().replace(" ", "-");
            },
            unhandle: function (value) {
                return value.replace("-", " ");
            },
            upperCase: function (value) {
                return value.toUpperCase();
            },
            ft_only: function (value) {
                if (typeof value === "string") {
                    return value.split(".")[0] + "'";
                } else {
                    return value;
                }
            },
            in_only: function (value) {
                if (typeof value === "string") {
                    return value.split(".")[1] + '"';
                } else {
                    return value;
                }
            },
        },
        // ======= end filters
    });
    // End app Vue
    // Assign app to state
    if (DT3oState) DT3oState.AppDT = app;
    // VueJS Error Handler
    if (Vue) {
        Vue.config.errorHandler = function(err = '', vm = '', info = '') {
            console.log('** VueJS Error', err);
            console.log('** VueJS VM', vm);
            console.log('** VueJS Info', info);
        }
        Vue.config.warnHandler = function(msg = '', vm = '', trace = '') {
            console.log('** VueJS Warning', msg, vm, trace);
        };
    }

}
// Create Vue App For Measurement Tab In Account Page, 03/16/2023 -> Nguyen update 08/07/2025
function initMeasurementTabInAccountPageApp() {
    var MeasurementTabInAccountPageApp = new Vue({
        el: '#CA-fit-profiles-block',
        data: {
            Vue_App_State: DT3oState ? DT3oState : {},
        },
    });
}

function removeLoader() {
    const loader = document.querySelector('.jsLoader');

    if (loader) {
        loader.style.transition = 'opacity 0.3s';
        loader.style.opacity = '0';
        setTimeout(() => {
            loader.style.display = 'none';
        }, 300);
    }
}

// Tab Account Measurments, Reconfirm Page
window.addEventListener('load', () => {
    const isAccountFitProfilesPage = window.location.href.match(/\/pages\/customer-account-fit-profiles\?show=account/gi);
    const isReconfirmOrdersPage = window.location.href.match(/\/reconfirm-orders/gi);

    if (isAccountFitProfilesPage) {
        try {
            let maxAttempts = 12; // 1 minute total (12 * 5000ms)
            let attempts = 0;

            const checkAccountsHub = () => {
                const accountsHub = document.querySelector('accounts-hub.ready');
                if (accountsHub) {
                    initMeasurementTabInAccountPageApp();
                    DT3oTool.showContentOfOneFitProfileModal_Caller();
                    removeLoader();
                    observer.disconnect();

                    return;
                }

                attempts++;
                if (attempts < maxAttempts) {
                    setTimeout(checkAccountsHub, 5000);
                } else {
                    observer.disconnect();
                    console.warn('Accounts hub not found after 1 minute');
                }
            };

            const observer = new MutationObserver(checkAccountsHub);
            checkAccountsHub();
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });

            setTimeout(() => observer.disconnect(), 1000);
        } catch (error) {
            console.error('Error initializing account fit profiles:', error);
        }
    }

    if (isReconfirmOrdersPage) {
        try {
            if (DT3oState.AppDT) {
                DT3oState.AppDT.changeMainApp('sm-reconfirm');
                DT3oState.AppDT.flags.showIntroWithAnimation = true;
            }
        } catch (error) {
            console.error('Error handling reconfirm orders:', error);
        }
    }
});
async function initSartoroMeasureApp() {
    setTimeout(initBoldMetricsApp, 500);
    setTimeout(function() {
        DT3oTool.init();
    }, 800);
}

if (jQuery) {
    initSartoroMeasureApp();
} else {
    window.addEventListener("load", function(event) {
        initSartoroMeasureApp();
    });
}